import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Paper,
  Typography,
  TextField,
  Stack,
  Tab,
  Box,
  IconButton,
  Popover,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  InputAdornment,
  Tooltip,
  tooltipClasses,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { GoogleMaterialIcon } from '../ui/GoogleMaterialIcon';
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { styled, alpha } from "@mui/material/styles";
import _ from "lodash";
import { capitalizeLeadingText } from "../../utils/textFormat";
import { Dialog } from "primereact/dialog";
import CustomDialog from "../common/CustomDialog";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import DataTableBase from "../common/DataTableBase";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator, FilterService } from "primereact/api";
import ClientFilingMasterContext from "../../context/client-filing-master/ClientFilingMasterContext";
import CustomerContext from "../../context/customer/CustomerContext";
import AuthContext from "../../context/auth/AuthContext";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import { DateTime } from "luxon";
import axios from "axios";
import { TabPanel, TabList, TabContext } from "@mui/lab";
import usePermission from "../../usePermission";
import { Button as PrimeButton } from "primereact/button";
import { ScrollPanel } from "primereact/scrollpanel";
import { OverlayPanel } from "primereact/overlaypanel";
import states from "../../data/StateLookup.json";
import { InputSwitch } from "primereact/inputswitch";
import { log } from "util";
import { tokens } from "../../theme/tokens";
import ClientTableFilter from "../customer/ClientTableFilter";
import { useResponsive } from "../hooks/useResponsive";
import { useCommonDetailsContext } from "../../context/Common/common";
import { TrackNowButton } from "../ui";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const statusLookup = ["Pending", "In Progress", "Approved", "Completed"];
const jurisdictionLookup = ["State", "Federal"];
const yearsOption = [
  { value: "", label: "None" },
  {
    value: "Before End of Current Month",
    label: "Before End of Current Month",
  },
  { value: "Within a Month", label: "Within a Month" },
  { value: "Within 3 Months", label: "Within 3 Months" },
  { value: "Within 6 Months", label: "Within 6 Months" },
  { value: "Before End of Current Year", label: "Before End of Current Year" },
];
const OverlayListContent = ({ title, filingName, list, emptyMessage }) => (
  <>
    <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 700 }}>{title}</Typography>
    {filingName && (
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700, overflowWrap: "anywhere" }}>
        {filingName}
      </Typography>
    )}
    <div className="tracker-overlay-scroll overlay-scroll-consistent" style={{ width: "100%", maxWidth: "100%", maxHeight: "10.5rem", overflowY: "auto", overflowX: "hidden", paddingRight: "0.25rem", boxSizing: "border-box" }}>
      {list.length === 0 ? (
        <Typography variant="body2" sx={{ color: "#888" }}>{emptyMessage}</Typography>
      ) : (
        <ul style={{ paddingLeft: "20px", margin: 0 }}>
          {list.map((name, idx) => (
            <li key={`${name}-${idx}`} style={{ marginBottom: "4px", overflowWrap: "anywhere" }}>{name}</li>
          ))}
        </ul>
      )}
    </div>
  </>
);

const ClientFilingTrackerTable = forwardRef((props, ref) => {
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;
  const EditPencilIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill={primaryColor}>
      <path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" />
    </svg>
  );
  const { isMobile } = useResponsive()

  const enableForzen = !isMobile
  useImperativeHandle(ref, () => ({
    refreshPage() {
      const vScroll =
        value === "1"
          ? sortRecord === "Clear"
            ? dtUpcoming.current.getVirtualScroller()
            : dt.current.getVirtualScroller()
          : dtHistory.current.getVirtualScroller();

      let range = vScroll.getRenderedRange();
      console.log("refreshPage vScroll", vScroll, range);

      let refreshPage = {};
      if (value === "1") {
        let pageInView;
        let noOfPages;
        if (clientFiling.length > 100) {
          pageInView = recordsInView - 2;
          noOfPages = 2;
        } else {
          pageInView = recordsInView - 1;
          noOfPages = 1;
        }
        let clientSelected = selectedClientFiling;
        console.log(
          "refreshPage clientSelected",
          pageInView,
          noOfPages,
          clientSelected
        );

        refreshPage.recordsInView = pageInView;
        refreshPage.refreshDetails = {
          viewport: range.viewport,
          pageInView,
          noOfPages,
          clientSelected,
        };
      } else {
        let pageInView;
        let noOfPages;
        if (clientFilingHistory.length > 100) {
          pageInView = recordsInView - 2;
          noOfPages = 2;
        } else {
          pageInView = recordsInView - 1;
          noOfPages = 1;
        }
        let clientSelected = selectedClientFiling;
        console.log(
          "refreshPage clientSelected",
          pageInView,
          noOfPages,
          clientSelected
        );

        refreshPage.recordsInView = pageInView;
        refreshPage.refreshDetails = {
          viewport: range.viewport,
          pageInView,
          noOfPages,
          clientSelected,
        };
      }
      console.log("refreshPageDetails refreshPage", refreshPage);
      setRefreshPageDetails(refreshPage);
      props.resetKeepPageDetails(false);
      return refreshPage;
    },
  }));

  const {
    displayComments,
    displayAttachments,
    // downloadData,
    displayDocuments,
    handleRefreshTableReturn,
    refreshTable,
    // downloadDataHistory,
  } = props;

  let { clientId } = useParams();
  const authContext = useContext(AuthContext);
  const { authUser, userRoles } = authContext;
  const [staffAssignedList, setstaffAssignedList] = useState([]);
  const [_clientId, setClientId] = useState(clientId);
  const [recordTypeVal, setRecordTypeVal] = useState("");
  const [isRecordTypeChange, setIsRecordTypeChange] = useState(false);
  const [detailedViewVal, setDetailedViewVal] = useState(false);
  const [trackNowVal, setTrackNowVal] = useState(false);
  const [trackNowValUpc, setTrackNowValUpc] = useState(false);
  const [postAwardVal, setPostAwardVal] = useState(false);
  const [postAwardValUpc, setPostAwardValUpc] = useState(false);
  const [showAffectedCompanies, setShowAffectedCompanies] = useState(false);
  const [showStaffAssigned, setShowStaffAssigned] = useState(false);
  const [affectedCompaniesDetails, setAffectedCompaniesDetails] = useState({
    recordName: "",
    list: [],
  });
  const [staffAssignedDetails, setStaffAssignedDetails] = useState({
    recordName: "",
    list: [],
  });
  const [checkboxdisabled, setCheckBoxDisabled] = useState(true);
  const [checkboxdisabledTrackNow, setcheckboxdisabledTrackNow] =
    useState(false);
  const [checkboxdisabledPostAward, setcheckboxdisabledPostAward] =
    useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [awardTypeList, setAwardTypeList] = useState([]);
  const [awardAgenciesList, setAwadAgenciesList] = useState([]);
  const [checkboxdisabledTrackNowUpc, setcheckboxdisabledTrackNowUpc] =
    useState(true);
  const [checkboxdisabledPostAwardUpc, setcheckboxdisabledPostAwardUpc] =
    useState(true);
  const [editingRow, setEditingRow] = useState(null);
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const {
    setClientFilingTrackers,
    setClientFilingTrackersHistory,
    getClientFilingTrackers,
    ClientFilingTrackers,
    ClientFilingTrackersHistory,
    ClientFilingMasterLoaded,
    clearClientFilingTrackers,
    fetchConfigurations,
    refreshPageDetails,
    setRefreshPageDetails,
  } = clientFilingMasterContext;
  const filingMasterContext = useContext(FilingMasterContext);
  const { getBusinessCategories, getProgramName } = filingMasterContext;

  // const [selectedValues, setSelectedValues] = useState(value || []); // State to store selected checkbox values
  const customerContext = useContext(CustomerContext);
  const { selectedCustomer, setCurrentCustomer } = customerContext;
  const isDetailedViewAvailable = Boolean(
    selectedCustomer &&
    selectedCustomer?.clientType !== "SubChild" &&
    !selectedCustomer?.isOnlyParentFile &&
    (selectedCustomer?.bothChildAndSubChild || selectedCustomer?.bothParentAndChild)
  );
  const [value, setValue] = React.useState("1");
  const [isDisabled, setIsDisabled] = useState(false);
  const [yearsList, setYearsList] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [masterCatFilter, setMasterCatFilter] = useState([]);
  const [postawardagencyArray, setPostAwardAgencyArray] = useState([]);
  const [postawardtypeArray, setPostAwardTypeArray] = useState([]);
  const [sortRecord, setSortRecord] = useState("Upcoming Due Dates");
  const [sortMaster, setSortMaster] = useState([]);
  const [isClearIcon, setIsClearIcon] = useState(false);
  const [isChildIncludes, setIsChildIncludes] = useState(false);
  const [isStatusColumnChange, setIsStatusColumnChange] = useState(false);
  const [isStatusChangeOk, setIsStatusChangeOk] = useState(false);
  const [isDenied, setIsDenied] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [initialOptions, setInitialOptions] = useState();
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);

  // const data = customers;
  // const [visibleApps, setVisibleApps] = useState(props.projects);
  // const [showFilter, setShowFilter] = useState(false);
  const [selectedClientFiling, setSelectedClientFiling] = useState([]);
  const [selectedFilingRecord, setSelectedFilingRecord] = useState(null);
  const [upcomingCatFilter, setUpcomingCatFilter] = useState([]);
  const [age, setAge] = React.useState("");
  // const [filteredStateCategories, setFilteredStateCategories] = useState([]);
  // const [filteredFederalCategories, setFilteredFederalCategories] = useState(
  //   []
  // );

  // const [selectedClient, setSelectedClient] = useState(null);
  // const [rowClick, setRowClick] = useState(true);

  const [data, setData] = useState([]);
  const [jurisdiction, setJurisdiction] = useState([]);
  const [options, setOptions] = React.useState("");

  const [lazyLoading, setLazyLoading] = useState(false);
  const [refreshRecordList, setRefreshRecordList] = useState(false);
  const [refreshDetails, setRefreshDetails] = useState(null);
  const [recordsInView, setRecordsInView] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFilterChange, setIsFilterChange] = useState([]);
  const [sortingData, setSortingData] = useState({
    sortBy: "",
    sortOrder: "",
  });
  const [upcomingDueDateVal, setupcomingDueDateVal] = useState("");
  const [rowEditPendingValues, setRowEditPendingValues] = useState(null);
  const [openFilingDueDateInfo, setOpenFilingDueDateInfo] = useState(false);

  const getDefaultTrackerFilters = () => ({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //customerName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // filingId: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // filingDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // dueDate: { value: null, matchMode: FilterMatchMode.DATE_IS },
    filingName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    dueDateFiling: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    internalDueDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    filingFrequency: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    filingStateInfo: { value: null, matchMode: FilterMatchMode.CONTAINS },
    stateList: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    staffAssignedArray: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    staffassigned: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    customerName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    ruleInfo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // formattedAffectedCompany: {
    //   operator: FilterOperator.AND,
    //   constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    // },
    filingRequired: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    awardingAgencyName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    federalCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    stateCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    // jsidept: { value: null, matchMode: FilterMatchMode.CONTAINS },
    jsicontactName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // jsiContactEmail: { value: null, matchMode: FilterMatchMode.CONTAINS },
    filingJuristiction: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    status: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    GrantTermcomplete: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    whereToFile: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  });

  const [filters, setFilters] = useState(getDefaultTrackerFilters);

  const [federalFilterSelectedValues, setFederalFilterSelectedValues] =
    React.useState({
      federalCategories: [],
    });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [viewAll, setViewAll] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [infoMessage, setInfoMessage] = useState("");
  const [grantTermConfrimation, setGrantTermConfrimation] = useState(false);
  const [grantTermVal, setGrantTermVal] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [federalCategoriesLookup, setFederalCategoriesLookup] = useState([]);
  // const [stateCategoriesLookup, setStateCategoriesLookup] = useState([]);
  // const [categoriesLookup, setCategoriesLookup] = useState([]);
  const [federalCatFilter, setFederalCatFilter] = useState([]);
  const [stateCatFilter, setStateCatFilter] = useState([]);

  const [dateFilter, setDateFilter] = useState(null);
  FilterService.register("customFilter_not", (item, filterBy) => {
    return item !== undefined && !item?.includes(filterBy);
  });
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    //let _filters = { ...filters };

    // _filters["global"].value = value;
    // setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const search = useRef(null);
  const overlayRefs = useRef({});

  // const applyGlobalFilter = () => {
  //   console.log("REF CHECK", search);
  //   let _filters = { ...filters };
  //   _filters["global"].value = search.current.value;
  //   setFilters(_filters);
  // };

  // const applyGlobalFilter = () => {
  //   let searchVal;
  //   console.log("ICON CHECK ENT", "SEARCH", search, "searchVal", searchVal);
  //   console.log();
  //   if (isClearIcon) {
  //     search.current = null
  //     console.log("ICON CHECK TRUE", "SEARCH", search, "SEARCH", search.current, "val",);
  //     searchVal = null
  //     setIsClearIcon(false)
  //   } else {
  //     searchVal = search.current.value
  //     setIsClearIcon(true)
  //     console.log("ICON CHECK FALSE", "SEARCH", search, "searchVal", searchVal);
  //   }
  //   console.log("ICON CHECK AFT", "SEARCH", search, "searchVal", searchVal);
  //   let _filters = { ...filters };
  //   _filters["global"].value = searchVal;
  //   setFilters(_filters);
  // };

  const applyGlobalFilter = () => {
    console.log("applyGlobalFilter", search.current.value, isClearIcon);
    let _filters = { ...filters };
    if (isClearIcon) {
      search.current.value = "";
      _filters["global"].value = "";
      setIsClearIcon(false);
      onFilterChange({ filters });
    } else {
      _filters["global"].value = search.current.value;
      setIsClearIcon(true);
      onFilterChange({ filters });
    }
    setFilters(_filters);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const getFilterChipLabel = (field) => {
    const labelMap = {
      filingName: "Filing Name",
      dueDateFiling: "Filing Due Date",
      filingFrequency: "Filing Frequency",
      stateList: "State",
      ruleInfo: "Rule Info",
      filingJuristiction: "Jurisdiction",
      filingRequired: "Required",
      status: "Status",
      federalCategories: "Who Must File Federal",
      stateCategories: "Who Must File in State",
      awardTypeName: "Award Type",
      awardingAgencyName: "Award Agency",
      staffAssignedArray: "Staff Assigned",
      whereToFile: "Where to File",
    };
    return labelMap[field] || field;
  };

  const getFilterChipValue = (value) =>
    Array.isArray(value) ? value.join(", ") : `${value ?? ""}`;

  const renderTrackerFilterChips = () =>
    activeFilters.length > 0 ? (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 1,
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
        }}
      >
        {activeFilters.map((filter) => (
          <div
            key={filter.field}
            style={{
              display: "inline-flex",
              alignItems: "center",
              backgroundColor: "#F1F2F6",
              border: "1px solid #ccc",
              borderRadius: "20px",
              padding: "6px 12px",
              fontSize: "13px",
              color: "#333",
              maxWidth: "100%",
            }}
          >
            <span>{`${filter.label}: ${filter.displayValue}`}</span>
            <button
              onClick={() => removeActiveFilterChip(filter.field)}
              style={{
                marginLeft: "6px",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#666",
                fontSize: "16px",
                padding: "0",
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              x
            </button>
          </div>
        ))}
      </Box>
    ) : null;

  const clearTrackerFilters = () => {
    setFilterAnchorEl(null);
    setActiveFilters([]);
    setIsFilterChange([]);
    setGlobalFilterValue("");
    setFilters(getDefaultTrackerFilters());
    setRecordsInView(0);
    setIsLoading(true);
    setClientFiling([]);
    setInitialValue([]);
    setClientFilingHistory([]);
    setInitialClientFilingHistory([]);
    props.setClientFilingData([]);
    setRefreshRecordList(true);
  };
  const resetFilters = () => {
    setFilterAnchorEl(null);
    setActiveFilters([]);
    setIsFilterChange([]);
    setGlobalFilterValue("");
    setFilters(getDefaultTrackerFilters());
  };

  const getTrackerApiFieldName = (field) => {
    if (field === "staffAssignedArray" || field === "staffassigned") {
      return "StaffAssigned";
    }

    return field.charAt(0).toUpperCase() + field.slice(1);
  };

  const buildTrackerApiFilters = (filterConfigs = []) => {
    let filterChange = [];

    filterConfigs.forEach((filterConfig) => {
      const { field, matchMode, value } = filterConfig;

      if (field === "stateList") {
        if (Array.isArray(value)) {
          value.forEach((ele, i) => {
            let changeItem = {
              name: "SearchByStateInfo",
              val: getStateCode(ele),
            };
            if (i + 1 === value.length) {
              changeItem.searchType = "StateInfoSearchType";
              changeItem.searchTypeVal = getSearchType(matchMode);
            }
            filterChange.push(changeItem);
          });
        } else {
          filterChange.push({
            name: "SearchByStateInfo",
            val: getStateCode(value),
            searchType: "StateInfoSearchType",
            searchTypeVal: getSearchType(matchMode),
          });
        }
      } else if (field === "filingJuristiction") {
        filterChange.push({
          name: "SearchByJuristiction",
          val: value,
        });
      } else if (field === "filingRequired") {
        filterChange.push({
          name: "SearchByRequired",
          val: value,
        });
      } else if (field === "awardTypeName") {
        if (Array.isArray(value)) {
          value.forEach((ele, i) => {
            let changeItem = {
              name: "SearchByAwardType",
              val: ele,
            };
            if (i + 1 === value.length) {
              changeItem.searchType = "AwardTypeSearchType";
              changeItem.searchTypeVal = getSearchType(matchMode);
            }
            filterChange.push(changeItem);
          });
        } else {
          filterChange.push({
            name: "SearchByAwardType",
            val: value,
            searchType: "AwardTypeSearchType",
            searchTypeVal: getSearchType(matchMode),
          });
        }
      } else if (field === "awardingAgencyName") {
        if (Array.isArray(value)) {
          value.forEach((ele, i) => {
            let changeItem = {
              name: "SearchByAwardAgency",
              val: ele,
            };
            if (i + 1 === value.length) {
              changeItem.searchType = "AwardAgencySearchType";
              changeItem.searchTypeVal = getSearchType(matchMode);
            }
            filterChange.push(changeItem);
          });
        } else {
          filterChange.push({
            name: "SearchByAwardAgency",
            val: value,
            searchType: "AwardAgencySearchType",
            searchTypeVal: getSearchType(matchMode),
          });
        }
      } else if (field === "federalCategories") {
        if (Array.isArray(value)) {
          value.forEach((ele, i) => {
            let changeItem = {
              name: "SearchByWhoMustFileFederal",
              val: ele,
            };
            if (i + 1 === value.length) {
              changeItem.searchType = "WhoMustFileFederalSearchType";
              changeItem.searchTypeVal = getSearchType(matchMode);
            }
            filterChange.push(changeItem);
          });
        }
      } else if (field === "stateCategories") {
        if (Array.isArray(value)) {
          value.forEach((ele, i) => {
            let changeItem = {
              name: "SearchByWhoMustFileInState",
              val: ele,
            };
            if (i + 1 === value.length) {
              changeItem.searchType = "WhoMustFileInStateSearchType";
              changeItem.searchTypeVal = getSearchType(matchMode);
            }
            filterChange.push(changeItem);
          });
        }
      } else if (field === "status") {
        if (Array.isArray(value)) {
          value.forEach((ele, i) => {
            let changeItem = {
              name: "SearchByStatus",
              val: ele,
            };
            if (i + 1 === value.length) {
              changeItem.searchType = "StatusSearchType";
              changeItem.searchTypeVal = getSearchType(matchMode);
            }
            filterChange.push(changeItem);
          });
        } else {
          filterChange.push({
            name: "SearchByStatus",
            val: value,
            searchType: "StatusSearchType",
            searchTypeVal: getSearchType(matchMode),
          });
        }
      } else if (field === "dueDateFiling") {
        filterChange.push({
          name: "SearchByFilingDueDate",
          val: value,
          searchType: "FilingDueDateSearchType",
          searchTypeVal: getSearchType(matchMode),
        });
      } else {
        const fieldName = getTrackerApiFieldName(field);
        filterChange.push({
          name: `SearchBy${fieldName}`,
          val: value,
          searchType: `${fieldName}SearchType`,
          searchTypeVal: getSearchType(matchMode),
        });
      }
    });

    return filterChange;
  };

  const removeActiveFilterChip = (field) => {
    const nextActiveFilters = activeFilters.filter(
      (filter) => filter.field !== field
    );
    setActiveFilters(nextActiveFilters);

    if (nextActiveFilters.length === 0) {
      clearTrackerFilters();
      return;
    }

    const allFilterChanges = buildTrackerApiFilters(nextActiveFilters);
    handleSetFilterVariable(allFilterChanges);
  };

  const customDateFilter = (value, filter) => {
    if (!filter.dateFrom || !filter.dateTo) {
      return true;
    }
    return (
      value.getTime() >= filter.dateFrom.getTime() &&
      value.getTime() <= filter.dateTo.getTime()
    );
  };

  const onDateFilterChange = (event) => {
    setDateFilter(event.value);
  };
  const handleChange = (event) => {
    setOptions(event.target.value);
  };
  const dateFilterTemplate = (options) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => {
          return options.filterCallback(e.value, options.index);
        }}
        dateFormat="mm/dd/yy"
        placeholder="mm/dd/yyyy"
        mask="99/99/9999"
      />
    );
  };

  const filingPeriodFilterTemplate = (options) => {
    return (
      <div>
        <Calendar
          value={options.value}
          onChange={(e) => {
            return options.filterCallback(e.value, options.index);
          }}
          dateFormat="mm/dd/yy"
          placeholder="Start Date"
          mask="99/99/9999"
        />
        <Calendar
          value={options.value}
          onChange={(e) => {
            return options.filterCallback(e.value, options.index);
          }}
          dateFormat="mm/dd/yy"
          placeholder="End Date"
          mask="99/99/9999"
        />
      </div>
    );
  };

  const jusrisdictionItemTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <span>{option}</span>
      </div>
    );
  };

  const jusrisdictionArray = ["Federal", "State", "Both"];

  const jurisdictionRowFilterTemplate = (options) => {
    if (
      !federalFilterSelectedValues.jurisdiction &&
      options?.filterModel?.value
    ) {
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <Dropdown
        value={federalFilterSelectedValues.jurisdiction || []}
        options={jusrisdictionArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, jurisdiction: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
    // options.filterModel?.matchMode &&
    //   options.filterModel.matchMode === "in" ? (
    //   <MultiSelect
    //     value={federalFilterSelectedValues.jurisdiction || []}
    //     options={jurisdiction}
    //     itemTemplate={jusrisdictionItemTemplate}
    //     onChange={(e) => {
    //       setFederalFilterSelectedValues((prev) => {
    //         return { ...prev, jurisdiction: e.value };
    //       });
    //       options.filterApplyCallback(e.value);
    //     }}
    //     placeholder="Any"
    //     maxSelectedLabels={1}
    //     className="p-column-filter"
    //     style={{ minWidth: "14rem", maxWidth: "14rem" }}
    //   />
    // ) : (

    // );
  };

  const requiredArray = ["True", "False"];

  const requiredRowFilterTemplate = (options) => {
    // console.log("requiredRowFilterTemplate:", options,masterCatFilter);
    if (
      !federalFilterSelectedValues.jurisdiction &&
      options?.filterModel?.value
    ) {
      // console.log("requiredRowFilterTemplate filterModel",options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <Dropdown
        value={federalFilterSelectedValues.filingRequired || []}
        options={requiredArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, filingRequired: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const statusRowFilterTemplate = (options) => {
    // console.log("##Options:", options, "matchmode", options.filterModel.matchMode,);
    // console.log("federalFilterSelectedValuesCheck", federalFilterSelectedValues);
    if (!federalFilterSelectedValues?.status && options?.filterModel?.value) {
      options.filterModel.value = null;
      options.value = null;
    }
    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={federalFilterSelectedValues.status || []}
        options={statusLookup}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, status: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "auto", maxWidth: "auto" }}
      />
    ) : (
      <Dropdown
        value={federalFilterSelectedValues.status || []}
        options={statusLookup}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, status: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "auto", maxWidth: "auto" }}
      />
    );
  };

  const stateRowFilterTemplate = (options) => {
    if (!federalFilterSelectedValues.stateList && options.filterModel.value) {
      options.filterModel.value = [];
      options.value = [];
    }
    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={federalFilterSelectedValues.stateList || []}
        options={stateList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, stateList: e.value };
          });
          options.filterCallback(e.value, options.index);
          //options.filterApplyCallback(e.value);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "12rem" }}
      />
    ) : (
      <Dropdown
        value={federalFilterSelectedValues.stateList || []}
        options={stateList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, stateList: e.value };
          });

          let values = [];

          if (options?.filterModel?.matchMode === "equals") {
            values.push(e.value);
          } else if (options?.filterModel?.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "12rem" }}
      />
    );
  };

  const [clientFiling, setClientFiling] = useState([]);
  const [clientFilingHistory, setClientFilingHistory] = useState([]);
  const [initialClientFilingHistory, setInitialClientFilingHistory] = useState(
    []
  );
  const [initialValue, setInitialValue] = useState([]);
  const [initialValueUpc, setInitialValueUpc] = useState([]);
  useEffect(() => {
    let list = states.map((ele) => ele.state);
    setStateList(list);
    return () => {
      clearClientFilingTrackers && clearClientFilingTrackers();
    };
  }, []);
  useEffect(() => {
    if (isDenied) {
      cellStatusEditor(initialOptions);
    }
  }, [isDenied]);
  useEffect(() => {
    // console.log(
    //   "isStatusColumnChange",
    //   isStatusColumnChange,
    //   "isStatusChangeOk",
    //   isStatusChangeOk
    // );
    if (isStatusColumnChange && !isStatusChangeOk && isChildIncludes) {
      setInfoMessage(
        "Do you want to update all affected companies status for this filing ?"
      );
      setShowInfo(true);
    }
  }, [isStatusColumnChange, isDenied]);

  const getStateName = (stateCode) => {
    const state = states.find((s) => s.code === stateCode);
    return state ? state.state : stateCode;
  };
  // useEffect(() => {
  //   if (isDenied) {
  //     cellStatusEditor(initialOptions)
  //   }
  // }, [isDenied])
  // useEffect(() => {
  //   // console.log(
  //   //   "isStatusColumnChange",
  //   //   isStatusColumnChange,
  //   //   "isStatusChangeOk",
  //   //   isStatusChangeOk
  //   // );
  //   if (isStatusColumnChange && !isStatusChangeOk && isChildIncludes) {
  //     setInfoMessage(
  //       "Do you want to update all affected companies status for this filing ?"
  //     );
  //     setShowInfo(true);
  //   }
  // }, [isStatusColumnChange, isDenied]);
  const cellListDisplayState = (rowData) => {
    return rowData.stateCategories?.join(", ");
  };

  const hideOtherCellOverlays = (currentKey) => {
    Object.entries(overlayRefs.current).forEach(([key, overlay]) => {
      if (key !== currentKey && overlay?.hide) {
        overlay.hide();
      }
    });
  };

  const getPreferredOverlayDirection = (cellElement) => {
    const rowElement = cellElement?.closest("tr");
    const rowIndexAttr = rowElement?.getAttribute("data-p-index");
    const rowIndex = rowIndexAttr !== null ? Number(rowIndexAttr) : -1;
    if (rowIndex >= 0 && rowIndex <= 2) {
      return "down";
    }

    const cellRect = cellElement?.getBoundingClientRect();
    if (!cellRect) {
      return "down";
    }

    return cellRect.bottom > window.innerHeight * 0.7 ? "up" : "down";
  };

  const positionOverlayNearCell = (overlayKey, cellElement, preferredDirection) => {
    const overlayPanel = overlayRefs.current[overlayKey];
    const overlayElement = overlayPanel?.container;
    if (!overlayElement || !cellElement || overlayElement.style.display === "none") {
      return;
    }

    const cellRect = cellElement.getBoundingClientRect();
    const overlayRect = overlayElement.getBoundingClientRect();
    const gap = 8;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const canOpenDown = cellRect.bottom + overlayRect.height + gap <= viewportHeight;
    const canOpenUp = cellRect.top - overlayRect.height - gap >= gap;

    let openUp = false;
    if (preferredDirection === "up" && canOpenUp) {
      openUp = true;
    } else if (preferredDirection === "down" && !canOpenDown && canOpenUp) {
      openUp = true;
    } else if (!canOpenDown && canOpenUp) {
      openUp = true;
    }

    let top = openUp
      ? cellRect.top - overlayRect.height - gap
      : cellRect.bottom + gap;
    let left = cellRect.left + cellRect.width / 2 - overlayRect.width / 2;

    left = Math.min(Math.max(left, gap), viewportWidth - overlayRect.width - gap);
    top = Math.min(Math.max(top, gap), viewportHeight - overlayRect.height - gap);

    overlayElement.style.position = "fixed";
    overlayElement.style.left = `${Math.round(left)}px`;
    overlayElement.style.top = `${Math.round(top)}px`;
    overlayElement.style.transform = "none";
  };

  const toggleCellOverlay = (event, overlayKey) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    const targetElement = event?.currentTarget;

    const overlayPanel = overlayRefs.current[overlayKey];
    if (!overlayPanel?.toggle) return;

    const overlayElement = overlayPanel.container;
    const isVisible = Boolean(
      overlayElement && overlayElement.style.display !== "none"
    );

    if (!isVisible) {
      hideOtherCellOverlays(overlayKey);
    }

    overlayPanel.toggle(event);

    requestAnimationFrame(() => {
      const preferredDirection = getPreferredOverlayDirection(targetElement);
      positionOverlayNearCell(overlayKey, targetElement, preferredDirection);
    });
  };

  const CellListDisplayFederal = (rowData, field) => {
    const categories = rowData[field]
      ? field === "federalCategories"
        ? rowData.businessCategory.map((ele) => ele.businessCategoryName)
        : rowData.businessCategory
          .filter((ele) => ele.state === rowData.filingStateInfo)
          .map((ele) => ele.businessCategoryName)
      : [];
    const firstCategory = categories[0] || "";
    const remainingCount = Math.max(categories.length - 1, 0);
    const hasValue = categories.length > 0;
    const hasMore = remainingCount > 0;

    let name =
      field === "federalCategories"
        ? "Who Must File Federal"
        : "Who Must File in State";
    const overlayKey = `${field}-${rowData.fileTrackingId || rowData.filingId || rowData.workflowId}`;
    return rowData.recordType === "TrackNow" ? (
      <div
        className="tableBtn"
        id={`${field}+${rowData.fileTrackingId}`}
        style={{
          width: "inherit",
        }}
      >
        <PrimeButton
          onClick={(event) => {
            if (!hasValue) return;
            toggleCellOverlay(event, overlayKey);
          }}
          text
          style={{
            width: "100%",
          }}
        >
          <div
            style={{
              width: "100%",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              whiteSpace: "nowrap",
              minWidth: 0,
            }}
          >
            <span
              style={{
                flex: "1 1 auto",
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                color: primaryColor,
                textAlign: "left",
              }}
            >
              {firstCategory}
            </span>
            {hasMore && (
              <span
                className="tracker-more-count"
                style={{
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                }}
              >
                {`+${remainingCount} more`}
              </span>
            )}
          </div>
        </PrimeButton>
        {hasValue && (
          <OverlayPanel
            ref={(el) => {
              if (el) {
                overlayRefs.current[overlayKey] = el;
              }
            }}
            showCloseIcon
            dismissable
            className="client-profile-overlay-panel"
            style={{
              padding: "0.4rem 0.8rem",
              width: "min(22rem, calc(100vw - 1rem))",
              maxWidth: "min(22rem, calc(100vw - 1rem))",
              maxHeight: "min(18rem, calc(100vh - 1rem))",
            }}
          >
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
              {name}
            </Typography>
            <div
              className="tracker-overlay-scroll overlay-scroll-consistent"
              style={{ width: "100%", maxWidth: "100%", maxHeight: "10.5rem", overflowY: "auto", overflowX: "hidden", paddingRight: "0.25rem", boxSizing: "border-box" }}
            >
              <ul style={{ paddingLeft: "20px", margin: 0 }}>
                {categories.map((ele, idx) => (
                  <li key={`${ele}-${idx}`} style={{ marginBottom: "4px", overflowWrap: "anywhere" }}>
                    {ele}
                  </li>
                ))}
              </ul>
            </div>
          </OverlayPanel>
        )}
      </div>
    ) : (
      <div
        style={{
          color: "black",
          textTransform: "uppercase",
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {firstCategory}
      </div>
    );
  };

  const CellAffectedCompaniesEditorBody = (rowData, field) => {
    const overlayKey = `affectedCompanies-${rowData.fileTrackingId || rowData.filingId}`;
    return detailedViewVal ||
      !isDetailedViewAvailable ||
      selectedCustomer?.clientType === "SubChild" ||
      (selectedCustomer?.clientType === "Parent" &&
        selectedCustomer?.isOnlyParentFile) ||
      (selectedCustomer?.clientType === "Child" &&
        !selectedCustomer?.bothChildAndSubChild) ? (
      <div style={{ width: "inherit", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {rowData.customerName}
      </div>
    ) : (
      <div className="tableBtn" style={{ width: "inherit" }}>
        <PrimeButton
          text
          style={{ width: "100%" }}
          onClick={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            const targetElement = e.currentTarget;
            const overlayPanel = overlayRefs.current[overlayKey];
            const overlayElement = overlayPanel?.container;
            const isVisible = Boolean(overlayElement && overlayElement.style.display !== "none");
            if (isVisible) {
              overlayPanel.hide();
              return;
            }
            hideOtherCellOverlays(overlayKey);
            const res = await fetchConsolidatedRecords(rowData);
            if (res) {
              const companyNames = res.map((ele) => ele.customerName);
              setOverlayDataMap((prev) => ({ ...prev, [overlayKey]: { list: companyNames, filingName: rowData.filingName } }));
            }
            if (overlayPanel?.show) {
              overlayPanel.show(e, targetElement);
              requestAnimationFrame(() => {
                const preferredDirection = getPreferredOverlayDirection(targetElement);
                positionOverlayNearCell(overlayKey, targetElement, preferredDirection);
              });
            }
          }}
        >
          <span style={{ color: primaryColor, textDecoration: "underline", fontWeight: 600 }}>
            View Affected Companies
          </span>
        </PrimeButton>
        <OverlayPanel
          ref={(el) => { if (el) overlayRefs.current[overlayKey] = el; }}
          showCloseIcon
          dismissable
          className="client-profile-overlay-panel"
          style={{
            padding: "0.4rem 0.8rem",
            width: "min(22rem, calc(100vw - 1rem))",
            maxWidth: "min(22rem, calc(100vw - 1rem))",
            maxHeight: "min(18rem, calc(100vh - 1rem))",
          }}
        >
          <OverlayListContent
            title="Affected Companies"
            filingName={overlayDataMap[overlayKey]?.filingName}
            list={overlayDataMap[overlayKey]?.list || []}
            emptyMessage="No Affected Companies"
          />
        </OverlayPanel>
      </div>
    );
  };
  const cellFilingPeriods = (rowData) => {
    return rowData.filingPeriod
  }

  const [anchorEl, setAnchorEl] = React.useState({});
  const [anchorE2, setAnchorE2] = React.useState({});
  const [overlayDataMap, setOverlayDataMap] = useState({});

  const CellListDisplayStaffAssigned = (rowData, field) => {
    let displayStaffAssigned =
      Array.isArray(rowData["staffAssignedArray"]) &&
        rowData["staffAssignedArray"].length > 0
        ? rowData["staffAssignedArray"].map((ele) => ele.name).join(", ")
        : rowData["staffAssignedArray"];

    const overlayKey = `staffAssigned-${rowData.fileTrackingId || rowData.filingId}`;

    if (detailedViewVal || !isDetailedViewAvailable || selectedCustomer.clientType === "SubChild" || (selectedCustomer.clientType === "Parent" && selectedCustomer?.isOnlyParentFile) || (selectedCustomer.clientType === "Child" && !selectedCustomer?.bothChildAndSubChild)) {
      if (!rowData.staffAssignedArray.length) {
        return (
          <div style={{ width: "inherit", overflow: "hidden", textOverflow: "ellipsis", color: "black" }}>
            {displayStaffAssigned}
          </div>
        );
      }
      return (
        <div className="tableBtn" id={`staffassigned${field}+${rowData.fileTrackingId}`} style={{ width: "inherit" }}>
          <PrimeButton
            text
            style={{ width: "100%" }}
            onClick={(event) => toggleCellOverlay(event, overlayKey)}
          >
            <div style={{ width: "100%", overflow: "hidden", display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap", minWidth: 0 }}>
              <span style={{ flex: "1 1 auto", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: primaryColor, textAlign: "left" }}>
                {displayStaffAssigned}
              </span>
            </div>
          </PrimeButton>
          <OverlayPanel
            ref={(el) => { if (el) overlayRefs.current[overlayKey] = el; }}
            showCloseIcon
            dismissable
            className="client-profile-overlay-panel"
            style={{
              padding: "0.4rem 0.8rem",
              width: "min(22rem, calc(100vw - 1rem))",
              maxWidth: "min(22rem, calc(100vw - 1rem))",
              maxHeight: "min(18rem, calc(100vh - 1rem))",
            }}
          >
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Staff Assigned</Typography>
            <div className="tracker-overlay-scroll overlay-scroll-consistent" style={{ width: "100%", maxWidth: "100%", maxHeight: "10.5rem", overflowY: "auto", overflowX: "hidden", paddingRight: "0.25rem", boxSizing: "border-box" }}>
              <ul style={{ paddingLeft: "20px", margin: 0 }}>
                {rowData.staffAssignedArray.map((ele) => (
                  <li key={ele.name} style={{ marginBottom: "4px", overflowWrap: "anywhere" }}>{ele.name}</li>
                ))}
              </ul>
            </div>
          </OverlayPanel>
        </div>
      );
    }

    // Non-detailed view: "View Staff Assigned" link with overlay
    const staffOverlayKey = `staffAssignedView-${rowData.fileTrackingId || rowData.filingId}`;
    return (
      <div className="tableBtn" style={{ width: "inherit" }}>
        <PrimeButton
          text
          style={{ width: "100%" }}
          onClick={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            const targetElement = e.currentTarget;
            const overlayPanel = overlayRefs.current[staffOverlayKey];
            const overlayElement = overlayPanel?.container;
            const isVisible = Boolean(overlayElement && overlayElement.style.display !== "none");
            if (isVisible) {
              overlayPanel.hide();
              return;
            }
            hideOtherCellOverlays(staffOverlayKey);
            const res = await fetchConsolidatedRecords(rowData);
            if (res) {
              const staffAssignedArray = res.reduce((acc, curr) => acc.concat(curr.staffAssigned), []);
              const uniqueEntries = {};
              const uniqueUserNames = staffAssignedArray.reduce((acc, curr) => {
                const key = `${curr.filingId}-${curr.userId}`;
                if (!uniqueEntries[key]) { uniqueEntries[key] = true; acc.push(curr.userName); }
                return acc;
              }, []);
              setOverlayDataMap((prev) => ({ ...prev, [staffOverlayKey]: { list: uniqueUserNames, filingName: rowData.filingName } }));
            }
            if (overlayPanel?.show) {
              overlayPanel.show(e, targetElement);
              requestAnimationFrame(() => {
                const preferredDirection = getPreferredOverlayDirection(targetElement);
                positionOverlayNearCell(staffOverlayKey, targetElement, preferredDirection);
              });
            }
          }}
        >
          <span style={{ color: primaryColor, textDecoration: "underline", fontWeight: 600 }}>View Staff Assigned</span>
        </PrimeButton>
        <OverlayPanel
          ref={(el) => { if (el) overlayRefs.current[staffOverlayKey] = el; }}
          showCloseIcon
          dismissable
          className="client-profile-overlay-panel"
          style={{
            padding: "0.4rem 0.8rem",
            width: "min(22rem, calc(100vw - 1rem))",
            maxWidth: "min(22rem, calc(100vw - 1rem))",
            maxHeight: "min(18rem, calc(100vh - 1rem))",
          }}
        >
          <OverlayListContent
            title="Staff Assigned"
            filingName={overlayDataMap[staffOverlayKey]?.filingName}
            list={overlayDataMap[staffOverlayKey]?.list || []}
            emptyMessage="No Staff Assigned"
          />
        </OverlayPanel>
      </div>
    );
  };

  const cellListDisplayName = (rowData) => {
    return rowData.isMasterFiling ? (
      <LightTooltip title={rowData.filingName}>
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {rowData.filingName}
        </div>
      </LightTooltip>
    ) : (
      <LightTooltip title={rowData.filingName}>
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontWeight: "bold",
            fontStyle: "italic",
          }}
        >
          {rowData.filingName}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayRuleInfo = (rowData) => {
    const ruleInfoValue = capitalizeLeadingText(rowData.ruleInfo);
    return (
      <LightTooltip title={ruleInfoValue}>
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {ruleInfoValue}
        </div>
      </LightTooltip>
    );
  };

  // const cellListDisplayAffectedComp = (rowData, field) => {
  //   const open = Boolean(anchorE2[rowData.fileTrackingId]);
  //   const id = open ? "simple-popover" : undefined;
  //   const handleClose = () => {
  //     setAnchorE2((old) => ({ ...old, [rowData.fileTrackingId]: null }));
  //   };

  //   let findParent;
  //   if (
  //     rowData.parentCustomer !== null &&
  //     rowData.parentCustomer !== "" &&
  //     rowData.parentCustomer !== 0
  //   ) {
  //     findParent = rowData.affectedCompanies.find(
  //       (ele) => ele.type === "Parent"
  //     );
  //   } else {
  //     findParent = rowData.affectedCompanies.find(
  //       (ele) => ele.type === "DefaultClient"
  //     );
  //   }

  //   let popupData = [...rowData.affectedCompanies];
  //   popupData.forEach(function (item, i) {
  //     if (
  //       findParent &&
  //       findParent.customerId &&
  //       item.customerId === findParent.customerId
  //     ) {
  //       popupData.splice(i, 1);
  //       popupData.unshift(item);
  //     }
  //   });

  //   return (
  //     rowData?.formattedAffectedCompany?.length > 0 && (
  //       // <div>
  //       //  {rowData?.formattedAffectedCompany?.length > 1 ? (
  //       <div
  //         className='tableBtn'
  //         id={`affectedCompanies${field}+${rowData.fileTrackingId}`}
  //         style={{
  //           width: "inherit",
  //         }}
  //       >
  //         <PrimeButton
  //           onClick={(e) =>
  //             setAnchorE2((old) => ({
  //               ...old,
  //               [rowData.fileTrackingId]: e.currentTarget,
  //             }))
  //           }
  //           text
  //           style={{
  //             width: "100%",
  //           }}
  //         >
  //           {rowData.formattedAffectedCompany.length > 0 && (
  //             <div
  //               style={{
  //                 width: "inherit",
  //                 overflow: "hidden",
  //                 textOverflow: "ellipsis",
  //                 color: "black",
  //               }}
  //             >
  //               {/* {rowData.formattedAffectedCompany.join(", ")} */}
  //               {rowData.formattedAffectedCompany.map((company, index) => (
  //                 <span key={index}>
  //                   {company.customerName}
  //                   {index < rowData.formattedAffectedCompany.length - 1
  //                     ? ", "
  //                     : ""}
  //                 </span>
  //               ))}
  //             </div>
  //           )}
  //         </PrimeButton>
  //         <Popover
  //           className='scrollbar-tracker'
  //           id={id}
  //           open={open}
  //           disableScrollLock
  //           anchorEl={anchorE2[rowData.fileTrackingId]}
  //           onClose={handleClose}
  //           anchorOrigin={{
  //             vertical: "bottom",
  //             horizontal: "top",
  //           }}
  //           style={{
  //             minWidth: "23rem", // Adjust the minimum width as needed
  //             maxHeight: "23rem", // Adjust the maximum height as needed
  //           }}
  //         //  style={{ padding: '0rem 1rem', position: "fixed" }}
  //         >
  //           <Stack
  //             className='affectedCompanies'
  //             direction='row'
  //             flexDirection='row'
  //             justifyContent='space-between'
  //             // sx={{ margin: "20px 20px 0 20px" }}
  //             style={{
  //               minWidth: "23rem", // Adjust the minimum width as needed
  //               maxHeight: "23rem", // Adjust the maximum height as needed
  //               margin: "20px 20px 0 20px",
  //             }}
  //           >
  //             <Typography>AFFECTED COMPANIES</Typography>
  //             <PrimeButton onClick={handleClose}>
  //               <CloseIcon style={{ color: "white", cursor: "pointer" }} />
  //             </PrimeButton>
  //           </Stack>

  //           <ScrollPanel
  //             style={{
  //               // width: "18.375rem",
  //               // // padding: "6px 19px 28px 28px",
  //               // // scrollbarColor: "auto",

  //               // height: "8.625rem",
  //             }}
  //           >
  //             <Stack direction='column' spacing={0.5} mt={1}>
  //               <ul>
  //                 <>
  //                   {popupData.length > 0 &&
  //                     popupData.map((ele, i) => (
  //                       <li
  //                         style={{
  //                           marginBottom: "0.5rem",
  //                           textDecoration:
  //                             ele.status === "Completed"
  //                               ? "line-through"
  //                               : "none",
  //                         }}
  //                         key={ele}
  //                       >
  //                         {ele.customerName}{" "}
  //                         {findParent &&
  //                           findParent.customerId &&
  //                           findParent.customerId === ele.customerId &&
  //                           `- (Parent)`}{" "}
  //                         {""}-{ele.status}
  //                       </li>
  //                     ))}
  //                 </>
  //               </ul>
  //             </Stack>
  //           </ScrollPanel>
  //         </Popover>
  //       </div>
  //     )
  //   );
  // };
  // return (
  //   <LightTooltip title={rowData.affectedCompanies}>
  //     <div
  //       style={{
  //         width: 'inherit',
  //         margin: '0 1rem',
  //         overflow: 'hidden',
  //         textOverflow: 'ellipsis',
  //       }}
  //     >
  //       {rowData.affectedCompanies}
  //     </div>
  //   </LightTooltip>
  // );
  // };

  const cellListDisplayNotes = (rowData) => {
    const notesUrl = rowData.notes;
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    if (!notesUrl) return null;

    const formattedText = notesUrl.replace(
      urlRegex,
      '<a style="color:#0000FF;" href="$&" target="_blank" rel="noopener noreferrer">$&</a>'
    );

    return (
      <LightTooltip
        arrow
        title={
          <div
            style={{
              maxWidth: "350px",
              maxHeight: "250px",
              overflowY: "auto",
              overflowX: "hidden",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowWrap: "anywhere",
              padding: "4px",// Added top/bottom & left/right padding
              fontWeight: "normal",   // Remove bold
              lineHeight: "1.5",      // Better readability
              fontSize: "14px",
            }}
            dangerouslySetInnerHTML={{ __html: formattedText }}
          />
        }
      >
        <div
          style={{
            width: "100%",
            maxWidth: "44rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          dangerouslySetInnerHTML={{ __html: formattedText }}
        />
      </LightTooltip>
    );
  };

  const cellListDisplayWhereToFile = (rowData) => {
    const value = rowData.whereToFile?.trim();
    const urlRegex = /(https?:\/\/[^\s]+)/gi;
    const urlTestRegex = /(https?:\/\/[^\s]+)/i;

    if (!value) return value;

    const parts = value.split(urlRegex);

    return (
      <LightTooltip
        title={
          <>
            {parts.map((part, index) =>
              urlTestRegex.test(part) ? (
                <a key={index} href={part} target="_blank" rel="noopener noreferrer">
                  {part}
                </a>
              ) : (
                part
              )
            )}
          </>
        }
      >
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {parts.map((part, index) =>
            urlTestRegex.test(part) ? (
              <a key={index} href={part} target="_blank" rel="noopener noreferrer">
                {part}
              </a>
            ) : (
              part
            )
          )}
        </div>
      </LightTooltip>
    );
  };
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#F1F2F6",
      color: "black",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }));

  // const federalCategoryRowFilterTemplate = (options) => {
  //   console.log("##Options5:", options);

  //   return (
  //     <MultiSelect
  //       value={federalCatFilter}
  //       options={federalCategoriesLookup}
  //       itemTemplate={jusrisdictionItemTemplate}
  //       onChange={(e) => {
  //         console.log("##EOptions:", e.value);
  //         setFederalCatFilter(e.value);
  //         const fedRows = clientFiling.filter(
  //           (row) => row.juristiction === "Federal"
  //         );
  //         const selectedIds = fedRows
  //           .filter((row) => {
  //             return e.value.some((category) =>
  //               row.federalCategories.includes(category)
  //             );
  //           })
  //           .map((item) => item.filingId);
  //         console.log("##selectedIds:", selectedIds);

  //         options.filterApplyCallback(selectedIds);
  //       }}
  //       placeholder="Any"
  //       maxSelectedLabels={1}
  //       className="p-column-filter"
  //       style={{ minWidth: "14rem", maxWidth: "14rem" }}
  //     />
  //   );
  // };
  // const stateCategoryRowFilterTemplate = (options) => {
  //   console.log("##Options:", options);
  //   return (
  //     <MultiSelect
  //       value={stateCatFilter}
  //       options={stateCategoriesLookup}
  //       itemTemplate={jusrisdictionItemTemplate}
  //       onChange={(e) => {
  //         console.log("##EOptions:", e.value);
  //         setStateCatFilter(e.value);
  //         const stateRows = clientFiling.filter(
  //           (row) => row.juristiction === "State"
  //         );
  //         const selectedIds = stateRows
  //           .filter((row) => {
  //             return e.value.some((category) =>
  //               row.stateCategories.includes(category)
  //             );
  //           })
  //           .map((item) => item.filingId);
  //         options.filterApplyCallback(selectedIds);
  //       }}
  //       placeholder="Any"
  //       maxSelectedLabels={1}
  //       className="p-column-filter"
  //       style={{ minWidth: "14rem", maxWidth: "14rem" }}
  //     />
  //   );
  // };
  const customCategoryFilter = (value, filter) => {
    filter.filterApplyCallback(value);
    // return value.some((cateogory) => cateogory.includes(filter)); // check if at least one skill matches filter
  };
  const filteredData = clientFiling.filter((row) => {
    if (row.jurisdiction === "Federal") {
      return federalCatFilter.some((category) =>
        row.federalCategories.includes(category)
      );
    } else if (row.jurisdiction === "State") {
      return stateCatFilter.some((category) =>
        row.stateCategories.includes(category)
      );
    }
    return true;
  });


  // const footerContentInfo = (
  //   <div>
  //     <PrimeButton
  //       label='No'
  //       icon='pi pi-check'
  //       onClick={() => closeRowEditing()}
  //       autoFocus
  //     />
  //     {/* <PrimeButton
  //       label='Yes'
  //       icon='pi pi-check'
  //       onClick={() => closeInfo()}
  //       autoFocus
  //     /> */}
  //   </div>
  // );

  const closeAlert = () => {
    setShowAlert(false);
    // scrollToSelected()
  };
  // const closeInfo = () => {
  //   setIsStatusChangeOk(true);
  //   setIsDenied(false)
  //   setShowInfo(false);
  // };

  const formatDate = (value) => {
    return value !== null
      ? value?.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      : null;
  };

  const dateBodyTemplate = (rowData) => {
    return formatDate(rowData.date);
  };

  const cellEditorBody = (rowData) => {
    // console.log('cellEditorBody', rowData['internalDueDate']);
    return formatDate(rowData.internalDueDate);
  };

  const cellFilingDateBody = (rowData, field) => {
    return formatDate(rowData.dueDateFiling);
  };

  const cellEditor = (options) => {
    console.log("options", options);
    return (
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Calendar
          value={options.value ? new Date(options.value) : options.value}
          disabled={
            (options.rowData.initialGrantTermComplete &&
              options.rowData.initialGrantTermComplete === "Yes") ||
            (!detailedViewVal &&
              options.rowData?.isOnlyChildFile &&
              options.rowData?.isUnderParent &&
              !options.rowData?.isOnlyParentFile)
          }
          onChange={(e) => options.editorCallback(e.value)}
          dateFormat="mm/dd/yy"
          placeholder="mm/dd/yyyy"
          mask="99/99/9999"
        />
      </Stack>
    );
  };

  const cellFilingEditor = (options, isDisable) => {
    // console.log(" options", options);
    return (
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Calendar
          value={options.value ? new Date(options.value) : options.value}
          disabled={!isDisable}
          onChange={(e) => options.editorCallback(e.value)}
          dateFormat="mm/dd/yy"
          placeholder="mm/dd/yyyy"
          mask="99/99/9999"
        />
      </Stack>
    );
  };


  const cellFilingEditorPeriod = (options, isDisable) => {

    const handleStartDateChange = (e) => {
      options.editorCallback({
        ...options.value,
        startdate: e.value,
      });
    }
    const handleEndDateChange = (e) => {
      options.editorCallback({
        ...options.value,
        enddate: e.value
      })
    }

    return (
      <Stack direction={"row"} justifyContent={"space-between"} spacing={1} >
        <Calendar
          value={options.value.startdate ? new Date(options.value.startdate) : options.value.startdate}
          disabled={!isDisable}
          onChange={(e) => handleStartDateChange(e)}
          dateFormat="mm/dd/yy"
          placeholder="mm/dd/yyyy"
          mask="99/99/9999"
        />
        <Calendar
          value={options.value.enddate ? new Date(options.value.enddate) : options.value.enddate}
          disabled={!isDisable}
          onChange={(e) => handleEndDateChange(e)}
          dateFormat="mm/dd/yy"
          placeholder="mm/dd/yyyy"
          mask="99/99/9999"
        />
      </Stack>
    );
  };

  const onRowEditComplete = async (e) => {

    const formatDate = (date) => {
      if (!date) return null;
      const modDate = typeof date === 'string' ? date.slice(0, 10) : date.toISOString().slice(0, 10);
      return modDate
    };

    const formattedStartDate = formatDate(e.newData?.filingPeriods?.startdate);
    const formattedEndDate = formatDate(e.newData?.filingPeriods?.enddate);

    if (
      JSON.stringify(e.data?.staffAssignedArray) !== JSON.stringify(e.newData?.staffAssignedArray) ||
      e.data["dueDateFiling"] !== e.newData["dueDateFiling"] ||
      e.data["status"] !== e.newData["status"] ||
      e.data["grantTermComplete"] !== e.newData["grantTermComplete"] ||
      (e.data?.filingPeriods && formatDate(e.data.filingPeriods.startdate) !== formattedStartDate) ||
      (e.data?.filingPeriods && formatDate(e.data.filingPeriods.enddate) !== formattedEndDate)
    ) {

      if (e.data["dueDateFiling"] !== e.newData["dueDateFiling"] && !e.data.isOnlyChildFile && !e.data.isOnlyParentFile && !e.data.isOnlySubchildFile) {
        console.log("onRowEditComplete e.data", e.data);
        console.log("onRowEditComplete e.newData", e.newData);
        console.log("onRowEditComplete selectedCustomer", selectedCustomer);

        setRowEditPendingValues(e)
        setAlertMessage("Changes to due dates will automatically propagate to parent, child and Subchild entities and may affect data belonging to another company. Proceed only if this impact is intended.")
        // setOpenConfirmEditFilingDueDate(true)
        setOpenFilingDueDateInfo(true)

      } else {
        completeOnRowEditFunc(e)
      }
      console.log('val-check-grant', e);

    }

  };

  const completeOnRowEditFunc = (e) => {
    setAlertMessage("")
    setOpenFilingDueDateInfo(false)
    // closeDialog();

    const editValues = e || rowEditPendingValues;

    if (editValues.data["status"] !== editValues.newData["status"]) {
      // console.log("onRowEditComplete Mainstatus change ", "e.data", e.data["status"], e.newData["status"]);

      saveNewField(editValues.data, editValues.newData, true);
    } else {
      console.log("onRowEditComplete Mainstatus notchange");

      saveNewField(editValues.data, editValues.newData, false);
    }
  }

  let awardTypeArray = ["Direct Federal Award", "Pass Through Award"];

  const postawardTypeRowFilterTemplate = (options) => {
    let awardTypeOptionList = postawardtypeArray.sort();
    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={masterCatFilter.awardTypeName || []}
        options={awardTypeOptionList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardAgencyRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, awardTypeName: e.value };
          });
          options.filterApplyCallback(e.value);
          //options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter.awardTypeName || []}
        options={awardTypeOptionList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardAgencyRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, awardTypeName: e.value };
          });
          options.filterApplyCallback(e.value);
          //options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };
  const postawardAgencyRowFilterTemplate = (options) => {
    const awardAgenciesOptions = awardAgenciesList.map(
      (item) => item.awardingAgencyName
    );
    console.log(
      "postawardAgencyRowFilterTemplate",
      "postawardagencyArray",
      postawardagencyArray,
      "awardAgenciesList",
      awardAgenciesList,
      "awardAgenciesOptions",
      awardAgenciesOptions
    );

    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={masterCatFilter.awardingAgencyName || []}
        options={awardAgenciesOptions}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardAgencyRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, awardingAgencyName: e.value };
          });
          options.filterCallback(e.value, options.index);
          //options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter.awardingAgencyName || []}
        options={awardAgenciesOptions}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardAgencyRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, awardingAgencyName: e.value };
          });
          options.filterCallback(e.value, options.index);
          //options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };

  const resetDefaultStaffList = () => {
    const activeClientId =
      clientId || props.selectedClientId || selectedCustomer?.customerId;
    if (activeClientId && Array.isArray(userRoles)) {
      const staffList = userRoles
        .filter((ele) => {
          if (parseInt(activeClientId) === ele.customerId || String(activeClientId) === String(ele.customerId)) {
            return ele;
          }
        })
        .filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.userName === value.userName)
        );
      staffList.sort(function (a, b) {
        if (a.userName < b.userName) return -1;
        if (a.userName > b.userName) return 1;
        return 0;
      });
      setstaffAssignedList(staffList);
      if (props.setStaffList) {
        props.setStaffList(staffList);
      }
    }
  };

  const onRowEditInit = (e) => {
    console.log("onRowEditInit e.data", e?.data);
    const rowCustomerId = (detailedViewVal && e?.data?.customerId)
      ? e.data.customerId
      : (e?.data?.customerId || selectedCustomer?.customerId || clientId || props.selectedClientId);

    if (rowCustomerId && Array.isArray(userRoles) && userRoles.length > 0) {
      const filteredStaff = userRoles
        .filter((ele) => {
          if (parseInt(rowCustomerId) === ele.customerId || String(rowCustomerId) === String(ele.customerId)) {
            return ele;
          }
        })
        .filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.userName === value.userName)
        );
      filteredStaff.sort(function (a, b) {
        if (a.userName < b.userName) return -1;
        if (a.userName > b.userName) return 1;
        return 0;
      });
      setstaffAssignedList(filteredStaff);
      if (props.setStaffList) {
        props.setStaffList(filteredStaff);
      }
    } else {
      setstaffAssignedList([]);
      if (props.setStaffList) {
        props.setStaffList([]);
      }
    }
  };

  const onRowEditCancel = (e) => {
    resetDefaultStaffList();
    // setIsStatusColumnChange(false);
    // setIsStatusChangeOk(false);
    // setSelectedValues([]);
    // setIsDenied(false)
  };

  const cellStatusEditorBody = (rowData) => {
    return rowData["status"];
  };

  const grantTermFooterContent = (
    <div>
      <PrimeButton
        label="No"
        icon="pi pi-check"
        onClick={() => grantTermCloseAlert()}
        autoFocus
      />
      <PrimeButton
        label="Yes"
        icon="pi pi-check"
        onClick={() => {
          grantTermVal.editorCallback("Yes");
          grantTermCloseAlert();
        }}
        autoFocus
      />
    </div>
  );

  const handleCloseFilingDueDate = () => {
    setAlertMessage("")
    setOpenFilingDueDateInfo(false);
    setRowEditPendingValues(null);
  };

  const grantTermCloseAlert = () => {
    setGrantTermConfrimation(false);
  };

  const cellGrantTermcompleteEditorBody = (rowData) => {
    let val =
      rowData.recordType === "TrackNow"
        ? ""
        : rowData["grantTermComplete"] === "Yes" ||
          rowData["grantTermComplete"] === true
          ? "Yes"
          : "No";
    return val;
  };

  const fetchConsolidatedRecords = async (rowData) => {
    console.log("fetchConsolidatedRecords filingId", rowData);
    try {
      const consRecords = await axios.get(
        `${API_BASE_URL}/Customer/CustomerFileTrackingConsolidate?CustomerId=${props.selectedClientId}&FilingId=${rowData.filingId}&PreviousStartDate=${rowData.previousStartDate}`
      );

      console.log("fetchConsolidatedRecords consRecords", consRecords);

      return consRecords.data.data; // return the data received from the API
    } catch (error) {
      console.log("@@Error:", error);
      throw error; // re-throwing error to be caught by the calling function if needed
    }
  };

  const viewAffectedCompanies = async (e, rowData, field) => {
    e.preventDefault();
    setShowAffectedCompanies(false);
    setShowStaffAssigned(false);
    console.log("viewAffectedCompanies props", rowData, field);
    const res = await fetchConsolidatedRecords(rowData);
    console.log("viewAffectedCompanies res", res);
    if (res) {
      if (field === "affectedCompanies") {
        let companyNames = res.map((ele) => ele.customerName);
        console.log("viewAffectedCompanies companyNames", companyNames);
        setAffectedCompaniesDetails({
          recordName: rowData.filingName,
          list: companyNames,
        });
        setShowAffectedCompanies(true);
      } else {
        const staffAssignedArray = res.reduce((acc, curr) => {
          // Concatenate the nested staffAssigned arrays of each object
          return acc.concat(curr.staffAssigned);
        }, []);
        console.log(
          "viewAffectedCompanies staffAssignedArray",
          staffAssignedArray
        );

        // setStaffAssignedDetails({})
        const uniqueEntries = {};
        console.log("uniqueEntries", uniqueEntries);
        // Iterate through staffAssignedArray
        const uniqueUserNames = staffAssignedArray.reduce((acc, curr) => {
          // Generate a unique key based on filingId and userId
          const key = `${curr.filingId}-${curr.userId}`;

          // If the key doesn't exist in uniqueEntries, add it and store the userName
          if (!uniqueEntries[key]) {
            uniqueEntries[key] = true; // Mark the entry as seen
            acc.push(curr.userName); // Store the userName
          }

          return acc;
        }, []);
        console.log("viewAffectedCompanies uniqueUserNames", uniqueUserNames);
        setStaffAssignedDetails({
          recordName: rowData.filingName,
          list: uniqueUserNames,
        });
        setShowStaffAssigned(true);
      }
    }
  };

  const handleGrantTermChange = async (e, options) => {
    if (e.value.code === "Yes") {
      console.log("handleGrantTermChange", "e, options", e, options);
      // Step 1: Filter Client Filing Data based on FilingId

      // const filteredData = clientFiling.filter(
      //   (record) => record.filingId === options.rowData.filingId
      // );

      const res = await axios.get(
        `${API_BASE_URL}/Customer/TrackerFilingsBasedOnFrequency/${options.rowData.customerId}/${options.rowData.filingId}`
      );
      const filteredData = res.data.data;
      // Step 2: Find Record with Lowest Start Date
      const lowestStartDateRecord = filteredData.filter(
        (ele) => new Date(ele.startdate) < new Date(options.rowData.startdate)
      );

      // Step 3: Check for 'Pending' Status
      let isPending = lowestStartDateRecord.find(
        (ele) => ele.status === "Pending"
      );
      // console.log("handleGrantTermChange", "filteredData", filteredData, "lowestStartDateRecord", lowestStartDateRecord, "isPending", isPending);

      if (isPending) {
        // Step 4: Display Alert Message
        setAlertMessage(
          "The record is in pending status for one or more previous periods. Please complete them before marking Grant Term Completed for the record."
        );
        setShowAlert(true);
      } else {
        setGrantTermVal(options);
        setGrantTermConfrimation(true);
      }
    } else {
      options.editorCallback(e.value.code);
    }
  };
  const cellGrantTermcompleteEditor = (options) => {
    const GrantTermcompleteDropdown = [
      { name: "Yes", code: "Yes" },
      { name: "No", code: "No" },
    ];

    let val = options.value === true || options.value === "Yes" ? "Yes" : "No";
    let initalGrantTermcomplete = { name: val, code: val };

    return (
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Dropdown
          value={initalGrantTermcomplete}
          disabled={
            (options.rowData.initialGrantTermComplete &&
              options.rowData.initialGrantTermComplete === "Yes") ||
            (!detailedViewVal &&
              options.rowData?.isOnlyChildFile &&
              options.rowData?.isUnderParent &&
              !options.rowData?.isOnlyParentFile)
          }
          onChange={(e) => {
            handleGrantTermChange(e, options);
          }}
          options={GrantTermcompleteDropdown}
          optionLabel="name"
          autoFocus
          style={{ position: "static" }}
        />
      </Stack>
    );
  };

  const cellStatusEditor = (options) => {
    const statusDropdown = [
      { name: "Pending", code: "Pending" },
      { name: "In Progress", code: "In Progress" },
      { name: "Approved", code: "Approved" },
      { name: "Completed", code: "Completed" },
    ];
    console.log("opt-check-status", options);
    let initalStatus = { name: options.value, code: options.value };
    console.log("init-status", initalStatus);
    // if (editingStatusCell === options.field && openStatusEditor) {
    console.log("editStatus cellStatusEditor");
    return (
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Dropdown
          value={initalStatus}
          disabled={
            (options.rowData.initialGrantTermComplete &&
              options.rowData.initialGrantTermComplete === "Yes") ||
            (options.rowData?.isOnlyChildFile &&
              options.rowData?.isUnderParent &&
              !options.rowData?.isOnlyParentFile &&
              !detailedViewVal)
          }
          onChange={(e) => {
            // e.preventDefault();
            // onStatusEdit(e.value);
            options.editorCallback(e.value.code);
          }}
          options={statusDropdown}
          optionLabel="name"
          autoFocus
        />
      </Stack>
    );
  };
  const saveNewField = async (oldStaff, newStaff) => {

    const isRowEdit = true;
    // const utcDate =
    //   newStaff.internalDueDate !== null && newStaff.internalDueDate.getFullYear
    //     ? new Date(
    //       Date.UTC(
    //         newStaff.internalDueDate.getFullYear(),
    //         newStaff.internalDueDate.getMonth(),
    //         newStaff.internalDueDate.getDate()
    //       )
    //     )
    //     : newStaff.internalDueDate;
    props.resetKeepSelectedRecords([newStaff]);
    console.log("saveNewField oldStaff", oldStaff, "newStaff", newStaff);

    const utcFilingDate =
      newStaff.dueDateFiling !== null && newStaff.dueDateFiling.getFullYear
        ? new Date(
          Date.UTC(
            newStaff.dueDateFiling.getFullYear(),
            newStaff.dueDateFiling.getMonth(),
            newStaff.dueDateFiling.getDate()
          )
        )
        : newStaff.dueDateFiling;
    const startDateUtc = newStaff.filingPeriods && newStaff.filingPeriods.startdate !== null && newStaff.filingPeriods.startdate?.getFullYear
      ? new Date(
        Date.UTC(
          newStaff.filingPeriods.startdate.getFullYear(),
          newStaff.filingPeriods.startdate.getMonth(),
          newStaff.filingPeriods.startdate.getDate()
        )
      )
      : (newStaff.filingPeriods?.startdate || null);
    const endDateUtc = newStaff.filingPeriods && newStaff.filingPeriods.enddate !== null && newStaff.filingPeriods.enddate?.getFullYear
      ? new Date(
        Date.UTC(
          newStaff.filingPeriods.enddate.getFullYear(),
          newStaff.filingPeriods.enddate.getMonth(),
          newStaff.filingPeriods.enddate.getDate()
        )
      )
      : (newStaff.filingPeriods?.enddate || null);

    console.log("saveNewField newStaff.dueDateFiling", newStaff.dueDateFiling, "utcFilingDate", utcFilingDate);
    console.log("saveNewField newStaff-FilingPeriod startDate", newStaff.filingPeriods.startdate, "startDateUtc", startDateUtc);

    try {
      let payload = [
        {
          ...newStaff,
          // dueDate: utcDate,
          filingduedate: utcFilingDate,
          updateDate: new Date(),
          updateUser: authUser.userId + "",
          grantTermComplete:
            newStaff.grantTermComplete === "Yes" ? true : false,
          startdate: startDateUtc,
          enddate: endDateUtc,
        },

      ];
      delete payload[0].stateList;
      delete payload[0].staffassigned;

      //Exsisting staffs extraction
      const oldStaffAssignedArray = Array.isArray(oldStaff.staffAssignedArray)
        ? oldStaff.staffAssignedArray
        : [];
      const newStaffAssignedArray = Array.isArray(newStaff.staffAssignedArray)
        ? newStaff.staffAssignedArray
        : [];
      const oldStaffAssignedList = Array.isArray(oldStaff.staffAssigned)
        ? oldStaff.staffAssigned
        : [];

      const exUserIds = oldStaffAssignedArray
        .filter((oldEle) =>
          newStaffAssignedArray.some(
            (newEle) => String(newEle.code) === String(oldEle.code)
          )
        )
        .map((ele) => ele.code);
      const exsistingStaffsDetails = oldStaffAssignedList
        .filter((staff) =>
          exUserIds.some((id) => String(id) === String(staff.userId))
        )
        .map((staff) => ({
          staffAssignedId: staff.staffAssignedId,
          userId: staff.userId,
          isDeleted: false,
        })); // Extracting and storing the exsisting staffs details
      console.log(
        "Staff-Assigned-Ass Exsisting ",
        "exUserIds",
        exUserIds,
        "exsistingStaffsDetails",
        exsistingStaffsDetails
      );

      //Removed Exsisting staffs
      const removedUserIds = oldStaffAssignedArray
        .filter(
          (oldEle) =>
            !newStaffAssignedArray.some(
              (newEle) => String(newEle.code) === String(oldEle.code)
            )
        )
        .map((ele) => ele.code);
      const removedStaffsDetails = oldStaffAssignedList
        .filter((staff) =>
          removedUserIds.some((id) => String(id) === String(staff.userId))
        )
        .map((staff) => ({
          staffAssignedId: staff.staffAssignedId,
          userId: staff.userId,
          isDeleted: true,
        })); // Extracting and storing the removed staffs details

      //Newly added Staff Assigned
      const newLyAddedStaffs = newStaffAssignedArray
        .filter(
          (newEle) =>
            !oldStaffAssignedArray.some(
              (oldEle) => String(oldEle.code) === String(newEle.code)
            )
        )
        .map((ele) => ({
          staffAssignedId: 0,
          userId: ele.code,
          isDeleted: false,
        }));
      const staffAssignedPayload = [
        ...exsistingStaffsDetails,
        ...removedStaffsDetails,
        ...newLyAddedStaffs,
      ];
      payload[0].staffAssigned = staffAssignedPayload.map((ele) => ({
        staffAssignedId: ele.staffAssignedId,
        fileTrackingID: newStaff.fileTrackingId,
        userId: ele.userId,
        isDeleted: ele.isDeleted,
        createDate: new Date(),
        createUser: authUser.userId + "",
        updateDate: new Date(),
        updateUser: authUser.userId + "",
      }));



      // console.log('saveNewField payload', payload);
      const res = await axios.put(
        `${API_BASE_URL}/Customer/CustomerFileTrackingUpdate`,
        payload
      );
      console.log('saveNewField res', res);
      console.log("oldstaffnewstaff", oldStaff, newStaff);

      if (oldStaff["dueDateFiling"] !== newStaff["dueDateFiling"] && !oldStaff.isMasterFiling) {

        console.log("Filing due date changed");
        const res = await axios.post(
          `${API_BASE_URL}/Customer/CustomerFilingTrackerPeriodDuedateUpdate/${oldStaff.fileTrackingId}`
        );
      } else {
        console.log("Filing due date not changed");

      }

      if (oldStaff.status !== "Completed" && newStaff.status === "Completed") {
        const completedStatusEmailPayload = [{
          customerId: newStaff.customerId,
          filingId: newStaff.filingId,
          fileTrackingId: newStaff.fileTrackingId,
          recordType: newStaff.recordType
        }]

        const res = await axios.post(
          `${API_BASE_URL}/Customer/CustomerFileTrackingCompletedEmail`,
          completedStatusEmailPayload
        );
      }
      setRowEditPendingValues(null)
      setAlertMessage("Successfully updated the record");
      setShowAlert(true);
      const vScroll =
        value === "1"
          ? sortRecord === "Clear"
            ? dtUpcoming.current.getVirtualScroller()
            : dt.current.getVirtualScroller()
          : dtHistory.current.getVirtualScroller();

      let range = vScroll.getRenderedRange();
      console.log("refreshTable vScroll", vScroll, range);

      if (value === "1") {
        props.handleRefreshTable()
      } else {
        props.handleRefreshTable()
      }
      setIsStatusChangeOk(false);
      setIsStatusColumnChange(false);
      // setSelectedValues([]);
      setInitialOptions();
      setIsDenied(false);
      resetDefaultStaffList();

    } catch (err) {
      console.log("saveNewField err", err);
    }
  };
  // if (data["fldAffectedCompany"] !== newStaff["fldAffectedCompany"] && !isMainStatusChange) {

  //   //Both parent and child company for status completed
  //   let addedAffectedCompany = newStaff.fldAffectedCompany.filter(newCompany => {
  //     return !data.fldAffectedCompany.some(oldCompany => oldCompany.code === newCompany.code);
  //   });

  //   //Both parent and child company for status In progress

  //   let removedAffectedCompanies = data.fldAffectedCompany.filter(oldCompany => {
  //     return !newStaff.fldAffectedCompany.some(newCompany => newCompany.code === oldCompany.code);
  //   });

  //   //parent company for status completed
  //   let addedParentConpany = addedAffectedCompany.find(company => company.code == payload.customerId);
  //   // parent company for status In progress
  //   let removedParentCompany = removedAffectedCompanies.find(company => company.code == payload.customerId);

  //   console.log("saveNewField addedAffectedCompany ", addedAffectedCompany, "removedAffectedCompanies", removedAffectedCompanies, "Payload", payload.customerId);

  //   //child company for status completed
  //   addedAffectedCompany = addedAffectedCompany.filter(company => company.code !== payload.customerId);

  //   //child company for status completed
  //   removedAffectedCompanies = removedAffectedCompanies.filter(company => company.code !== payload.customerId);

  //   console.log("saveNewField Modified Child addedAffectedCompany ", addedAffectedCompany, "removedAffectedCompanies", removedAffectedCompanies, "Payload", payload.customerId);
  //   console.log("saveNewField Modified Parent addedParentConpany ", addedParentConpany, "removedParentCompany", removedParentCompany, "Payload", payload.customerId);

  //   if (addedParentConpany) {
  //     payload.status = "Completed"
  //   }
  //   if (removedParentCompany) {
  //     payload.status = "In Progress"
  //   }

  //   addedAffectedCompany.forEach(newCompany => {
  //     if (payload.customerId === newCompany.code) {
  //       updatedChildItem = "Completed";
  //     }
  //   });

  //   // Update status based on removedAffectedCompanies for payload
  //   removedAffectedCompanies.forEach(oldCompany => {
  //     if (payload.customerId === oldCompany.code) {
  //       updatedChildItem = "In Progress";
  //     }
  //   });

  // }
  // // Add staffAssigned array from payload to each object in childList
  // if ('staffAssigned' in payload && Array.isArray(payload.staffAssigned)) {
  //   childItem.staffAssigned = payload.staffAssigned.map((staffItem) => ({
  //     staffAssignedId: staffItem.staffAssignedId,
  //     fileTrackingID: staffItem.fileTrackingID,
  //     userId: staffItem.userId,
  //     createDate: staffItem.createDate,
  //     createUser: staffItem.createUser,
  //     updateDate: staffItem.updateDate,
  //     updateUser: staffItem.updateUser,
  //   }));

  // }

  const deleteStaff = (oldStaff) => {
    try {
      oldStaff.forEach(async (ele) => {
        const res = await axios.delete(
          `${API_BASE_URL}/Customer/DeleteCustomerFilingTrackerStaffAssigned/${ele.staffAssignedId}`
        );
        if (value === "1") {
          // fetchClientFilingTrackers(clientId);
        } else {
          // fetchClientFilingTrackersHistory();
        }
      });
    } catch (err) {
      // console.log("deleteStaff err", err);
    }
  };

  const handleStaffAssigned = (oldStaff, newStaff, fileTrackingId) => {
    let newPayload = newStaff.staffAssignedArray.filter(
      (e) => !oldStaff.staffAssignedArray.includes(e)
    );
    let oldPayload = newStaff.staffAssigned.filter((objA) => {
      let matchingCode = newStaff.staffAssignedArray.find(
        (objB) => objB.name === objA.userName
      );
      return matchingCode === undefined || matchingCode.code !== objA.userId;
    });
    if (newPayload.length > 0) {
      saveNewField(newPayload, fileTrackingId);
    }
    if (oldPayload.length > 0) {
      `deleteStaff`(oldPayload);
    }
  };

  const cellStaffAssignedBody = (rowData) => {
    return rowData["staffAssignedArray"]?.reduce(
      (prevVal, val, i) => (i === 0 ? val.name : prevVal + " , " + val.name),
      ""
    );
  };

  const StaffAssignedInlineEditor = ({
    editorId,
    value,
    optionsList,
    disabled,
    onChange,
  }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const selectedValues = Array.isArray(value) ? value : [];
    const selectedCodes = new Set(
      selectedValues.map((item) => String(item?.code ?? item?.userId ?? item))
    );

    const displayValue = selectedValues.length
      ? selectedValues
        .map((item) => item?.name ?? item?.userName ?? "")
        .filter(Boolean)
        .join(", ")
      : "Select Staff";

    const handleTogglePopover = (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (disabled) {
        return;
      }

      setAnchorEl((current) => (current ? null : event.currentTarget));
    };

    const handleClosePopover = () => {
      setAnchorEl(null);
    };

    const handleOptionToggle = (option) => {
      const optionCodeStr = String(option.code);
      const isSelected = selectedCodes.has(optionCodeStr);
      const nextValue = isSelected
        ? selectedValues.filter(
          (item) => String(item?.code ?? item?.userId ?? item) !== optionCodeStr
        )
        : [...selectedValues, option];

      onChange(nextValue);
    };

    return (
      <Box sx={{ width: "100%", minWidth: 0, overflow: "hidden" }}>
        <Box
          id={editorId}
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          onClick={handleTogglePopover}
          sx={{
            width: "100%",
            minWidth: 0,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            px: 1.25,
            borderRadius: "8px",
            border: "1px solid #c7c7d1",
            backgroundColor: disabled ? "#f3f4f6" : "#ffffff",
            cursor: disabled ? "not-allowed" : "pointer",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          <Typography
            sx={{
              minWidth: 0,
              flex: 1,
              fontSize: "0.95rem",
              color: selectedValues.length ? "#111827" : "#6b7280",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              textAlign: "left",
            }}
          >
            {displayValue}
          </Typography>
          <GoogleMaterialIcon
            name={anchorEl ? "expand_less" : "expand_more"}
            size={20}
            color="#6b7280"
          />
        </Box>

        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          disableAutoFocus
          disableEnforceFocus
          disableRestoreFocus
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          PaperProps={{
            onMouseDown: (event) => {
              event.stopPropagation();
            },
            onClick: (event) => {
              event.stopPropagation();
            },
            sx: {
              mt: 0.5,
              minWidth: anchorEl ? `${anchorEl.clientWidth}px` : "14rem",
              maxWidth: "20rem",
              maxHeight: "16rem",
              overflow: "hidden",
              borderRadius: "10px",
              border: "1px solid #d9d9e3",
              boxShadow: "0 16px 40px rgba(17, 24, 39, 0.14)",
            },
          }}
        >
          <Box
            onMouseDown={(event) => {
              event.stopPropagation();
            }}
            onClick={(event) => {
              event.stopPropagation();
            }}
            sx={{
              py: 0.5,
              maxHeight: "16rem",
              overflowY: "auto",
            }}
          >
            {optionsList.length > 0 ? (
              optionsList.map((option) => (
                <FormControlLabel
                  key={option.code}
                  onMouseDown={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                  }}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    handleOptionToggle(option);
                  }}
                  control={
                    <Checkbox
                      size="small"
                      checked={selectedCodes.has(String(option.code))}
                      onChange={() => handleOptionToggle(option)}
                      onClick={(event) => event.stopPropagation()}
                    />
                  }
                  label={
                    <Typography
                      sx={{
                        fontSize: "0.95rem",
                        color: "#1f2937",
                      }}
                    >
                      {option.name}
                    </Typography>
                  }
                  sx={{
                    width: "100%",
                    mx: 0,
                    px: 1,
                    py: 0.25,
                    alignItems: "center",
                  }}
                />
              ))
            ) : (
              <Typography
                sx={{
                  p: 1.5,
                  fontSize: "0.875rem",
                  color: "#6b7280",
                  textAlign: "center",
                }}
              >
                No Staff Available
              </Typography>
            )}
          </Box>
        </Popover>
      </Box>
    );
  };

  const cellStaffAssignedEditor = (options) => {
    const staffAssignedEditorId = `tracker-staffassigned-editor-${options.rowData.fileTrackingId || options.rowData.filingId}`;

    // In detailed view (or row-level edit), use the clicked row's customer to filter user roles
    const targetCustomerId = (detailedViewVal && options.rowData?.customerId)
      ? options.rowData.customerId
      : (options.rowData?.customerId || selectedCustomer?.customerId || clientId || props.selectedClientId);

    let baseStaffList = [];
    if (targetCustomerId && Array.isArray(userRoles) && userRoles.length > 0) {
      const rowStaff = userRoles
        .filter((ele) => {
          if (parseInt(targetCustomerId) === ele.customerId || String(targetCustomerId) === String(ele.customerId)) {
            return ele;
          }
        })
        .filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.userName === value.userName)
        );
      rowStaff.sort(function (a, b) {
        if (a.userName < b.userName) return -1;
        if (a.userName > b.userName) return 1;
        return 0;
      });
      baseStaffList = rowStaff;
    } else if (!detailedViewVal) {
      baseStaffList = staffAssignedList;
    }

    let staffAssignedOptions = [];
    if (options.rowData.recordType === "TrackNow") {
      staffAssignedOptions = baseStaffList
        .filter(
          (ele) =>
            !ele.roleName?.includes("PostAward")
        )
        .map((ele) => ({
          name: ele.userName ? ele.userName.charAt(0).toUpperCase() + ele.userName.slice(1) : "",
          code: ele.userId,
        }));
    } else {
      staffAssignedOptions = baseStaffList
        .map((ele) => ({
          name: ele.userName ? ele.userName.charAt(0).toUpperCase() + ele.userName.slice(1) : "",
          code: ele.userId,
        }));
    }

    // Ensure currently assigned staff are included in options
    const existingAssigned = Array.isArray(options.value) ? options.value : [];
    existingAssigned.forEach((assigned) => {
      const code = assigned?.code ?? assigned?.userId;
      if (code && !staffAssignedOptions.some((opt) => String(opt.code) === String(code))) {
        staffAssignedOptions.push({
          name: assigned.name ?? assigned.userName ?? `User ${code}`,
          code: code,
        });
      }
    });

    console.log(
      "#STAFFCHECK cellStaffAssignedEditor: staffAssignedOptions",
      targetCustomerId,
      baseStaffList,
      staffAssignedOptions
    );

    const isNonDetailedDisabled = isDetailedViewAvailable && !detailedViewVal;

    return (
      <Stack
        direction={"row"}
        justifyContent={"flex-start"}
        className="staffAssignedArray"
        style={{ width: "100%", maxWidth: "100%", minWidth: 0, overflow: "hidden" }}
      >
        <StaffAssignedInlineEditor
          editorId={staffAssignedEditorId}
          value={options.value}
          optionsList={staffAssignedOptions}
          disabled={
            (options.rowData.initialGrantTermComplete &&
              options.rowData.initialGrantTermComplete === "Yes") ||
            isNonDetailedDisabled
          }
          onChange={(nextValue) => options.editorCallback(nextValue)}
        />
      </Stack>
    );
  };

  // const cellAffectedCompaniesEditor = (options) => {
  //   const { rowData } = options;
  //   const isChildIncludes = rowData.affectedCompanies.some(
  //     (company) => company.type === "Child"
  //   );
  //   setIsChildIncludes(isChildIncludes);

  //   const affectedCompaniesList = rowData.affectedCompanies.map((item) => ({
  //     name: item.customerName,
  //     code: item.customerId,
  //     status: item.status === "Completed",
  //   }));

  //   const updatedValue = options.value;
  //   // console.log(
  //   //   "cellAffectedCompaniesEditor OPTIONS",
  //   //   options,
  //   //   "updatedVals",
  //   //   updatedValue
  //   // );
  //   // const initalStatus = options.value;
  //   // customerName: company.customerName,
  //   // type: company.type, // Assuming 'type' property exists in 'company' object
  //   // customerId: company.customerId, // Assuming 'customerId' property exists in 'company' object
  //   // status: company.status,

  //   // const isChildIncludes = affectedCompaniesList.some(
  //   //   (company) => company.type === "Child"
  //   // );
  //   // console.log("isChildIncludes".isChildIncludes);
  //   // setIsChildIncludes(isChildIncludes);
  //   // const optionsWithStatus = affectedCompaniesList.map((company) => ({
  //   //   label: `${company.customerName} - ${company.status}`,
  //   //   value: company.customerId,
  //   //   checked: company.status === "Completed",
  //   //   disabled:
  //   //     !rowData.isParentCompany &&
  //   //     rowData?.parentCustomer === company.customerId,
  //   //   // defaultValue: company.status === "Completed" ? company.customerName : null
  //   // }));

  //   return (
  //     <Stack
  //       direction={"row"}
  //       justifyContent={"space-between"}
  //       className='affectedCompanies'
  //     >
  //       <MultiSelect
  //         value={updatedValue}
  //         onChange={(e) => {
  //           options.editorCallback(e.value);
  //         }}
  //         disabled={
  //           options.rowData.initialGrantTermComplete &&
  //           options.rowData.initialGrantTermComplete === "Yes"
  //         }
  //         options={affectedCompaniesList}
  //         optionLabel='name'
  //         // optionValue='customerId'
  //         //  optionDisabled='status'
  //         panelClassName='affectedCompanies'
  //         placeholder='Select affected Companies'
  //         maxSelectedLabels={3}
  //         className='w-full md:w-20rem'
  //         style={{ position: "static", maxWidth: "20rem", maxHeight: "20rem" }}
  //       />
  //     </Stack>
  //   );
  // };

  const cellAffectedCompaniesEditor = (options) => {
    const { rowData } = options;
    const isChildIncludes = rowData.affectedCompanies.some(
      (company) => company.type === "Child"
    );
    setIsChildIncludes(isChildIncludes);

    const affectedCompaniesList = rowData.affectedCompanies.map((item) => ({
      name: item.customerName,
      code: item.customerId,
      status: item.status === "Completed",
    }));

    const updatedValue = options.value;
    // console.log(
    //   "cellAffectedCompaniesEditor OPTIONS",
    //   options,
    //   "updatedVals",
    //   updatedValue
    // );
    // const initalStatus = options.value;
    // customerName: company.customerName,
    // type: company.type, // Assuming 'type' property exists in 'company' object
    // customerId: company.customerId, // Assuming 'customerId' property exists in 'company' object
    // status: company.status,

    // const isChildIncludes = affectedCompaniesList.some(
    //   (company) => company.type === "Child"
    // );
    // console.log("isChildIncludes".isChildIncludes);
    // setIsChildIncludes(isChildIncludes);
    // const optionsWithStatus = affectedCompaniesList.map((company) => ({
    //   label: `${company.customerName} - ${company.status}`,
    //   value: company.customerId,
    //   checked: company.status === "Completed",
    //   disabled:
    //     !rowData.isParentCompany &&
    //     rowData?.parentCustomer === company.customerId,
    //   // defaultValue: company.status === "Completed" ? company.customerName : null
    // }));

    return (
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        className="affectedCompanies"
      >
        <MultiSelect
          value={updatedValue}
          onChange={(e) => {
            options.editorCallback(e.value);
          }}
          disabled={
            options.rowData.initialGrantTermComplete &&
            options.rowData.initialGrantTermComplete === "Yes"
          }
          options={affectedCompaniesList}
          optionLabel="name"
          // optionValue='customerId'
          //  optionDisabled='status'
          panelClassName="affectedCompanies"
          placeholder="Select affected Companies"
          maxSelectedLabels={3}
          className="w-full md:w-20rem"
          style={{ position: "static", maxWidth: "20rem", maxHeight: "20rem" }}
        />
      </Stack>
    );
  };

  const toLocalTime = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-LL-yyyy hh:mm:ss"),
        "dd-LL-yyyy hh:mm:ss",
        { zone: "UTC" }
      ).toFormat("dd-LL-yyyy");
      // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  const toLocalTime2 = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-LL-yyyy hh:mm:ss"),
        "dd-LL-yyyy hh:mm:ss",
        { zone: "UTC" }
      ).toFormat("yyyy-LL-dd");
      // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  // Map over the clientFiling data and modify the dueDate field for each row
  // const modifiedClientFiling = clientFiling.map((row) => {
  //   return {
  //     ...row,
  //     dueDateFormatted: toLocalTime(row.dueDate),
  //   };
  // });
  const handleTabChange = (event, newValue) => {
    setFederalFilterSelectedValues([]);
    setSelectedClientFiling([]);
    setViewAll(false);
    props.setSelectedFiling([]);
    setGlobalFilterValue("");
    setFilters({
      ...filters,
      global: {
        ...filters.global,
        value: null,
      },
    });
    setValue(newValue);
    props.setTablValue(newValue);
    let _filters = { ...filters };
    search.current.value = "";
    _filters["global"].value = "";
    setFilters(_filters);
    setIsClearIcon(false);
    setDetailedViewVal(false);
    setRecordTypeVal("");
    if (newValue === "2") {
      setIsDisabled(true);
      setClientFiling([]);
      setInitialValue([]);
    } else {
      setIsDisabled(false);
      setClientFilingHistory([]);
      setInitialClientFilingHistory([]);
    }
    if (sortRecord === "Clear") {
      setTrackNowValUpc(false);
      setPostAwardValUpc(false);
      setcheckboxdisabledTrackNowUpc(true);
      setcheckboxdisabledPostAwardUpc(true);
      setSortMaster([]);
      setSortRecord("Upcoming Due Dates");
      props.setSortRecord("Upcoming Due Date");
      setMasterCatFilter([]);
      setUpcomingCatFilter([]);
    }
  };
  const onRowSelect = (e) => {
    // console.log("@@RowSelect:", e);
  };
  const onRowEditCheck = (e) => {
    // console.log("@@onRowEditCheck:", e);
  };

  const handleViewAllClick = () => {
    setViewAll(true);
  };

  const handlePaginationClick = () => {
    setViewAll(false);
  };
  const fetchConfigs = async () => {
    if (fetchConfigurations) {
      let config = await fetchConfigurations();
      let startYear = config.find(
        (ele) => ele.configItem === "StartYear"
      ).configItemValue;
      let currentYear = config.find(
        (ele) => ele.configItem === "CurrentYear"
      ).configItemValue;
      startYear = parseInt(startYear);
      currentYear = parseInt(currentYear);
      const yearsInBetween = [];
      for (let year = startYear; year < currentYear; year++) {
        yearsInBetween.push(year);
      }
      setYearsList(yearsInBetween);
      setSelectedYear(currentYear - 1);
    }
  };
  const handletrackNowChange = () => {
    if (trackNowVal === true) {
      setTrackNowVal(false);
    } else {
      setTrackNowVal(true);
    }
  };

  const handletrackNowChangeUc = () => {
    if (trackNowValUpc === true) {
      setTrackNowValUpc(false);
    } else {
      setTrackNowValUpc(true);
    }
  };

  const handlepostAwardChange = () => {
    if (postAwardVal === true) {
      setPostAwardVal(false);
    } else {
      setPostAwardVal(true);
    }
  };

  const handlepostAwardChangeUc = () => {
    if (postAwardValUpc === true) {
      setPostAwardValUpc(false);
    } else {
      setPostAwardValUpc(true);
    }
  };

  // console.log("selectedCustomer", selectedCustomer)

  useEffect(() => {
    console.log(
      "postaward/tracknow up check prop",
      selectedCustomer,
      checkboxdisabled,
      lazyLoading,
      isRecordTypeChange
    );

    if (
      selectedCustomer &&
      !checkboxdisabled &&
      !lazyLoading &&
      isRecordTypeChange
    ) {
      console.log(
        "postaward/tracknow up check val",
        trackNowValUpc,
        postAwardValUpc
      );

      if (trackNowValUpc === true && postAwardValUpc === true) {
        setRecordTypeVal("");
      } else if (trackNowValUpc === true) {
        setRecordTypeVal("TrackNow");
      } else if (postAwardValUpc === true) {
        setRecordTypeVal("PostAward");
      } else if (trackNowValUpc === false && trackNowValUpc === false) {
        setRecordTypeVal("");
        setDetailedViewVal(false);
      }

      // setFederalFilterSelectedValues([]);
      // setGlobalFilterValue("");
      // setFilters({
      //   ...filters,
      //   global: {
      //     ...filters.global,
      //     value: null,
      //   },
      // });
      // let _filters = { ...filters };
      // search.current.value = "";
      // _filters["global"].value = "";
      // setFilters(_filters);
      // setIsClearIcon(false);
      setTotalRecords(0);
      setRecordsInView(0);
      setClientFiling([]);
      setInitialValue([]);
      setClientFilingHistory([]);
      setInitialClientFilingHistory([]);
      // setIsFilterChange([])
      // setSortingData({sortBy: "",sortOrder: ""})
      props.setClientFilingData([]);
      setSelectedClientFiling([]);
      props.setSelectedFiling([]);
      console.log(
        "postaward/tracknow up check  --?",
        trackNowValUpc,
        postAwardValUpc
      );
      if (!(trackNowValUpc === false && postAwardValUpc === false)) {
        console.log(
          "postaward/tracknow up check",
          trackNowValUpc,
          postAwardValUpc
        );
        setRefreshRecordList(true);
      }
      setIsRecordTypeChange(false);
    } else if (!selectedCustomer) {
      setcheckboxdisabledTrackNowUpc(true);
      setTrackNowValUpc(false);
      setPostAwardValUpc(false);
    }
  }, [trackNowValUpc, postAwardValUpc, selectedCustomer]);

  useEffect(() => {
    setcheckboxdisabledTrackNow(
      !checkboxdisabled && trackNowVal === true && postAwardVal === false
    );
    setcheckboxdisabledPostAward(
      !checkboxdisabled && postAwardVal === true && trackNowVal === false
    );
  }, [trackNowVal, postAwardVal, checkboxdisabled]);

  useEffect(() => {
    console.log(
      "postaward/tracknow check prop",
      selectedCustomer,
      checkboxdisabled,
      lazyLoading,
      isRecordTypeChange
    );

    if (
      selectedCustomer &&
      !checkboxdisabled &&
      !lazyLoading &&
      isRecordTypeChange
    ) {
      console.log("postaward/tracknow check val", trackNowVal, postAwardVal);

      if (trackNowVal === true && postAwardVal === true) {
        setRecordTypeVal("");
      } else if (trackNowVal === true) {
        setRecordTypeVal("TrackNow");
      } else if (postAwardVal === true) {
        setRecordTypeVal("PostAward");
      } else if (trackNowVal === false && postAwardVal === false) {
        setRecordTypeVal("");
        setDetailedViewVal(false);
      }

      // setFederalFilterSelectedValues([]);
      // setGlobalFilterValue("");
      // setFilters({
      //   ...filters,
      //   global: {
      //     ...filters.global,
      //     value: null,
      //   },
      // });
      // let _filters = { ...filters };
      // search.current.value = "";
      // _filters["global"].value = "";
      // setFilters(_filters);
      // setIsClearIcon(false);
      setTotalRecords(0);
      setRecordsInView(0);
      setClientFiling([]);
      setInitialValue([]);
      setClientFilingHistory([]);
      setInitialClientFilingHistory([]);
      // setIsFilterChange([])
      // setSortingData({sortBy: "",sortOrder: ""})
      props.setClientFilingData([]);
      setSelectedClientFiling([]);
      props.setSelectedFiling([]);
      console.log("postaward/tracknow check  --?", trackNowVal, postAwardVal);
      if (!(trackNowVal === false && postAwardVal === false) && !lazyLoading) {
        console.log("postaward/tracknow check", trackNowVal, postAwardVal);
        setRefreshRecordList(true);
      }
      setIsRecordTypeChange(false);
    } else if (!selectedCustomer) {
      setCheckBoxDisabled(true);
      setTrackNowVal(false);
      setPostAwardVal(false);
    }
  }, [trackNowVal, postAwardVal]);

  useEffect(() => {
    setcheckboxdisabledTrackNowUpc(
      !checkboxdisabled && trackNowValUpc === true && postAwardValUpc === false
    );
    setcheckboxdisabledPostAwardUpc(
      !checkboxdisabled && postAwardValUpc === true && trackNowValUpc === false
    );
  }, [trackNowValUpc, postAwardValUpc, checkboxdisabled]);

  useEffect(() => {
    let filteredTrackNowData = [];
    if (trackNowVal === true && postAwardVal === true) {
      if (value === "2" && selectedCustomer) {
        // setClientFilingHistory(initialClientFilingHistory);
      } else {
        // setClientFiling(initialValue);
      }
    } else {
      let initalVal =
        value === "2" && selectedCustomer
          ? initialClientFilingHistory
          : initialValue;
      if (trackNowVal === true) {
        filteredTrackNowData = initalVal.filter(
          (ele) => ele.recordType === "TrackNow"
        );
      }
      if (postAwardVal === true) {
        filteredTrackNowData = initalVal.filter(
          (ele) => ele.recordType === "PostAward"
        );
      }
      if (value === "2" && selectedCustomer) {
        // setClientFilingHistory(filteredTrackNowData);
      } else {
        // setClientFiling(filteredTrackNowData);
      }
    }
  }, [initialValue, initialClientFilingHistory]);

  const handleTrackPostChange = (type, isHistoryView) => {
    console.log("handleTrackPostChange", type, trackNowVal);
    setIsRecordTypeChange(true);
    // if(type === "trackNow" && trackNowVal){
    //   setTrackNowVal(false)
    //   setRecordTypeVal("PostAward")
    // }else if(type === "trackNow" && !trackNowVal){
    //   setTrackNowVal(true)
    //   setRecordTypeVal("TrackNow")
    // }
    if (type === "trackNow") {
      setTrackNowVal(!trackNowVal);
    } else {
      setPostAwardVal(!postAwardVal);
    }
    // if (type === "trackNow") {
    //   handletrackNowChange();
    // } else {
    //   handlepostAwardChange();
    // }
  };

  const handleTrackPostChangeUc = (type) => {
    setIsRecordTypeChange(true);
    if (type === "trackNow") {
      setTrackNowValUpc(!trackNowValUpc);
    } else {
      setPostAwardValUpc(!postAwardValUpc);
    }
  };

  const clearTrackerTableRecords = () => {
    setClientFiling([]);
    setInitialValue([]);
    setClientFilingTrackers([]);
    setClientFilingHistory([]);
    setInitialClientFilingHistory([]);
    setClientFilingTrackersHistory([]);
    props.setClientFilingData([]);
    setSelectedClientFiling([]);
    props.setSelectedFiling([]);
  };

  useEffect(() => {
    console.log(
      "detailedView check prop",
      selectedCustomer,
      lazyLoading,
      isRecordTypeChange
    );
    props.setDetailedViewVal(detailedViewVal);
    // if (selectedCustomer && !checkboxdisabled && !lazyLoading && isRecordTypeChange) {

    if (
      selectedCustomer &&
      !lazyLoading &&
      isRecordTypeChange &&
      !(trackNowVal === false && postAwardVal === false)
    ) {
      console.log("detailedView check val", detailedViewVal);

      // if (trackNowVal === true && postAwardVal === true) {
      //   setRecordTypeVal("")
      // } else if (trackNowVal === true) {
      //   setRecordTypeVal("TrackNow")
      // } else if (postAwardVal === true) {
      //   setRecordTypeVal("PostAward")
      // }
      setTotalRecords(0);
      setRecordsInView(0);
      clearTrackerTableRecords();
      resetVirtualScrollerPosition();
      console.log("detailedView check", lazyLoading);
      if (!lazyLoading) {
        setRefreshRecordList(true);
      }
      setIsRecordTypeChange(false);
    } else if (!selectedCustomer) {
      setCheckBoxDisabled(true);
      setDetailedViewVal(false);
    }
  }, [detailedViewVal]);

  const handleDetailedViewChange = () => {
    //resetFilters()
    resetVirtualScrollerPosition();
    setIsRecordTypeChange(true);
    clearTrackerTableRecords();
    setDetailedViewVal(!detailedViewVal);
    props.setUnderDetailedViewProps(!detailedViewVal);
  };

  const fetchBusinessCategories = async () => {
    console.log("@@Fetch BusinessCategories:", getBusinessCategories);
    if (getBusinessCategories) {
      console.log("@@Fetch BusinessCategories:");
      try {
        let list = [];
        const resList = await getBusinessCategories();
        console.log("@@BusinessCategories:", resList);
        list = resList.map((item) => item.businessCategoryName);
        const progList = await getProgramName();
        console.log("@@BusinessCategories:", progList);
        list.push(...progList.map((item) => item.programName));
        list.sort();
        console.log("@@BusinessCategories: list", list);
        setCategoryList(() => list);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };
  const fetchAwardType = async () => {
    console.log("@@Fetch fetchAwardType:");
    try {
      const resList = await axios.get(
        `${API_BASE_URL}/Application/ListAwardType`
      );
      let typeList = resList.data;
      //.map((item) => item.businessCategoryName).sort()\
      typeList = typeList.sort((a, b) =>
        (a.awardTypeName ?? "").localeCompare(b.localeCompare ?? "")
      );
      console.log("@@fetchAwardType:", resList, "typeList", typeList);
      setAwardTypeList(() => typeList);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };
  const fetchAwardAgencies = async () => {
    console.log("@@Fetch BusinessCategories:");

    console.log("@@Fetch BusinessCategories:");
    try {
      const resList = await axios.get(
        `${API_BASE_URL}/Application/ListAwardingAgencies`
      );
      let agenciesList = resList.data;

      agenciesList = agenciesList.sort((a, b) =>
        (a.awardingAgencyName ?? "").localeCompare(b.awardingAgencyName ?? "")
      );
      console.log("@@BusinessCategories:", resList, "resList", resList);
      setAwadAgenciesList(() => agenciesList);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };
  const fetchClientFilingTrackers = async (clientId, isRowEdit) => {
    // if (clientId) {
    setClientFiling([]);
    setInitialValue([]);
    let payLoad = { customerId: clientId };
    setIsLoading(true);

    try {
      if (getClientFilingTrackers) {
        if (isRowEdit === undefined || !isRowEdit) {
          setTrackNowVal(false);
          setPostAwardVal(false);
          setCheckBoxDisabled(true);
        }
        try {
          let custList = await getClientFilingTrackers(payLoad);

          const _jusrisdictions = custList.map((item) =>
            item.filingJuristiction ? item.filingJuristiction : ""
          );
          const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));
          setJurisdiction(_uniqJurisdictions);
          custList = custList.map((ele) => {
            // const affectedCompaniesNames = ele.affectedCompanies.map(
            //   (company) => company.customerName
            // );
            // ele.formattedAffectedCompany = affectedCompaniesNames;
            // ele.formattedAffectedCompany = ele.affectedCompanies.map(
            //   (company) => ({
            //     customerName: company.customerName,
            //     type: company.type, // Assuming 'type' property exists in 'company' object
            //     customerId: company.customerId, // Assuming 'customerId' property exists in 'company' object
            //     status: company.status, // Assuming 'status' property exists in 'company' object
            //   })
            // );
            // ele.fldAffectedCompany = ele.affectedCompanies
            //   .filter((item) => item.status === "Completed")
            //   .map((company) => ({
            //     name: company.customerName,
            //     code: company.customerId, // Assuming 'customerId' property exists in 'company' object
            //     status: company.status === "Completed",
            //   }));
            // let findParent;
            // if (
            //   ele.parentCustomer !== null &&
            //   ele.parentCustomer !== "" &&
            //   ele.parentCustomer !== 0
            // ) {
            //   findParent = ele.affectedCompanies.find(
            //     (item) => item.type === "Parent"
            //   );
            // } else {
            //   findParent = ele.affectedCompanies.find(
            //     (item) => item.type === "DefaultClient"
            //   );
            // }

            // let popupData = [...ele.affectedCompanies];
            // popupData.forEach(function (item, i) {
            //   if (findParent && findParent.customerId && item.customerId === findParent.customerId) {
            //     popupData.splice(i, 1);
            //     popupData.unshift(item);
            //   }
            // });

            // // Add findParent property to the current element
            // ele.parentAffectedCompany = findParent;

            let date = ele.dueDate;

            // let isParent = ele.staffAssigned && ele.staffAssigned.length > 0 ?
            //   ele.staffAssigned.some((staff) => staff.company === "Parent") : false

            ele.staffAssignedArray =
              ele.staffAssigned.length > 0
                ? ele.staffAssigned.map((ele) => ({
                  name: ele.userName
                    ? ele.userName.charAt(0).toUpperCase() +
                    ele.userName.slice(1)
                    : ele.name,
                  code: ele.userId ? ele.userId : ele.code,
                }))
                : ele.staffAssigned;

            // let internalDueDate =
            //   ele.dueDate !== null ? ele.dueDate.toISOString() : "";
            // let dueDateFiling =
            //   ele.filingDueDate !== null ? ele.filingDueDate.toISOString() : "";
            // console.log("##dueDate internal", internalDueDate, dueDateFiling);
            ele.internalDueDate =
              ele.dueDate !== null ? new Date(ele.dueDate) : null;
            ele.dueDateFiling =
              ele.filingDueDate !== null ? new Date(ele.filingDueDate) : null;
            return { ...ele, dueDate: date };
          });
          setInitialValue((old) => custList);
          if (isRowEdit === undefined || !isRowEdit) {
            setClientFiling((old) => custList);

            // const trackNowExist = custList.find(
            //   (ele) => ele.recordType === "TrackNow"
            // );
            // const postAwardExist = custList.find(
            //   (ele) => ele.recordType === "PostAward"
            // );

            // if (trackNowExist) {
            //    setTrackNowVal(true);
            // }

            // if (postAwardExist) {
            //    setPostAwardVal(true);
            // }

            // if (trackNowExist && postAwardExist) {
            //   setCheckBoxDisabled(false);
            // } else {
            //   setCheckBoxDisabled(true);
            // }
          }

          // setTrackNowList((old) => trackNowList);
          // setPostAwardList((old) => postAwardList);
          props.setClientFilingData((old) => custList);
          props.resetRefreshList();
        } catch (error) {
          console.log("error", error);
        }
      } else {
      }
    } catch (error) {
      console.error("err", error);
    } finally {
      setIsLoading(false);
    }
    // }
  };

  const fetchClientFilingTrackersHistory = async (isRowEdit) => {
    // if (clientId) {
    setClientFilingHistory([]);
    setInitialClientFilingHistory([]);
    setIsLoadingHistory(true);
    try {
      if (selectedCustomer) {
        if (isRowEdit === undefined || !isRowEdit) {
          setTrackNowVal(false);
          setPostAwardVal(false);
          setCheckBoxDisabled(true);
        }
        try {
          const resList = await axios.get(
            `${API_BASE_URL}/Customer/CustomerFileTrackingbyCustomerId?CustomerId=${selectedCustomer.customerId}&Year=${selectedYear}`
          );
          let custList = resList.data.data;
          const _jusrisdictions = custList.map((item) =>
            item.filingJuristiction ? item.filingJuristiction : ""
          );
          const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));

          setJurisdiction(_uniqJurisdictions);
          custList = custList.map((ele) => {
            // const affectedCompaniesNames = ele.affectedCompanies.map(
            //   (company) => company.customerName
            // );
            //  ele.formattedAffectedCompany = affectedCompaniesNames;

            // ele.formattedAffectedCompany = ele.affectedCompanies.map(
            //   (company) => ({
            //     customerName: company.customerName,
            //     type: company.type, // Assuming 'type' property exists in 'company' object
            //     customerId: company.customerId, // Assuming 'customerId' property exists in 'company' object
            //     status: company.status, // Assuming 'status' property exists in 'company' object
            //   })
            // );

            // ele.fldAffectedCompany = ele.affectedCompanies
            //   .filter((item) => item.status === "Completed")
            //   .map((company) => ({
            //     name: company.customerName,
            //     code: company.customerId, // Assuming 'customerId' property exists in 'company' object
            //     status: company.status === "Completed",
            //   }));
            // let findParent;
            // if (
            //   ele.parentCustomer !== null &&
            //   ele.parentCustomer !== "" &&
            //   ele.parentCustomer !== 0
            // ) {
            //   findParent = ele.affectedCompanies.find(
            //     (item) => item.type === "Parent"
            //   );
            // } else {
            //   findParent = ele.affectedCompanies.find(
            //     (item) => item.type === "DefaultClient"
            //   );
            // }

            // let popupData = [...ele.affectedCompanies];
            // popupData.forEach(function (item, i) {
            //   if (findParent && findParent.customerId && item.customerId === findParent.customerId) {
            //     popupData.splice(i, 1);
            //     popupData.unshift(item);
            //   }
            // });

            // // Add findParent property to the current element
            // ele.parentAffectedCompany = findParent;

            let date = ele.dueDate;

            // let isParent = ele.staffAssigned && ele.staffAssigned.length > 0 ?
            //   ele.staffAssigned.some((staff) => staff.company === "Parent") : false

            ele.staffAssignedArray =
              ele.staffAssigned.length > 0
                ? ele.staffAssigned.map((ele) => ({
                  name: ele.userName
                    ? ele.userName.charAt(0).toUpperCase() +
                    ele.userName.slice(1)
                    : ele.name,
                  code: ele.userId ? ele.userId : ele.code,
                }))
                : ele.staffAssigned;

            // let internalDueDate =
            //   ele.dueDate !== null ? ele.dueDate.toISOString() : "";
            // let dueDateFiling =
            //   ele.filingDueDate !== null ? ele.filingDueDate.toISOString() : "";
            // console.log("##dueDate internal", internalDueDate, dueDateFiling);
            ele.internalDueDate =
              ele.dueDate !== null ? new Date(ele.dueDate) : null;
            ele.dueDateFiling =
              ele.filingDueDate !== null ? new Date(ele.filingDueDate) : null;

            const _stateList = getStateName(ele.filingStateInfo);
            const _staffassigned = _.map(ele.staffAssigned, "userName").join(
              ", "
            );
            const grantTermCompleteText = ele.grantTermComplete ? "Yes" : "No";
            const programName =
              ele.programInfo && ele.programInfo.length > 0
                ? ele.programInfo[0].programName
                : "";
            const awardTypeName =
              ele.awardType && ele.awardType.length > 0
                ? ele.awardType[0].awardTypeName
                : "";

            const awardingAgencyName =
              ele.awardingAgency && ele.awardingAgency.length > 0
                ? ele.awardingAgency[0].awardingAgencyName
                : "";
            const filingPeriods1 = ele.startdate ? new Date(ele.startdate) : "";
            const filingPeriods2 = ele.enddate ? new Date(ele.enddate) : "";

            const toLocalDateString = (date) => console.log("date", date);
            date.toLocaleDateString("en-US", {
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
            });

            const filingPeriod = `${toLocalDateString(
              filingPeriods1
            )} - ${toLocalDateString(filingPeriods2)}`;

            if (ele.filingJuristiction?.includes("Federal")) {
              let federalCategoriesVal;
              if (ele.recordType === "TrackNow") {
                const _categories = _.map(
                  ele.businessCategory,
                  "businessCategoryName"
                ).join(", ");

                //fedLookup.push(..._categories);
                federalCategoriesVal = _categories;
              } else {
                // fedLookup.push(...programName);
                federalCategoriesVal = programName;
              }
              return {
                ...ele,
                federalCategories: federalCategoriesVal,
                awardTypeName,
                awardingAgencyName,
                dueDate: date,
                stateList: _stateList,
                staffassigned: _staffassigned,
                filingPeriod,
                grantTermComplete: grantTermCompleteText,
                initialGrantTermComplete: grantTermCompleteText,
              };
            } else if (ele.filingJuristiction?.includes("Both")) {
              let stateCategoriesVal;
              if (ele.recordType === "TrackNow") {
                const categoriesState = ele.businessCategory.filter(
                  (ele) => ele.state === ele.filingStateInfo
                );

                const _categories = categoriesState
                  .map((ele) => ele.businessCategoryName)
                  .join(", ");

                stateCategoriesVal = _categories;
              } else {
                stateCategoriesVal = programName;
              }
              return {
                ...ele,
                stateCategories: stateCategoriesVal,
                federalCategories: stateCategoriesVal,
                awardTypeName,
                awardingAgencyName,
                dueDate: date,
                stateList: _stateList,
                staffassigned: _staffassigned,
                filingPeriod,
                grantTermComplete: grantTermCompleteText,
                initialGrantTermComplete: grantTermCompleteText,
              };
            } else {
              let stateCategoriesVal;
              if (ele.recordType === "TrackNow") {
                const categoriesState = ele.businessCategory.filter(
                  (ele) => ele.state === ele.filingStateInfo
                );

                const _categories = categoriesState
                  .map((ele) => ele.businessCategoryName)
                  .join(", ");

                stateCategoriesVal = _categories;
              } else {
                stateCategoriesVal = programName;
              }
              return {
                ...ele,
                stateCategories: stateCategoriesVal,
                awardTypeName,
                awardingAgencyName,
                dueDate: date,
                stateList: _stateList,
                staffassigned: _staffassigned,
                filingPeriod,
                grantTermComplete: grantTermCompleteText,
                initialGrantTermComplete: grantTermCompleteText,
              };
            }
          });
          if (isRowEdit === undefined || !isRowEdit) {
            setClientFilingHistory((old) => custList);
            // const trackNowExist = custList.find(
            //   (ele) => ele.recordType === "TrackNow"
            // );
            // const postAwardExist = custList.find(
            //   (ele) => ele.recordType === "PostAward"
            // );

            // if (trackNowExist) {
            //    setTrackNowVal(true);
            // }

            // if (postAwardExist) {
            //    setPostAwardVal(true);
            // }

            // if (trackNowExist && postAwardExist) {
            //   setCheckBoxDisabled(false);
            // } else {
            //   setCheckBoxDisabled(true);
            // }
          }
          setInitialClientFilingHistory((old) => custList);
          props.setClientFilingData((old) => custList);
          props.resetRefreshList();
        } catch (error) {
          console.error("fetchClientFilingTrackersHistory error", error);
        }
      } else {
      }
    } finally {
      setIsLoadingHistory(false);
    }
    // }
  };

  const upcomingDueDates = () => {
    try {
      const currentYear = new Date().getFullYear();
      const currentDate = new Date();
      //only current year
      const pendingClientFiling = initialValue.filter(
        (item) => item.status === "Pending"
      );
      let filteredDueDates = pendingClientFiling.filter((item) => {
        if (item.internalDueDate instanceof Date) {
          return item.internalDueDate.getFullYear() === currentYear;
        }
        return false;
      });

      let sortedRecords; // New variable to store the filtered records

      // Before End of Current Month
      if (options === "Before End of Current Month") {
        const lastDateOfCurrentMonth = new Date(
          currentYear,
          currentDate.getMonth() + 1,
          0
        );
        sortedRecords = filteredDueDates.filter((item) => {
          if (
            item.internalDueDate >= currentDate &&
            item.internalDueDate <= lastDateOfCurrentMonth
          ) {
            return true;
          }
          return false;
        });
      }
      // Within a Month
      else if (options === "Within a Month") {
        const next30Days = new Date(currentDate);
        next30Days.setDate(next30Days.getDate() + 30); // Get date 30 days from now
        sortedRecords = filteredDueDates.filter((item) => {
          return (
            item.internalDueDate >= currentDate &&
            item.internalDueDate <= next30Days
          );
        });
      }
      // Within 3 Months
      else if (options === "Within 3 Months") {
        const next90Days = new Date(currentDate);
        next90Days.setDate(next90Days.getDate() + 90); // Get date 90 days from now
        sortedRecords = filteredDueDates.filter((item) => {
          return (
            item.internalDueDate >= currentDate &&
            item.internalDueDate <= next90Days
          );
        });
      }
      // Within 6 Months
      else if (options === "Within 6 Months") {
        const next180Days = new Date(currentDate);
        next180Days.setDate(next180Days.getDate() + 180); // Get date 180 days from now
        sortedRecords = filteredDueDates.filter((item) => {
          return (
            item.internalDueDate >= currentDate &&
            item.internalDueDate <= next180Days
          );
        });
      } else if (options === "Before End of Current Year") {
        sortedRecords = filteredDueDates.filter((item) => {
          return item.internalDueDate >= currentDate;
        });
      }
      // Set the final result to setSortMaster

      setInitialValueUpc(sortedRecords);

      if (trackNowVal === true && postAwardVal === true) {
        // setTrackNowValUpc(true);
        // setPostAwardValUpc(true);
        setSortMaster(sortedRecords);
      } else {
        if (trackNowVal === true) {
          const trackNowExist = sortedRecords.filter(
            (ele) => ele.recordType === "TrackNow"
          );

          // setTrackNowValUpc(true);
          setSortMaster(trackNowExist);
        }
        if (postAwardVal === true) {
          const postAwardExist = sortedRecords.filter(
            (ele) => ele.recordType === "PostAward"
          );
          // setPostAwardValUpc(true);
          setSortMaster(postAwardExist);
        }
      }
    } catch (error) {
      console.error("errdue", error);
    }
  };

  const saveEditedField = async (selectedFiling) => {
    const utcDate = selectedFiling.dueDate.getFullYear
      ? new Date(
        Date.UTC(
          selectedFiling.dueDate.getFullYear(),
          selectedFiling.dueDate.getMonth(),
          selectedFiling.dueDate.getDate()
        )
      )
      : selectedFiling.dueDate;
    // utcDate.setMinutes(currTime.getMinutes());
    // utcDate.setSeconds(currTime.setSeconds());
    let payload = {
      ...selectedFiling,
      dueDate: utcDate,
      updateDate: new Date(),
      updateUser: authUser.userId + "",
    };
    // let payload = {
    //   fileTrackingId: selectedFiling.fileTrackingId,
    //   customerId: selectedFiling.customerId,
    //   filingId: selectedFiling.filingId,
    //   dueDate: utcDate,
    //   filingDueDate: selectedFiling.filingDueDate,
    //   status: selectedFiling.status,
    //   createDate: selectedFiling.createDate,
    //   createUser: selectedFiling.createUser,
    //   updateDate: new Date(),
    //   updateUser: authUser.userId + "",
    //   startdate: selectedFiling.startdate,
    //   enddate: selectedFiling.enddate,
    // };
    const res = await axios.put(
      `${API_BASE_URL}/Customer/CustomerFileTracking/${selectedFiling.fileTrackingId}`,
      payload
    );
    if (res.data.status === "Success") {
      setAlertMessage("Successfully updated the record");
      setShowAlert(true);
      // fetchClientFilingTrackers(clientId);
    } else {
      setAlertMessage("Unexpected error occurted while updating the record");
      setShowAlert(true);
    }
  };
  useEffect(() => {
    if (ClientFilingMasterLoaded) {
      // console.log("Show Table Data", ClientFilingTrackers)
    }
    //setIsLoading(true);
    //eslint-disable-next-line
  }, [ClientFilingMasterLoaded]);

  useEffect(() => {
    const activeClientId =
      clientId || props.selectedClientId || selectedCustomer?.customerId;
    if (activeClientId) {
      //fetchClientFilingTrackers(activeClientId);
      let _filters = { ...filters };
      if (search.current) {
        search.current.value = "";
      }
      _filters["global"].value = "";
      setFilters(_filters);
      setIsClearIcon(false);
      const staffList = userRoles
        .filter((ele) => {
          // if (ele.roleName === "Admin" || ele.roleName === "Admin-PostAward") {
          //   return ele;
          // } else
          if (parseInt(activeClientId) === ele.customerId) {
            return ele;
          }
        })

        // .map((ele) => ({
        //   name: ele.userName.charAt(0).toUpperCase() + ele.userName.slice(1),
        //   code: ele.userId,
        //   loginId: ele.loginId

        // }))
        .filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.userName === value.userName)
        );
      staffList.sort(function (a, b) {
        if (a.userName < b.userName) {
          return -1;
        }
        if (a.userName > b.userName) {
          return 1;
        }
        return 0;
      });
      console.log("#STAFFCHECK", staffList, "userRoles", userRoles, "clientId", activeClientId);

      console.log("fetchStaffAssigned staffList", staffList);
      setstaffAssignedList(staffList);
      if (props.setStaffList) {
        props.setStaffList(staffList);
      }
    }
  }, [clientId, props.selectedClientId, selectedCustomer?.customerId, userRoles]);

  useEffect(() => {
    if (selectedCustomer) {
      resetVirtualScrollerPosition();
      setFilterAnchorEl(null);
      setActiveFilters([]);
      setIsFilterChange([]);
      setGlobalFilterValue("");
      setFilters(getDefaultTrackerFilters());
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          resetVirtualScrollerPosition();
        });
      });
      console.log(
        "selectedCustomer refreshPage",
        selectedCustomer,
        value,
        refreshPageDetails
      );
      if (
        value === "1" &&
        selectedCustomer?.customerId &&
        !lazyLoading &&
        !refreshPageDetails.hasOwnProperty("recordsInView")
      ) {
        // fetchClientFilingTrackers(selectedCustomer.customerId);
        if (clientFiling.length > 0) {
          setRecordsInView(0);
          setIsLoading(true);
          setClientFiling([]);
          setInitialValue([]);
          props.setClientFilingData([]);
          setSelectedClientFiling([]);
          props.setSelectedFiling([]);
          setRefreshRecordList(true);
        } else {
          setIsLoading(true);
          setRecordsInView(0);
          setRefreshRecordList(true);
        }
      } else if (
        selectedCustomer?.customerId &&
        !lazyLoading &&
        !refreshPageDetails.hasOwnProperty("recordsInView")
      ) {
        // fetchClientFilingTrackersHistory();
        if (clientFilingHistory.length > 0) {
          setRecordsInView(0);
          setIsLoading(true);
          setClientFilingHistory([]);
          setInitialClientFilingHistory([]);
          props.setClientFilingData([]);
          setSelectedClientFiling([]);
          props.setSelectedFiling([]);
          setRefreshRecordList(true);
        } else {
          setIsLoading(true);
          setRecordsInView(0);
          setRefreshRecordList(true);
        }
      }
      fetchBusinessCategories();
      fetchAwardAgencies();
      fetchAwardType();
      console.log(
        "refreshPageDetails --@",
        refreshPageDetails,
        refreshPageDetails.hasOwnProperty("recordsInView")
      );
      if (refreshPageDetails.hasOwnProperty("recordsInView")) {
        console.log(
          "refreshPageDetails --@",
          refreshPageDetails.refreshDetails.clientSelected
        );
        props.resetKeepSelectedRecords(
          refreshPageDetails.refreshDetails.clientSelected
        );
        setRecordsInView(refreshPageDetails.recordsInView);
        setRefreshDetails(refreshPageDetails.refreshDetails);
        setRefreshRecordList(true);
        props.resetKeepPageDetails(false);
      }
    }
  }, [selectedCustomer]);

  useEffect(() => {
    fetchConfigs();
  }, []);
  useEffect(() => {
    if (value === "2" && selectedCustomer?.customerId && selectedYear) {
      // fetchClientFilingTrackersHistory()
      console.log("Year changed in history tab, fetching data for year:", selectedYear);
      setRecordsInView(0);
      setIsLoading(true);
      setClientFiling([]);
      setInitialValue([]);
      setClientFilingHistory([]);
      setInitialClientFilingHistory([]);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setFederalFilterSelectedValues([]);
      props.setClientFilingData([]);
      setSelectedClientFiling([]);
      setRefreshRecordList(true);
    }
  }, [selectedYear]);

  useEffect(() => {
    if (value === "2") {
      //passing selected year props to client tracker list
      props.setSelectedYear(selectedYear);
    }
  }, [selectedYear, value]);

  useEffect(() => {
    if (selectedCustomer) {
      resetVirtualScrollerPosition();
      if (value === "1") {
        // fetchClientFilingTrackers(selectedCustomer.customerId)
        setRecordsInView(0);
        setIsLoading(true);
        setClientFiling([]);
        setIsFilterChange([]);
        setSortingData({ sortBy: "", sortOrder: "" });
        setFederalFilterSelectedValues([]);
        setInitialValue([]);
        props.setClientFilingData([]);
        setSelectedClientFiling([]);
        props.setSelectedFiling([]);
        setRefreshRecordList(true);
      } else {
        // fetchClientFilingTrackersHistory()
        setRecordsInView(0);
        setIsLoading(true);
        setClientFilingHistory([]);
        setInitialClientFilingHistory([]);
        setIsFilterChange([]);
        setSortingData({ sortBy: "", sortOrder: "" });
        props.setClientFilingData([]);
        setSelectedClientFiling([]);
        props.setSelectedFiling([]);
        setRefreshRecordList(true);
      }
    }
  }, [value]);

  useEffect(() => {
    // console.log("selectedClientId", props.selectedClientId, selectedCustomer?.customerId)
    if (props.selectedClientId) {
      setClientId(() => props.selectedClientId);
      setSelectedClientFiling([]);
      props.setSelectedFiling([]);
      setFilterAnchorEl(null);
      setActiveFilters([]);
      setIsFilterChange([]);
      setGlobalFilterValue("");
      setFilters(getDefaultTrackerFilters());
    }

    console.log(
      "selectedCustomer refreshPage",
      selectedCustomer,
      refreshPageDetails
    );
    if (
      props.selectedClientId &&
      selectedCustomer?.customerId &&
      !lazyLoading &&
      !refreshPageDetails.hasOwnProperty("recordsInView")
    ) {
      setRecordsInView(0);
      setClientFiling([]);
      setInitialValue([]);
      setClientFilingHistory([]);
      setInitialClientFilingHistory([]);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setFederalFilterSelectedValues([]);
      setRecordTypeVal("");
      setupcomingDueDateVal("");
      setIsLoading(true);
      props.setClientFilingData([]);
      setSelectedClientFiling([]);
      props.setSelectedFiling([]);
      setDetailedViewVal(false);
      setRefreshRecordList(true);
    } else {
      setIsLoading(false);
    }
  }, [props.selectedClientId]);
  useEffect(() => {
    if (sortRecord === "Clear") {
      setSortMaster([]);
      setSortRecord("Upcoming Due Dates");
      props.setSortRecord("Upcoming Due Date");
      setMasterCatFilter([]);
      setFederalFilterSelectedValues([]);
      setOptions("");
    } else {
      setOptions("");
    }
  }, [props.selectedClientId]);

  useEffect(() => {
    if (props.refreshList && selectedCustomer?.customerId) {
      if (value === "1") {
        // fetchClientFilingTrackers(clientId);
        setIsLoading(true);
        setClientFiling([]);
        setInitialValue([]);
        props.setClientFilingData([]);
        setSelectedClientFiling([]);
        props.setSelectedFiling([]);
        setRefreshRecordList(true);
      } else {
        // fetchClientFilingTrackersHistory();
        setIsLoading(true);
        setClientFilingHistory([]);
        setInitialClientFilingHistory([]);
        props.setClientFilingData([]);
        setSelectedClientFiling([]);
        props.setSelectedFiling([]);
        setRefreshRecordList(true);
      }
      setSelectedClientFiling([]);
      props.setSelectedFiling([]);
    }
  }, [props.refreshList]);
  useEffect(() => {
    if (refreshTable) {
      const vScroll =
        value === "1"
          ? sortRecord === "Clear"
            ? dtUpcoming.current.getVirtualScroller()
            : dt.current.getVirtualScroller()
          : dtHistory.current.getVirtualScroller();

      let range = vScroll.getRenderedRange();
      console.log("refreshTable vScroll", vScroll, range);

      if (value === "1") {
        let pageInView;
        let noOfPages;
        if (clientFiling.length > 100) {
          pageInView = recordsInView - 2;
          noOfPages = 2;
        } else {
          pageInView = recordsInView - 1;
          noOfPages = 1;
        }
        let clientSelected = selectedClientFiling;
        console.log(
          "refreshTable clientSelected",
          selectedClientFiling,
          clientSelected
        );

        setRecordsInView(pageInView);
        setRefreshDetails({
          viewport: range.viewport,
          pageInView,
          noOfPages,
          clientSelected,
        });

        // fetchClientFilingTrackers(clientId);
        setIsLoading(true);
        setClientFiling([]);
        setInitialValue([]);
        props.setClientFilingData([]);
        setRefreshRecordList(true);
      } else {
        let pageInView;
        let noOfPages;
        if (clientFilingHistory.length > 100) {
          pageInView = recordsInView - 2;
          noOfPages = 2;
        } else {
          pageInView = recordsInView - 1;
          noOfPages = 1;
        }
        let clientSelected = selectedClientFiling;
        console.log(
          "refreshTable clientSelected",
          selectedClientFiling,
          clientSelected
        );

        setRecordsInView(pageInView);
        setRefreshDetails({
          viewport: range.viewport,
          pageInView,
          noOfPages,
          clientSelected,
        });
        // fetchClientFilingTrackersHistory();
        setIsLoading(true);
        setClientFilingHistory([]);
        setInitialClientFilingHistory([]);
        props.setClientFilingData([]);
        setRefreshRecordList(true);
      }
      handleRefreshTableReturn();
      // setSelectedClientFiling([]);
      // props.setSelectedFiling([]);
      // setCheckBoxDisabled(true);
    }
  }, [refreshTable]);

  useEffect(() => {
    // console.log("refreshPageDetails --@", refreshPageDetails, refreshPageDetails.hasOwnProperty("recordsInView"));
  }, [refreshPageDetails]);

  useEffect(() => {
    //eslint-disable-next-line
    console.log("ClientFilingTrackers", ClientFilingTrackers);

  }, [ClientFilingTrackers]);

  // useEffect(() => {
  //   downloadData(clientFiling);
  // }, [clientFiling]);
  useEffect(() => { }, [ClientFilingTrackersHistory]);
  useEffect(() => {

    if (props.clearSelectedRecords) {
      console.log("CLEAR SELECTED RECORDS", "Table uf", props.clearSelectedRecords);
      setSelectedClientFiling([]);
      props.setClearSelectedRecords(false);
    }

  }, [props.clearSelectedRecords])
  console.log("CLEAR SELECTED RECORDS", "SELECTEDCLIENTFILING ", selectedClientFiling);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const renderHeader = () => {
    return (
      <Grid container sx={{ my: 1, flexDirection: "column" }}>
        <Grid container sx={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", flexWrap: "nowrap", gap: 1 }}>
          <Typography
            variant="h6"
            noWrap
            sx={{
              fontWeight: 500,
              color: "inherit",
              textDecoration: "none",
            }}
          >
            {value === "1" && selectedCustomer
              ? `TRACK NOW CLIENT FILINGS (${totalRecords})`
              : value === "2" && selectedCustomer
                ? `TRACK NOW CLIENT FILING  (${totalRecords})`
                : "TRACK NOW CLIENT FILING (0)"}
          </Typography>
        </Grid>
        <Grid container sx={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", flexWrap: "nowrap", gap: 1, mt: 1 }}>
          <Grid sx={{ display: "flex", flexDirection: "column", gap: 1, minWidth: 0 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0 }}>
               <TrackNowButton
                variant="secondary"
                size="small"
                onClick={(e) => setFilterAnchorEl(e.currentTarget)}
                sx={{
                  fontSize: "12px",
                  padding: "4px 12px",
                  minHeight: "28px"
                }}
              >
                + Filter
              </TrackNowButton>
 
              {value === "1" &&
                selectedCustomer &&
                selectedCustomer?.clientType !== "SubChild" &&
                !selectedCustomer?.isOnlyParentFile && (selectedCustomer.bothChildAndSubChild || selectedCustomer.bothParentAndChild) && (
                  <FormControlLabel
                    value="top"
                    control={
                      <InputSwitch
                        checked={detailedViewVal}
                        disabled={
                          !selectedCustomer ||
                          (trackNowVal === false && postAwardVal === false)
                        }
                        onChange={() => handleDetailedViewChange()}
                      />
                    }
                    label="Detailed View"
                    labelPlacement="end"
                    sx={{ whiteSpace: "nowrap", margin: 0 }}
                  />
                )}
            </Box>
          </Grid>
          <Grid sx={{ display: "flex", flexDirection: "column", gap: 1, minWidth: 0 }}>
            <ClientTableFilter
              anchorEl={filterAnchorEl}
              onClose={() => setFilterAnchorEl(null)}
              hideTrackerStaffAssignedFilter={
                !selectedCustomer?.isOnlyChildFile &&
                !selectedCustomer?.isOnlyParentFile
              }
              onApply={(filterConfig) => {
                console.log('Filter applied:', filterConfig);
                setFilterAnchorEl(null);

                // Convert filter to API parameter format
                let filterChange = [];
                const { field, matchMode, value, matchModeLabel } = filterConfig;
                const nextActiveFilters = [
                  ...activeFilters.filter((item) => item.field !== field),
                  {
                    field,
                    label: getFilterChipLabel(field),
                    displayValue: getFilterChipValue(value),
                    matchMode,
                    value,
                  },
                ];
                setActiveFilters(nextActiveFilters);

                if (field === 'stateList') {
                  if (Array.isArray(value)) {
                    value.forEach((ele, i) => {
                      let changeItem = {
                        name: 'SearchByStateInfo',
                        val: getStateCode(ele),
                      };
                      if (i + 1 === value.length) {
                        changeItem.searchType = 'StateInfoSearchType';
                        changeItem.searchTypeVal = getSearchType(matchMode);
                      }
                      filterChange.push(changeItem);
                    });
                  } else {
                    filterChange.push({
                      name: 'SearchByStateInfo',
                      val: getStateCode(value),
                      searchType: 'StateInfoSearchType',
                      searchTypeVal: getSearchType(matchMode),
                    });
                  }
                } else if (field === 'filingJuristiction') {
                  filterChange.push({
                    name: 'SearchByJuristiction',
                    val: value,
                  });
                } else if (field === 'filingRequired') {
                  filterChange.push({
                    name: 'SearchByRequired',
                    val: value,
                  });
                } else if (field === 'awardTypeName') {
                  if (Array.isArray(value)) {
                    value.forEach((ele, i) => {
                      let changeItem = {
                        name: 'SearchByAwardType',
                        val: ele,
                      };
                      if (i + 1 === value.length) {
                        changeItem.searchType = 'AwardTypeSearchType';
                        changeItem.searchTypeVal = getSearchType(matchMode);
                      }
                      filterChange.push(changeItem);
                    });
                  } else {
                    filterChange.push({
                      name: 'SearchByAwardType',
                      val: value,
                      searchType: 'AwardTypeSearchType',
                      searchTypeVal: getSearchType(matchMode),
                    });
                  }
                } else if (field === 'awardingAgencyName') {
                  if (Array.isArray(value)) {
                    value.forEach((ele, i) => {
                      let changeItem = {
                        name: 'SearchByAwardAgency',
                        val: ele,
                      };
                      if (i + 1 === value.length) {
                        changeItem.searchType = 'AwardAgencySearchType';
                        changeItem.searchTypeVal = getSearchType(matchMode);
                      }
                      filterChange.push(changeItem);
                    });
                  } else {
                    filterChange.push({
                      name: 'SearchByAwardAgency',
                      val: value,
                      searchType: 'AwardAgencySearchType',
                      searchTypeVal: getSearchType(matchMode),
                    });
                  }
                } else if (field === 'federalCategories') {
                  if (Array.isArray(value)) {
                    value.forEach((ele, i) => {
                      let changeItem = {
                        name: 'SearchByWhoMustFileFederal',
                        val: ele,
                      };
                      if (i + 1 === value.length) {
                        changeItem.searchType = 'WhoMustFileFederalSearchType';
                        changeItem.searchTypeVal = getSearchType(matchMode);
                      }
                      filterChange.push(changeItem);
                    });
                  }
                } else if (field === 'stateCategories') {
                  if (Array.isArray(value)) {
                    value.forEach((ele, i) => {
                      let changeItem = {
                        name: 'SearchByWhoMustFileInState',
                        val: ele,
                      };
                      if (i + 1 === value.length) {
                        changeItem.searchType = 'WhoMustFileInStateSearchType';
                        changeItem.searchTypeVal = getSearchType(matchMode);
                      }
                      filterChange.push(changeItem);
                    });
                  }
                } else if (field === 'status') {
                  if (Array.isArray(value)) {
                    value.forEach((ele, i) => {
                      let changeItem = {
                        name: 'SearchByStatus',
                        val: ele,
                      };
                      if (i + 1 === value.length) {
                        changeItem.searchType = 'StatusSearchType';
                        changeItem.searchTypeVal = getSearchType(matchMode);
                      }
                      filterChange.push(changeItem);
                    });
                  } else {
                    filterChange.push({
                      name: 'SearchByStatus',
                      val: value,
                      searchType: 'StatusSearchType',
                      searchTypeVal: getSearchType(matchMode),
                    });
                  }
                } else {
                  // Generic field handling
                  const fieldName = field.charAt(0).toUpperCase() + field.slice(1);
                  filterChange.push({
                    name: `SearchBy${fieldName}`,
                    val: value,
                    searchType: `${fieldName}SearchType`,
                    searchTypeVal: getSearchType(matchMode),
                  });
                }

                const allFilterChanges = buildTrackerApiFilters(nextActiveFilters);
                console.log('Filter parameters:', allFilterChanges);
                handleSetFilterVariable(allFilterChanges);
              }}
              onClear={() => {
                console.log('Filter cleared');
                clearTrackerFilters();
              }}
              clients={[]}
              categoriesLookup={categoryList || []}
              programList={categoryList || []}
              stateList={stateList || []}
              tracknowlicenseTypes={[]}
              postawardlicenseTypes={[]}
              roleType={userRoles || []}
              trackerMode={true}
              requiredOnlyIs={true}
              statusLookup={statusLookup || []}
              jurisdictionLookup={jurisdictionLookup || []}
              awardAgenciesList={awardAgenciesList || []}
              awardTypeList={awardTypeList || []}
            />
          </Grid>
          <FormControl component="fieldset">
            <FormGroup aria-label="position" Column>
              <FormControlLabel
                value="top"
                control={
                  <Checkbox
                    name="trackNow"
                    checked={trackNowVal}
                    disabled={checkboxdisabled || checkboxdisabledTrackNow}
                    onClick={() =>
                      handleTrackPostChange(
                        "trackNow",
                        value === "2" && selectedCustomer
                      )
                    }
                    sx={{
                      color: primaryColor,
                      '&.Mui-checked': { color: primaryColor },
                      padding: '4px'
                    }}
                  />
                }
                label={<span style={{ color: trackNowVal ? "#4a4a4a" : "#9ca3af", fontWeight: 500, fontSize: '15px' }}>TrackNow</span>}
                labelPlacement="end"
                sx={{ margin: 0, marginBottom: '4px', whiteSpace: "nowrap" }}
              />
              <FormControlLabel
                value="top"
                control={
                  <Checkbox
                    name="postAward"
                    checked={postAwardVal}
                    disabled={checkboxdisabled || checkboxdisabledPostAward}
                    onClick={() =>
                      handleTrackPostChange(
                        "postAward",
                        value === "2" && selectedCustomer
                      )
                    }
                    sx={{
                      color: primaryColor,
                      '&.Mui-checked': { color: primaryColor },
                      padding: '4px'
                    }}
                  />
                }
                label={<span style={{ color: postAwardVal ? "#4a4a4a" : "#9ca3af", fontWeight: 500, fontSize: '15px' }}>PostAward</span>}
                labelPlacement="end"
                sx={{ margin: 0, whiteSpace: "nowrap" }}
              />
            </FormGroup>
          </FormControl>
          {value === "1" && (
            <Stack direction="column" spacing={1} sx={{ minWidth: 0 }}>
              <Button
                variant="contained"
                onClick={sortRecords}
                disabled={!options}
                sx={{
                  borderRadius: '24px',
                  height: '48px',
                  backgroundColor: primaryColor,
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '16px',
                  padding: '0 20px',
                  textTransform: 'none',
                  minWidth: 'fit-content',
                  width: 'fit-content',
                  '&:hover': {
                    backgroundColor: `color-mix(in srgb, ${primaryColor} 85%, black)`,
                    '& .arrow-icon': {
                      transform: 'rotate(-45deg)',
                    },
                  },
                  '&:disabled': {
                    backgroundColor: tokens.colors.grey,
                    color: 'white',
                  },
                }}
              >
                Upcoming Due Dates
                <Box
                  className="arrow-icon"
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    backgroundColor: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: '12px',
                    transition: 'transform 0.3s ease',
                  }}
                >
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6L10 6M10 6L7 3M10 6L7 9" stroke={primaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Box>
              </Button>

              <FormControl
                disabled={!props.selectedClientId}
                sx={{ minWidth: "14rem" }}
                size="small"
              >
                <InputLabel id="demo-select-small-label">
                  Select Filing Due
                </InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={options}
                  label="Select Filing Due"
                  onChange={handleChange}
                  sx={{
                    maxWidth: "14rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {yearsOption.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          )}
          {value === "2" && (
            <FormControl sx={{ minWidth: 120 }} size="small">
              <InputLabel id="demo-select-small-label">Year</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={selectedYear}
                label="Year"
                onChange={handleYearChange}
              >
                {yearsList.map((year) => (
                  <MenuItem value={year} key={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <TextField
            inputRef={search}
            placeholder='Search Filing Name...'
            size='small'
            sx={{
              width: 280,
              minWidth: 200,
              "& .MuiOutlinedInput-root": {
                borderRadius: "999px",
                backgroundColor: tokens.colors.offWhite,
                fontFamily: "Area Normal, Inter, sans-serif",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: `${primaryColor}55`,
              },
              "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: `${primaryColor}88`,
              },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: primaryColor,
                borderWidth: "1px",
              },
              "& .MuiInputBase-input": {
                py: "11px",
                px: "14px",
                fontSize: "15px",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={applyGlobalFilter} edge='end' size='small'>
                    {isClearIcon ? (
                      <ClearIcon sx={{ color: primaryColor }} />
                    ) : (
                      <SearchIcon sx={{ color: primaryColor }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        {activeFilters.length > 0 && (
          <Grid container sx={{ mt: 1 }}>
            <Grid sx={{ width: "100%", minWidth: 0 }}>
              {renderTrackerFilterChips()}
            </Grid>
          </Grid>
        )}
      </Grid>
    );
  };


  const handleCommentClick = (rowData) => {
    const rowDataArr = Array.isArray(rowData) ? rowData : [rowData];
    console.log(
      "Indicator Icon Comments rowwdata",
      rowData,
      "rowDataArr",
      rowDataArr
    );
    displayComments(rowData);
    setSelectedClientFiling(rowDataArr);
    props.setSelectedFiling(rowDataArr);
  };

  const handleAttachmentsClick = (rowData) => {
    const rowDataArr = Array.isArray(rowData) ? rowData : [rowData];
    console.log(
      "Indicator Icon attachment rowwdata",
      rowData,
      "rowDataArr",
      rowDataArr
    );
    displayAttachments(rowData);
    setSelectedClientFiling(rowDataArr);
    props.setSelectedFiling(rowDataArr);
  };
  const handleRefDocClick = (rowData) => {
    const rowDataArr = Array.isArray(rowData) ? rowData : [rowData];
    console.log(
      "Indicator Icon Docs rowwdata",
      rowData,
      "rowDataArr",
      rowDataArr
    );
    displayDocuments(rowData);
    setSelectedClientFiling(rowDataArr);
    props.setSelectedFiling(rowDataArr);
  };

  const activePermissionClientId =
    clientId || props.selectedClientId || selectedCustomer?.customerId;

  const hasChangeStatusPermission = usePermission(
    "ClientFilingList",
    "changeStatus",
    activePermissionClientId
  );

  const hasChangeGrantTermcompletePermission = usePermission(
    "ClientFilingList",
    "changeGrantTermcomplete",
    activePermissionClientId
  );

  const hasStaffAssignedPermission = usePermission(
    "ClientFilingList",
    "changeStaff",
    activePermissionClientId
  );

  const canEditStaffAssigned =
    hasStaffAssignedPermission && (!isDetailedViewAvailable || detailedViewVal);

  const hasChangeDueDatePermission = usePermission(
    "ClientFilingList",
    "changeStatusAndDueDate",
    activePermissionClientId
  );

  const TrackClientComment = ({ rowData }) => {
    const isPermissionEnabled = usePermission(
      "ClientFilingList",
      "comments",
      props.selectedClientId
    );

    const hasComments = rowData.hasComments === true || rowData.hasComments === 1 || rowData.hasComments === '1';
    const isActive = hasComments && isPermissionEnabled;
    const isDisabled = !isActive;

    return (
      <IconButton
        disabled={!isActive}
        onClick={() => handleCommentClick(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          minWidth: 28,
          minHeight: 28,
          mr: 0.5,
          pointerEvents: isDisabled ? 'none' : 'auto',
          cursor: isDisabled ? 'default' : 'pointer',
          backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)' : 'transparent',
          '&:hover': {
            backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 20%, white)' : 'transparent',
          },
          '&.Mui-disabled': {
            backgroundColor: 'transparent',
          }
        }}
      >
        <GoogleMaterialIcon name="comment" size={20} color={isActive ? primaryColor : tokens.colors.grey} />
      </IconButton>
    );
  };
  const TrackClientAttachment = ({ rowData }) => {
    const isPermissionEnabled = usePermission(
      "ClientFilingList",
      "viewFinalAttachment",
      props.selectedClientId
    );

    const hasAttachments = rowData.hasAttachments === true || rowData.hasAttachments === 1 || rowData.hasAttachments === '1';
    const isActive = hasAttachments && isPermissionEnabled;
    const isDisabled = !isActive;

    return (
      <IconButton
        disabled={!isActive}
        onClick={() => handleAttachmentsClick(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          minWidth: 28,
          minHeight: 28,
          mr: 0.5,
          pointerEvents: isDisabled ? 'none' : 'auto',
          cursor: isDisabled ? 'default' : 'pointer',
          backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)' : 'transparent',
          '&:hover': {
            backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 20%, white)' : 'transparent',
          },
          '&.Mui-disabled': {
            backgroundColor: 'transparent',
          }
        }}
      >
        <GoogleMaterialIcon name="attach_file" size={20} color={isActive ? primaryColor : tokens.colors.grey} />
      </IconButton>
    );
  };
  const TrackClientRefDocs = ({ rowData }) => {
    const isPermissionEnabled = usePermission(
      "ClientFilingList",
      "masterFilingRefDoc",
      props.selectedClientId
    );

    const hasReference = rowData.hasReference === true || rowData.hasReference === 1 || rowData.hasReference === '1';
    const isActive = hasReference && isPermissionEnabled;
    const isDisabled = !isActive;

    return (
      <IconButton
        disabled={!isActive}
        onClick={() => handleRefDocClick(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          minWidth: 28,
          minHeight: 28,
          pointerEvents: isDisabled ? 'none' : 'auto',
          cursor: isDisabled ? 'default' : 'pointer',
          backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)' : 'transparent',
          '&:hover': {
            backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 20%, white)' : 'transparent',
          },
          '&.Mui-disabled': {
            backgroundColor: 'transparent',
          }
        }}
      >
        <GoogleMaterialIcon name="snippet_folder" size={20} color={isActive ? primaryColor : tokens.colors.grey} />
      </IconButton>
    );
  };

  const upcomingOptionVal = [
    { name: "", val: "" },
    { name: "Before End of Current Month", val: "BeforeEndofCurrentMonth" },
    { name: "Within a Month", val: "WithinMonth" },
    { name: "Within 3 Months", val: "Within3Month" },
    { name: "Within 6 Months", val: "Within6Month" },
    { name: "Before End of Current Year", val: "BeforeEndofCurrentYear" },
  ];

  const getUpcomingOption = (matchMode) => {
    // console.log("getSearchType props", matchMode);
    return upcomingOptionVal.find((ele) => ele.name === matchMode).val;
  };

  const sortRecords = () => {
    console.log("sortRecords clicked!", sortRecord, options);
    if (sortRecord === "Upcoming Due Dates") {
      setSortRecord("Clear");
      setViewAll(false);
      props.setSortRecord("Clear");
      let _filters = { ...filters };
      search.current.value = "";
      _filters["global"].value = "";
      setFilters(_filters);
      setIsClearIcon(false);
      // upcomingDueDates();
      setRecordsInView(0);
      setIsLoading(true);
      setClientFiling([]);
      setInitialValue([]);
      setClientFilingHistory([]);
      setInitialClientFilingHistory([]);
      props.setClientFilingData([]);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setIsClearIcon(false);
      setMasterCatFilter([]);
      setUpcomingCatFilter([]);
      setFederalFilterSelectedValues([]);
      setSelectedClientFiling([]);
      props.setSelectedFiling([]);
      let upcomingOption = getUpcomingOption(options);
      console.log("upcomingOption", upcomingOption);
      setupcomingDueDateVal(upcomingOption);
      setRefreshRecordList(true);
      if (
        recordTypeVal !== "" &&
        ((trackNowVal && !postAwardVal) || (!trackNowVal && postAwardVal))
      ) {
        setTrackNowValUpc(trackNowVal);
        setPostAwardValUpc(postAwardVal);
      }
    } else if (sortRecord === "Clear") {
      setViewAll(false);
      let _filters = { ...filters };
      search.current.value = "";
      _filters["global"].value = "";
      setFilters(_filters);
      setIsClearIcon(false);
      if (
        recordTypeVal !== "" &&
        ((trackNowValUpc && !postAwardValUpc) ||
          (!trackNowValUpc && postAwardValUpc))
      ) {
        setTrackNowVal(trackNowValUpc);
        setPostAwardVal(postAwardValUpc);
      }
      setTrackNowValUpc(false);
      setPostAwardValUpc(false);
      setcheckboxdisabledTrackNowUpc(true);
      setcheckboxdisabledPostAwardUpc(true);
      setSortMaster([]);
      setSortRecord("Upcoming Due Dates");
      props.setSortRecord("Upcoming Due Date");
      setMasterCatFilter([]);
      setUpcomingCatFilter([]);
      setFederalFilterSelectedValues([]);
      setSelectedClientFiling([]);
      props.setSelectedFiling([]);
      setRecordsInView(0);
      setIsLoading(true);
      setClientFiling([]);
      setInitialValue([]);
      setClientFilingHistory([]);
      setInitialClientFilingHistory([]);
      props.setClientFilingData([]);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setupcomingDueDateVal("");
      setRefreshRecordList(true);
    }
  };
  const header = renderHeader();
  const federalFilterElement = (options, field) => {
    console.log(
      "federalFilterElement",
      options,
      field,
      federalFilterSelectedValues
    );
    // let optionsList = [];
    // data
    //   .map((item) => item[field])
    //   .filter(Boolean)
    //   .map((item) => {
    //     if (item.includes(",")) {
    //       //console.log("spliited_item", item);
    //       item.split(",").map((subItem) => {
    //         optionsList.push(subItem && subItem.trim());
    //       });
    //     } else {
    //       optionsList.push(item.trim());
    //     }
    //   });
    // optionsList = optionsList
    //   .filter((item, i) => {
    //     return i === optionsList.lastIndexOf(item);
    //   })
    //   .sort();

    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={federalFilterSelectedValues[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, [field]: e.value };
          });
          // let values = [];

          // data.forEach((item) => {
          //   if (e.value.some((category) => item[field]?.includes(category))) {
          //     values.push(item[field]);
          //   }
          // });
          // values = values.filter((item, i) => {
          //   return i === values.lastIndexOf(item);
          // });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={federalFilterSelectedValues[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];

          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const upcomingCategoryFilter = (options, field) => {
    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={upcomingCatFilter[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setUpcomingCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={upcomingCatFilter[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setUpcomingCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];

          if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };
  const renderDueHeader = () => {
    return (
      <Grid container spacing={1} sx={{ mb: 2, background: tokens.colors.offWhite, p: 2, px: 1, borderRadius: '8px' }}>
        <Grid xs={12} sx={{ display: "flex", alignItems: "center", gap: 1, pl: 2, mb: 1 }}>
          <GoogleMaterialIcon name="arrow_back_ios_new" sx={{ marginRight: "10px", cursor: "pointer" }} onClick={sortRecords} />
          <Typography variant="h6" noWrap component="div" sx={{ fontWeight: 400, color: "inherit", textDecoration: "none", display: "flex", alignItems: "center", gap: 1 }}>
            UPCOMING DUE DATES ({totalRecords})
            {options && (<span style={{ fontWeight: 500, fontSize: '1rem', marginLeft: '8px' }}>- {options}</span>)}
          </Typography>
        </Grid>
        <Grid xs={12} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, flexWrap: "nowrap" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Button onClick={(e) => setFilterAnchorEl(e.currentTarget)} sx={{ borderRadius: '24px', height: '48px', backgroundColor: primaryColor, color: 'white', fontWeight: 700, fontSize: '16px', padding: '0 20px', textTransform: 'none', minWidth: 'fit-content', width: 'fit-content', '&:hover': { backgroundColor: `color-mix(in srgb, ${primaryColor} 85%, black)` } }}>+ Filter</Button>
              {selectedCustomer && selectedCustomer?.clientType !== "SubChild" && !selectedCustomer?.isOnlyParentFile && (
                <FormControlLabel control={<InputSwitch checked={detailedViewVal} disabled={!selectedCustomer || (trackNowValUpc === false && postAwardValUpc === false)} onChange={() => handleDetailedViewChange()} />} label="Detailed View" labelPlacement="end" sx={{ margin: 0 }} />)}
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FormControlLabel control={<Checkbox name="trackNow" checked={trackNowValUpc} disabled={checkboxdisabled || checkboxdisabledTrackNowUpc} onClick={() => handleTrackPostChangeUc("trackNow")} sx={{ color: primaryColor, '&.Mui-checked': { color: primaryColor }, padding: '4px' }} />} label={<span style={{ color: trackNowValUpc ? "#4a4a4a" : "#9ca3af", fontWeight: 500, fontSize: '15px' }}>TrackNow</span>} sx={{ margin: 0 }} />
              <FormControlLabel control={<Checkbox name="postAward" checked={postAwardValUpc} disabled={checkboxdisabled || checkboxdisabledPostAwardUpc} onClick={() => handleTrackPostChangeUc("postAward")} sx={{ color: primaryColor, '&.Mui-checked': { color: primaryColor }, padding: '4px' }} />} label={<span style={{ color: postAwardValUpc ? "#4a4a4a" : "#9ca3af", fontWeight: 500, fontSize: '15px' }}>PostAward</span>} sx={{ margin: 0 }} />
            </Box>
            <Button variant="contained" onClick={sortRecords} sx={{ borderRadius: '24px', height: '48px', backgroundColor: primaryColor, color: 'white', fontWeight: 700, fontSize: '16px', padding: '0 20px', textTransform: 'none', minWidth: 'fit-content', width: 'fit-content', '&:hover': { backgroundColor: `color-mix(in srgb, ${primaryColor} 85%, black)`, '& .arrow-icon': { transform: 'rotate(-45deg)' } } }}>
              Clear
              <Box className="arrow-icon" sx={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '12px', transition: 'transform 0.3s ease' }}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6L10 6M10 6L7 3M10 6L7 9" stroke={primaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
              </Box>
            </Button>
            <TextField
              inputRef={search}
              placeholder='Search Filing Name...'
              size='small'
              sx={{
                width: 280,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "999px",
                  backgroundColor: tokens.colors.offWhite,
                  fontFamily: "Area Normal, Inter, sans-serif",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${primaryColor}55`,
                },
                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${primaryColor}88`,
                },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: primaryColor,
                  borderWidth: "1px",
                },
                "& .MuiInputBase-input": {
                  py: "11px",
                  px: "14px",
                  fontSize: "15px",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton onClick={applyGlobalFilter} edge='end' size='small'>
                      {isClearIcon ? (
                        <ClearIcon sx={{ color: primaryColor }} />
                      ) : (
                        <SearchIcon sx={{ color: primaryColor }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
        {activeFilters.length > 0 && (
          <Grid xs={12} sx={{ mt: 1 }}>
            {renderTrackerFilterChips()}
          </Grid>
        )}
        <ClientTableFilter anchorEl={filterAnchorEl} onClose={() => setFilterAnchorEl(null)} hideTrackerStaffAssignedFilter={selectedCustomer?.clientType === "Parent" || selectedCustomer?.clientType === "Child"} onApply={(filterConfig) => {
          console.log('Filter applied:', filterConfig);
          setFilterAnchorEl(null);

          // Convert filter to API parameter format
          let filterChange = [];
          const { field, matchMode, value, matchModeLabel } = filterConfig;
          const nextActiveFilters = [
            ...activeFilters.filter((item) => item.field !== field),
            {
              field,
              label: getFilterChipLabel(field),
              displayValue: getFilterChipValue(value),
              matchMode,
              value,
            },
          ];
          setActiveFilters(nextActiveFilters);

          if (field === 'stateList') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = {
                  name: 'SearchByStateInfo',
                  val: getStateCode(ele),
                };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'StateInfoSearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            } else {
              filterChange.push({
                name: 'SearchByStateInfo',
                val: getStateCode(value),
                searchType: 'StateInfoSearchType',
                searchTypeVal: getSearchType(matchMode),
              });
            }
          } else if (field === 'filingJuristiction') {
            filterChange.push({
              name: 'SearchByJuristiction',
              val: value,
            });
          } else if (field === 'filingRequired') {
            filterChange.push({
              name: 'SearchByRequired',
              val: value,
            });
          } else if (field === 'awardTypeName') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = {
                  name: 'SearchByAwardType',
                  val: ele,
                };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'AwardTypeSearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            } else {
              filterChange.push({
                name: 'SearchByAwardType',
                val: value,
                searchType: 'AwardTypeSearchType',
                searchTypeVal: getSearchType(matchMode),
              });
            }
          } else if (field === 'awardingAgencyName') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = {
                  name: 'SearchByAwardAgency',
                  val: ele,
                };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'AwardAgencySearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            } else {
              filterChange.push({
                name: 'SearchByAwardAgency',
                val: value,
                searchType: 'AwardAgencySearchType',
                searchTypeVal: getSearchType(matchMode),
              });
            }
          } else if (field === 'federalCategories') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = {
                  name: 'SearchByWhoMustFileFederal',
                  val: ele,
                };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'WhoMustFileFederalSearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            }
          } else if (field === 'stateCategories') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = {
                  name: 'SearchByWhoMustFileInState',
                  val: ele,
                };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'WhoMustFileInStateSearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            }
          } else if (field === 'status') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = {
                  name: 'SearchByStatus',
                  val: ele,
                };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'StatusSearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            } else {
              filterChange.push({
                name: 'SearchByStatus',
                val: value,
                searchType: 'StatusSearchType',
                searchTypeVal: getSearchType(matchMode),
              });
            }
          } else {
            // Generic field handling
            const fieldName = field.charAt(0).toUpperCase() + field.slice(1);
            filterChange.push({
              name: `SearchBy${fieldName}`,
              val: value,
              searchType: `${fieldName}SearchType`,
              searchTypeVal: getSearchType(matchMode),
            });
          }

          const allFilterChanges = buildTrackerApiFilters(nextActiveFilters);
          console.log('Filter parameters:', allFilterChanges);
          handleSetFilterVariable(allFilterChanges);
        }} onClear={() => {
          clearTrackerFilters();
        }} clients={[]} categoriesLookup={categoryList || []} programList={categoryList || []} stateList={stateList || []} tracknowlicenseTypes={[]} postawardlicenseTypes={[]} roleType={userRoles || []} trackerMode={true} requiredOnlyIs={true} statusLookup={statusLookup || []} jurisdictionLookup={jurisdictionLookup || []} awardAgenciesList={awardAgenciesList || []} awardTypeList={awardTypeList || []} />
      </Grid>
    );
  };

  const headerDue = renderDueHeader();
  // const selectFilingRecord = (value) => {
  //   setSelectedClientFiling(value);
  //   props.setSelectedFiling(value);
  // };
  const selectFilingRecord = (value) => {
    const selectedRows = Array.isArray(value) ? value : [value];
    setSelectedClientFiling(selectedRows);
    props.setSelectedFiling(selectedRows);
  };
  const rowClass = (data) => {
    return {
      "completed-row": data.status === "Completed",
    };
  };
  // const ct = useRef(null)
  const dt = useRef(null);

  const dtHistory = useRef(null);
  const dtUpcoming = useRef(null);
  const closeRowEditing = () => {
    // if (dt.current) {
    // console.log("dt", dt);
    // dt.current.clearState();
    // dt.current.reset();
    // console.log("closeRowEditing initialOptions", initialOptions);
    setIsDenied(true);
    //cellStatusEditor(initialOptions, true)
    setIsStatusChangeOk(false);
    setIsStatusColumnChange(false);
    setSelectedValues([]);
    setShowInfo(false);
    //}
  };

  const tableRef = useRef(null);
  const pageSize = 100;

  const resetVirtualScrollerPosition = () => {
    const tables = [dt.current, dtUpcoming.current, dtHistory.current];

    tables.forEach((table) => {
      const vScroll = table?.getVirtualScroller?.();
      const scrollElement = vScroll?.getElementRef?.()?.current;

      if (scrollElement) {
        scrollElement.scrollTop = 0;
        scrollElement.scrollLeft = 0;
      }

      if (typeof vScroll?.scrollToIndex === "function") {
        vScroll.scrollToIndex(0);
      } else if (typeof vScroll?.scrollInView === "function") {
        vScroll.scrollInView(0);
      }
    });
  };

  const scrollToSelected = () => {
    console.log("scrollToSelected vScroll", refreshDetails);
    if (
      refreshDetails?.viewport &&
      refreshDetails?.noOfPages &&
      clientFiling.length > 0
    ) {
      setSelectedClientFiling(refreshDetails.clientSelected);
      props.setSelectedFiling(refreshDetails.clientSelected);
      const vScroll =
        value === "1"
          ? sortRecord === "Clear"
            ? dtUpcoming.current.getVirtualScroller()
            : dt.current.getVirtualScroller()
          : dtHistory.current.getVirtualScroller();
      console.log("scrollToSelected vScroll", vScroll, refreshDetails);
      vScroll.scrollInView(refreshDetails.viewport.first);
      setRefreshDetails(null);
    }
  };

  // lazy load function
  const loadDataLazy = async (event) => {
    console.log("loadDataLazy props", recordsInView, event);

    //Virtual scroll callback

    const vScroll =
      value === "1"
        ? sortRecord === "Clear"
          ? dtUpcoming.current.getVirtualScroller()
          : dt.current.getVirtualScroller()
        : dtHistory.current.getVirtualScroller();
    if (!vScroll?.getRenderedRange) {
      return;
    }

    let range = vScroll.getRenderedRange();
    let { first, last } = range.viewport;
    console.log("loadDataLazy vScroll", vScroll, range.viewport);

    let firstVal = recordsInView * pageSize;
    let tableList = value === "2" ? clientFilingHistory : clientFiling;
    console.log(
      "loadDataLazy totalRecords",
      firstVal,
      totalRecords,
      lazyLoading,
      tableList.length
    );

    console.log(
      "loadDataLazy scroll check:",
      "first:",
      first,
      "tableList.length:",
      tableList.length,
      "threshold:",
      tableList.length - pageSize / 5,
      "firstVal:",
      firstVal,
      "totalRecords:",
      totalRecords,
      "lazyLoading:",
      lazyLoading
    );

    if (
      firstVal < totalRecords &&
      first > tableList.length - pageSize / 5 &&
      !lazyLoading
    ) {
      //scroll down
      // setIsLoading(true);
      setLazyLoading(true);
      let lastVal = firstVal + pageSize;
      console.log("loadDataLazy d firstVal", firstVal, lastVal);

      //get next data
      let records = await loadRecordsList(firstVal, lastVal, "down");
      console.log("loadDataLazy d record", records);
      if (records) {
        console.log("loadDataLazy d scrollInView", recordsInView * 100);

        //scroll to next records
        vScroll.scrollInView(recordsInView * 100);
        setRecordsInView((old) => old + 1);
        setLazyLoading(false);
        setIsLoading(false);
      }
    } else if (last < pageSize / 5 && recordsInView > 1 && !lazyLoading) {
      // scroll up
      let firstVal = (recordsInView - 3) * pageSize;
      let lastVal = firstVal + pageSize;
      if (firstVal >= 0) {
        // setIsLoading(true);
        setLazyLoading(true);
        // console.log("loadDataLazy u firstVal", firstVal, lastVal);

        //get prev data
        let records = await loadRecordsList(firstVal, lastVal, "up");
        // console.log("loadDataLazy u record", records);
        if (records) {
          // console.log("loadDataLazy u scrollInView", (recordsInView - 3) * 100);

          //scroll to prev records - scroll to middle to prevent immediate re-trigger
          vScroll.scrollToIndex(pageSize * 1.5);
          setRecordsInView((old) => old - 1);
          setLazyLoading(false);
          setIsLoading(false);
        }
      }
    }
  };

  // api call for lazy load
  const loadRecordsList = async (first, last, direction) => {
    // console.log("loadRecordsList props", first, last, direction);
    setIsLoading(true);
    let url;
    if (detailedViewVal) {
      url = `${API_BASE_URL}/Customer/CustomerFileTrackingbyCustomerIdAndDetailedView?CustomerId=${selectedCustomer.customerId
        }&StartRow=${first + 1}&EndRow=${last}`;
    } else {
      url = `${API_BASE_URL}/Customer/CustomerFileTrackingbyCustomerIdAndPagination?CustomerId=${selectedCustomer.customerId
        }&StartRow=${first + 1}&EndRow=${last}`;
    }

    console.log("loadRecordsList recordTypeVal", recordTypeVal);
    if (recordTypeVal !== "") {
      url = `${url}&RecordType=${recordTypeVal}`;
    }

    console.log("loadRecordsList selectedYear", value, selectedYear);
    if (value === "2" && selectedYear !== "") {
      url = `${url}&Year=${selectedYear}`;
    }

    console.log("loadRecordsList upcomingDueDate", upcomingDueDateVal);
    if (upcomingDueDateVal !== "") {
      url = `${url}&UpcomingDuedateSearchType=${upcomingDueDateVal}`;
    }

    // console.log("loadRecordsList fliter/sort", isFilterChange, sortingData);
    if (isFilterChange !== undefined && isFilterChange.length > 0) {
      // url filter parameters
      isFilterChange.forEach((ele) => {
        url = `${url}&${ele.name}=${ele.val}${ele.searchType ? `&${ele.searchType}=${ele.searchTypeVal}` : ``
          }`;
      });
    }

    if (
      sortingData &&
      typeof sortingData === "object" &&
      sortingData.sortBy !== "" &&
      sortingData.sortOrder !== ""
    ) {
      // url sort parameters
      let sortParameter = getSortData(sortingData.sortBy);
      console.log("getSortData", sortParameter);
      let order = sortingData.sortOrder === 1 ? "Ascending" : "Descending";

      url = `${url}&${sortParameter.SortByParameter}=${sortParameter.SortByVal}&${sortParameter.SortOrderParameter}=${order}`;
    }

    // console.log("loadRecordsList url", url);
    try {
      //get data
      const res = await axios.get(url);
      // console.log("loadRecordsList res", res.data);

      if (res.data) {
        setIsLoading(true);
        let ogList;
        if (value === "2" && selectedYear !== "") {
          ogList = clientFilingHistory.map((ele) => ele);
        } else {
          ogList = clientFiling.map((ele) => ele);
        }
        let list = await modifyList(res.data.data.items, direction, ogList);
        setTotalRecords(res.data.data.totalItems);

        console.log(
          "loadRecordsList trackNow/postAward",
          res.data.data,
          recordTypeVal,
          isFilterChange,
          isFilterChange.length <= 0,
          sortingData,
          sortingData.sortBy === ""
        );

        if (
          recordTypeVal === "" &&
          isFilterChange &&
          isFilterChange.length <= 0 &&
          sortingData &&
          sortingData.sortBy === ""
        ) {
          if (sortRecord === "Clear") {
            setTrackNowValUpc(res.data.data.trackNow);
            setPostAwardValUpc(res.data.data.postAward);
            if (
              res.data.data.trackNow === true &&
              res.data.data.postAward === true
            ) {
              setCheckBoxDisabled(false);
              setcheckboxdisabledTrackNowUpc(false);
              setcheckboxdisabledPostAwardUpc(false);
            } else {
              setCheckBoxDisabled(true);
              setcheckboxdisabledTrackNowUpc(true);
              setcheckboxdisabledPostAwardUpc(true);
            }
          } else {
            setTrackNowVal(res.data.data.trackNow);
            setPostAwardVal(res.data.data.postAward);
            if (
              res.data.data.trackNow === true &&
              res.data.data.postAward === true
            ) {
              setCheckBoxDisabled(false);
            } else {
              setCheckBoxDisabled(true);
            }
          }
        }

        // setRefreshDetails(null)
        return list;
      } else {
        return false;
      }
    } catch (err) {
      // console.log("loadRecordsList err", err);
    }
  };

  //maping records for lazy load
  const modifyList = (list, direction, ogList) => {
    //console.log("modifyList", list, direction);
    try {
      if (list.length > 0) {
        //list has data

        let fedLookup = [];
        let awardAgencyLookup = [];
        let awardTypeLookup = [];
        //let stateCatLookup = [];
        // setFederalFilterSelectedValues([]);
        const addLookupValues = (lookup, rawValue) => {
          if (rawValue === null || rawValue === undefined) {
            return;
          }

          const values = Array.isArray(rawValue) ? rawValue : [rawValue];
          values.forEach((item) => {
            if (typeof item !== "string") {
              return;
            }
            item
              .split(",")
              .map((value) => value.trim())
              .filter(Boolean)
              .forEach((value) => lookup.push(value));
          });
        };

        let updCustomers = list.map((item, i) => {
          // console.log(`Customer filing M...`, item);
          //console.log("Orig DueDate...", item.dueDate);

          const grantTermCompleteText = item.grantTermComplete ? "Yes" : "No";
          const dueDateFormatted = toLocalTime(item.dueDate);
          const dueDateFilingFormatted = toLocalTime(item.filingDueDate);
          const dueDate = item.dueDate ? item.dueDate : item.filingDueDate;
          // console.log("Local DueDate...", dueDateFormatted);
          const dueDateUTC = new Date(item.dueDate);
          // console.log("Local dueDateUTC...", dueDateUTC);

          const _stateList = getStateName(item.filingStateInfo);
          const programName =
            item.programInfo && item.programInfo.length > 0
              ? item.programInfo[0].programName
              : "";
          const programId =
            item.programInfo && item.programInfo.length > 0
              ? item.programInfo[0].programId
              : "";
          const awardTypeName =
            item.awardType && item.awardType.length > 0
              ? item.awardType[0].awardTypeName
              : "";

          const awardingAgencyName =
            item.awardingAgency && item.awardingAgency.length > 0
              ? item.awardingAgency[0].awardingAgencyName
              : "";
          const filingPeriods1 = item.startdate ? new Date(item.startdate) : "";
          const filingPeriods2 = item.enddate ? new Date(item.enddate) : "";

          const toLocalDateString = (date) =>
            date.toLocaleDateString("en-US", {
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
            });

          const filingPeriod = `${toLocalDateString(
            filingPeriods1
          )} - ${toLocalDateString(filingPeriods2)}`;

          // setPostAwardAgencyarray([...postawardagencyArray,awardingAgencyName])
          const _staffassigned = _.map(item.staffAssigned, "userName").join(
            ", "
          );
          // allCats.push(..._categories);
          //TOCHECK
          //.join(", ");

          if (
            !awardAgencyLookup.includes(awardingAgencyName) &&
            awardingAgencyName !== ""
          ) {
            awardAgencyLookup.push(awardingAgencyName);
          }
          if (
            !awardTypeLookup.includes(awardTypeName) &&
            awardTypeName !== ""
          ) {
            awardTypeLookup.push(awardTypeName);
          }

          let date = item.dueDate;
          item.internalDueDate =
            item.dueDate !== null ? new Date(item.dueDate) : null;
          item.dueDateFiling =
            item.filingDueDate !== null ? new Date(item.filingDueDate) : null;

          item.dueDate = date;

          // const affectedCompaniesNames = item.affectedCompanies.map(
          //   (company) => company.customerName
          // );
          // item.formattedAffectedCompany = affectedCompaniesNames;
          // item.formattedAffectedCompany = item.affectedCompanies.map(
          //   (company) => ({
          //     customerName: company.customerName,
          //     type: company.type, // Assuming 'type' property exists in 'company' object
          //     customerId: company.customerId, // Assuming 'customerId' property exists in 'company' object
          //     status: company.status, // Assuming 'status' property exists in 'company' object
          //   })
          // );

          // item.fldAffectedCompany = item.affectedCompanies
          //   .filter((item) => item.status === "Completed")
          //   .map((company) => ({
          //     name: company.customerName,
          //     code: company.customerId, // Assuming 'customerId' property exists in 'company' object
          //     status: company.status === "Completed",
          //   }));

          if (item.filingJuristiction?.includes("Federal")) {
            if (item.recordType === "TrackNow") {
              const _categories = _.map(
                item.businessCategory,
                "businessCategoryName"
              ).join(", ");
              addLookupValues(fedLookup, _categories);
              return {
                ...item,
                federalCategories: _categories,
                awardTypeName,
                awardingAgencyName,
                filingPeriod,
                dueDateFormatted,
                dueDateFilingFormatted,
                dueDateUTC,
                dueDate,
                stateList: _stateList,
                programId: programId,
                staffassigned: _staffassigned,
                grantTermComplete: grantTermCompleteText,
                initialGrantTermComplete: grantTermCompleteText,
                trackerListId: `${i}${item.fileTrackingId}`,
              };
            } else {
              addLookupValues(fedLookup, programName);
              return {
                ...item,
                federalCategories: programName,
                awardTypeName,
                awardingAgencyName,
                filingPeriod,
                dueDateFormatted,
                dueDateFilingFormatted,
                dueDateUTC,
                dueDate,
                stateList: _stateList,
                programId: programId,
                staffassigned: _staffassigned,
                grantTermComplete: grantTermCompleteText,
                initialGrantTermComplete: grantTermCompleteText,
                trackerListId: `${i}${item.fileTrackingId}`,
              };
            }
          } else if (item.filingJuristiction?.includes("Both")) {
            if (item.recordType === "TrackNow") {
              const categoriesState = item.businessCategory.filter(
                (ele) => ele.state === item.filingStateInfo
              );

              const _categories = categoriesState
                .map((ele) => ele.businessCategoryName)
                .join(", ");
              return {
                ...item,
                stateCategories: _categories,
                federalCategories: _categories,
                awardTypeName,
                awardingAgencyName,
                filingPeriod,
                dueDateFormatted,
                dueDateFilingFormatted,
                dueDateUTC,
                dueDate,
                stateList: _stateList,
                programId: programId,
                staffassigned: _staffassigned,
                grantTermComplete: grantTermCompleteText,
                initialGrantTermComplete: grantTermCompleteText,
                trackerListId: `${i}${item.fileTrackingId}`,
              };
            } else {
              return {
                ...item,
                stateCategories: programName,
                federalCategories: programName,
                awardTypeName,
                awardingAgencyName,
                filingPeriod,
                dueDateFormatted,
                dueDateFilingFormatted,
                dueDateUTC,
                dueDate,
                stateList: _stateList,
                programId: programId,
                staffassigned: _staffassigned,
                grantTermComplete: grantTermCompleteText,
                initialGrantTermComplete: grantTermCompleteText,
                trackerListId: `${i}${item.fileTrackingId}`,
              };
            }
          } else {
            if (item.recordType === "TrackNow") {
              const categoriesState = item.businessCategory.filter(
                (ele) => ele.state === item.filingStateInfo
              );

              const _categories = categoriesState
                .map((ele) => ele.businessCategoryName)
                .join(", ");
              return {
                ...item,
                stateCategories: _categories,
                awardTypeName,
                awardingAgencyName,
                filingPeriod,
                dueDateFormatted,
                dueDateFilingFormatted,
                dueDateUTC,
                dueDate,
                stateList: _stateList,
                programId: programId,
                staffassigned: _staffassigned,
                grantTermComplete: grantTermCompleteText,
                initialGrantTermComplete: grantTermCompleteText,
                trackerListId: `${i}${item.fileTrackingId}`,
              };
            } else {
              return {
                ...item,
                stateCategories: programName,
                awardTypeName,
                awardingAgencyName,
                filingPeriod,
                dueDateFormatted,
                dueDateFilingFormatted,
                dueDateUTC,
                dueDate,
                stateList: _stateList,
                programId: programId,
                staffassigned: _staffassigned,
                grantTermComplete: grantTermCompleteText,
                initialGrantTermComplete: grantTermCompleteText,
                trackerListId: `${i}${item.fileTrackingId}`,
              };
            }
          }
        });
        const _jusrisdictions = updCustomers.map((item) =>
          item.juristiction ? item.juristiction : ""
        );
        // const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));
        // console.log("@@Unique Jurisdiction3:", _uniqJurisdictions);
        // console.log("Updated Customers filing M...", updCustomers);
        // // setData(updCustomers);
        // setJurisdiction(_uniqJurisdictions);
        setData(() => updCustomers);
        setFederalCategoriesLookup(Array.from(new Set(fedLookup)));
        setPostAwardAgencyArray(awardAgencyLookup);
        setPostAwardTypeArray(awardTypeLookup);
        updCustomers = updCustomers.map((ele) => {
          let date = ele.dueDate;
          // let isParent =
          //   ele.staffAssigned && ele.staffAssigned.length > 0
          //     ? ele.staffAssigned.some((staff) => staff.company === "Parent")
          //     : false;

          ele.staffAssignedArray =
            ele.staffAssigned.length > 0
              ? ele.staffAssigned.map((ele) => ({
                name: ele.userName
                  ? ele.userName.charAt(0).toUpperCase() +
                  ele.userName.slice(1)
                  : ele.name,
                code: ele.userId ? ele.userId : ele.code,
              }))
              : ele.staffAssigned;

          return { ...ele, dueDate: date };
        });

        let tableList = value === "2" ? clientFilingHistory : clientFiling;
        console.log("modifyList updCustomers", updCustomers, tableList);

        let updFilingMastersList;
        if (direction === "down") {
          //scroll down
          if (tableList.length >= pageSize * 2) {
            //list >= 2 pages

            //remove first pageSize records and add new data
            let unloadList = ogList.slice(pageSize);
            // console.log("modifyList dw unloadList", unloadList);

            //add new data
            updFilingMastersList = [...unloadList, ...updCustomers];
            // console.log("modifyList dw updFilingMastersList", updFilingMastersList);

            // let list = updFilingMastersList.map((ele)=>ele)
            // setClientFiling(updFilingMastersList);
          } else {
            //list < 2 pages

            // add new data to list
            updFilingMastersList = [...ogList, ...updCustomers];
            // console.log("modifyList dw updFilingMastersList", updFilingMastersList);

            // setClientFiling(updFilingMastersList);
          }
        } else if (direction === "up") {
          //scroll up
          if (tableList.length >= pageSize * 2) {
            //list >= 2 pages

            //slice 1 half of list
            let unloadList = ogList.slice(0, pageSize);
            // console.log("modifyList up unloadList", unloadList);

            //add new data
            updFilingMastersList = [...updCustomers, ...unloadList];
            // console.log("modifyList up updFilingMastersList", updFilingMastersList);

            // setClientFiling(updFilingMastersList);
          } else {
            //list < 2 pages

            //slice 1 half of list
            let unloadList = ogList.slice(0, pageSize);
            // console.log("modifyList up unloadList", unloadList);

            //add new data
            updFilingMastersList = [...updCustomers, ...unloadList];
            // console.log("modifyList up updFilingMastersList", updFilingMastersList);

            // setClientFiling(updFilingMastersList);
          }
        }
        if (value === "2" && selectedYear !== "") {
          setClientFiling([]);
          setInitialValue([]);
          setClientFilingTrackers([]);
          setClientFilingHistory(updFilingMastersList);
          setClientFilingTrackersHistory(updFilingMastersList);
          setInitialClientFilingHistory(updFilingMastersList);
          props.setClientFilingData(updFilingMastersList);
          props.resetRefreshList();
        } else {
          setClientFilingHistory([]);
          setInitialClientFilingHistory([]);
          setClientFilingTrackersHistory([]);
          setClientFiling(updFilingMastersList);
          setClientFilingTrackers(updFilingMastersList);
          setInitialValue(updFilingMastersList);
          props.setClientFilingData(updFilingMastersList);
        }
        setRefreshRecordList(false);
        setLazyLoading(false);
        setIsLoading(false);
        return updFilingMastersList;
      } else {
        //list empty
        // console.log("modifyList empty",list)
        setRefreshRecordList(false);
        setLazyLoading(false);
        setIsLoading(false);
        setClientFiling([]);
        setClientFilingTrackers([]);
        setClientFilingHistory([]);
        setClientFilingTrackersHistory([]);
        return [];
      }
    } catch (error) {
      console.error("err", error);
    }
  };

  //table filter change
  const onFilterChange = async (e) => {
    // console.log("onFilterChange props", e.filters);
    let filterChange = [];

    if (e.filters.global.value !== "" && e.filters.global.value !== null) {
      //global filter
      filterChange.push({
        name: `SearchByFilingName`,
        val: e.filters.global.value,
        searchType: `FilingNameSearchType`,
        searchTypeVal: getSearchType("contains"),
      });
    } else {
      //map filter event
      Object.keys(e.filters).forEach((col) => {
        if (
          e.filters[col].constraints &&
          e.filters[col].constraints[0].value !== null
        ) {
          if (col === "stateList") {
            Array.isArray(e.filters[col].constraints[0].value)
              ? e.filters[col].constraints[0].value.map((ele, i) => {
                let changeItem = {
                  name: `SearchByStateInfo`,
                  val: getStateCode(ele),
                };
                if (i + 1 === e.filters[col].constraints[0].value.length) {
                  changeItem.searchType = `StateInfoSearchType`;
                  changeItem.searchTypeVal = getSearchType(
                    e.filters[col].constraints[0].matchMode
                  );
                }
                filterChange.push(changeItem);
              })
              : filterChange.push({
                name: `SearchByStateInfo`,
                val: getStateCode(e.filters[col].constraints[0].value),
                searchType: `StateInfoSearchType`,
                searchTypeVal: getSearchType(
                  e.filters[col].constraints[0].matchMode
                ),
              });
          } else if (col === "filingJuristiction") {
            filterChange.push({
              name: `SearchByJuristiction`,
              val: e.filters[col].constraints[0].value,
            });
          } else if (col === "filingRequired") {
            filterChange.push({
              name: `SearchByRequired`,
              val: e.filters[col].constraints[0].value,
            });
          } else if (col === "awardTypeName") {
            filterChange.push({
              name: `SearchByAwardType`,
              val: e.filters[col].constraints[0].value,
              searchType: `AwardTypeSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "awardingAgencyName") {
            filterChange.push({
              name: `SearchByAwardAgency`,
              val: e.filters[col].constraints[0].value,
              searchType: `AwardAgencySearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "jsicontactName") {
            filterChange.push({
              name: `SearchByJSIStaff`,
              val: e.filters[col].constraints[0].value,
              searchType: `JSIStaffSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "customerName") {
            filterChange.push({
              name: `SearchByCustomerName`,
              val: e.filters[col].constraints[0].value,
              searchType: `CustomerNameSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "federalCategories") {
            e.filters[col].constraints[0].value.map((ele, i) => {
              // console.log(
              //   "onFilterChange i",
              //   i + 1,
              //   e.filters[col].constraints[0].value.length
              // );
              let changeItem = {
                name: `SearchByWhoMustFileFederal`,
                val: ele,
              };
              if (i + 1 === e.filters[col].constraints[0].value.length) {
                changeItem.searchType = `WhoMustFileFederalSearchType`;
                changeItem.searchTypeVal = getSearchType(
                  e.filters[col].constraints[0].matchMode
                );
              }
              filterChange.push(changeItem);
            });
          } else if (col === "stateCategories") {
            e.filters[col].constraints[0].value.map((ele, i) => {
              let changeItem = {
                name: `SearchByWhoMustFileInState`,
                val: ele,
              };
              if (i + 1 === e.filters[col].constraints[0].value.length) {
                changeItem.searchType = `WhoMustFileInStateSearchType`;
                changeItem.searchTypeVal = getSearchType(
                  e.filters[col].constraints[0].matchMode
                );
              }
              filterChange.push(changeItem);
            });
          } else if (col === "internalDueDate") {
            filterChange.push({
              name: `SearchByInternalDueDate`,
              val: formatFilterDate(e.filters[col].constraints[0].value),
              searchType: `InternalDueDateSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "dueDateFiling") {
            filterChange.push({
              name: `SearchByFilingDueDate`,
              val: formatFilterDate(e.filters[col].constraints[0].value),
              searchType: `FilingDueDateSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "filingPeriod") {
            filterChange.push({
              name: `SearchByFilingDueDate`,
              val: formatFilterDate(e.filters[col].constraints[0].value),
              searchType: `FilingDueDateSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else {
            const fieldName = getTrackerApiFieldName(col);
            filterChange.push({
              name: `SearchBy${fieldName}`,
              val: e.filters[col].constraints[0].value,
              searchType: `${fieldName}SearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          }
        }
      });
    }
    console.log("onFilterChange filterChange", filterChange);

    //set filter
    handleSetFilterVariable(filterChange);
  };

  const formatFilterDate = (date) => {
    // console.log("formatFilterDate", date);
    let getDate = new Date(date);
    let formatDate = `${getDate.getFullYear()}-${getDate.getMonth() + 1
      }-${getDate.getDate()}`;
    // console.log("formatFilterDate formatDate", getDate.getFullYear(), formatDate);
    return formatDate;
  };

  const getStateCode = (stateName) => {
    // console.log("getStateCode", stateName, states);
    const state = states.find((s) => s.state === stateName);
    return state ? state.code : stateName;
  };

  const matchModeVal = [
    { name: "contains", val: "Contains" },
    { name: "in", val: "Contains" },
    { name: "notContains", val: "NotContains" },
    { name: "equals", val: "EqualTo" },
    { name: "dateIs", val: "DateIs" },
    { name: "dateIsNot", val: "DateIsNot" },
    { name: "dateBefore", val: "DateIsBefore" },
    { name: "dateAfter", val: "DateIsAfter" },
  ];

  const getSearchType = (matchMode) => {
    // console.log("getSearchType props", matchMode);
    return matchModeVal.find((ele) => ele.name === matchMode).val;
  };

  //set filter
  const handleSetFilterVariable = (filterChange) => {
    console.log("handleSetFilterVariable props", filterChange);
    setIsFilterChange(() => filterChange);
    setRecordsInView(0);
    setIsLoading(true);
    setClientFiling([]);
    setInitialValue([]);
    setClientFilingHistory([]);
    setInitialClientFilingHistory([]);
    props.setClientFilingData([]);
  };

  //table sort change
  const handleSort = async (e) => {
    console.log("handleSort props", e, e.sortField);
    if (e.sortField !== "") {
      setSortingData(() => ({
        sortBy: e.sortField,
        sortOrder: e.sortOrder,
      }));
      setRecordsInView(0);
      setIsLoading(true);
      setClientFiling([]);
      setInitialValue([]);
      props.setClientFilingData([]);
    }
  };

  const getSortData = (val) => {
    console.log("getSortData props", val);
    if (val === "internalDueDate") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "DueDate",
        SortOrderParameter: "SortOrder",
      };
    } else if (val === "dueDateFiling") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "FilingDueDate",
        SortOrderParameter: "SortOrder",
      };
    } else if (val === "stateList") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "FilingStateInfo",
        SortOrderParameter: "SortOrder",
      };
    } else if (val === "federalCategories" || val === "stateCategories") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "BusinessCategory",
        SortOrderParameter: "SortOrder",
      };
    } else if (val === "staffAssignedArray") {
      return {
        SortByParameter: "SortByStaffAssigned",
        SortByVal: "StaffAssigned",
        SortOrderParameter: "SortOrderStaffAssigned",
      };
    } else if (val === "awardTypeName") {
      return {
        SortByParameter: "SortByAwardType",
        SortByVal: "AwardType",
        SortOrderParameter: "SortOrderAwardType",
      };
    } else if (val === "awardingAgencyName") {
      return {
        SortByParameter: "SortByAwardingAgency",
        SortByVal: "AwardingAgency",
        SortOrderParameter: "SortOrderAwardingAgency",
      };
    } else {
      return {
        SortByParameter: "SortBy",
        SortByVal: val.charAt(0).toUpperCase() + val.slice(1),
        SortOrderParameter: "SortOrder",
      };
    }
  };

  useEffect(() => {
    // console.log("filter/sort change", isFilterChange, sortingData, lazyLoading );
    //on filter/sort change
    if (
      selectedCustomer?.customerId &&
      !lazyLoading &&
      !refreshRecordList &&
      !refreshPageDetails.hasOwnProperty("recordsInView")
    ) {
      setLazyLoading(true);
      const sortAndFilterApiCall = async () => {
        let records = await loadRecordsList(0, 100, "down");
        setRecordsInView(1);
        console.log("recordsCheck", records);
        setIsLoading(false);
      };
      sortAndFilterApiCall();
    }
  }, [isFilterChange, sortingData]);

  useEffect(() => {
    console.log("Total Records updated:", totalRecords);
  }, [totalRecords]);

  const refreshRecords = async () => {
    console.log("refreshRecords props");
    const vScroll =
      value === "1"
        ? sortRecord === "Clear"
          ? dtUpcoming.current.getVirtualScroller()
          : dt.current.getVirtualScroller()
        : dtHistory.current.getVirtualScroller();
    let range = vScroll.getRenderedRange();
    console.log("refreshRecords vScroll range", vScroll, range);

    let records;
    console.log("refreshRecords refreshDetails", refreshDetails);
    if (refreshDetails?.pageInView || refreshDetails?.noOfPages) {
      let first = refreshDetails.pageInView * pageSize;
      records = await loadRecordsList(
        first,
        first + refreshDetails?.noOfPages * pageSize,
        "down"
      );
    } else {
      records = await loadRecordsList(0, pageSize, "down");
    }
    console.log("refreshRecords records", records, props.keepSelectedRecords);

    if (records) {
      if (refreshDetails?.viewport && refreshDetails?.noOfPages) {
        console.log(
          "refreshRecords scrollInView",
          refreshDetails.viewport.first,
          dt
        );
        setRecordsInView((old) => old + refreshDetails?.noOfPages);
        // scrollToSelected()
      } else {
        setRecordsInView((old) => old + 1);
      }
      if (refreshPageDetails.hasOwnProperty("recordsInView")) {
        setIsLoading(true);
        const myTimeout = setTimeout(() => {
          const vScroll =
            value === "1"
              ? sortRecord === "Clear"
                ? dtUpcoming.current.getVirtualScroller()
                : dt.current.getVirtualScroller()
              : dtHistory.current.getVirtualScroller();
          console.log("refreshRecords refreshDetails", refreshDetails);
          vScroll.scrollInView(refreshDetails.viewport.first);
          setIsLoading(false);
          setRefreshPageDetails({});
        }, 10000);
      }
      if (props.keepSelectedRecords.length > 0) {
        setSelectedClientFiling([]);
        props.setSelectedFiling([]);
        console.log(
          "refreshRecords keepSelectedRecords",
          props.keepSelectedRecords
        );
        let selectedRecordsIds = props.keepSelectedRecords.map(
          (ele) => ele.fileTrackingId
        );
        let getSelectedRecords = records.filter((ele) =>
          selectedRecordsIds.includes(ele.fileTrackingId)
        );
        console.log(
          "refreshRecords getSelectedRecords",
          selectedRecordsIds,
          getSelectedRecords
        );
        setSelectedClientFiling(getSelectedRecords);
        props.setSelectedFiling(getSelectedRecords);
        props.resetKeepSelectedRecords([]);
      }
    }
  };


  useEffect(() => {
    console.log(
      "refreshRecordList, refreshPageDetails ",
      refreshRecordList,
      selectedCustomer?.customerId,
      !lazyLoading,
      refreshRecordList && selectedCustomer?.customerId && !lazyLoading
    );
    if (refreshRecordList && selectedCustomer?.customerId && !lazyLoading) {
      setLazyLoading(true);
      refreshRecords();
    }
  }, [refreshRecordList]);

  useEffect(() => {
    console.log("recordsInView,", recordsInView);
  }, [recordsInView]);

  useEffect(() => {
    console.log("masters,", clientFiling);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientFiling, clientFiling.length, JSON.stringify(clientFiling)]);

  useEffect(() => {
    console.log("clientFilingHistory,", clientFilingHistory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    clientFilingHistory,
    clientFilingHistory.length,
    JSON.stringify(clientFilingHistory),
  ]);

  useEffect(() => {
    console.log("lazyLoading", lazyLoading);
  }, [lazyLoading]);

  useEffect(() => {
    console.log("isLoading", isLoading);
  }, [isLoading]);

  console.log("postAwardValUpc", postAwardValUpc, "trackNowValUpc", trackNowValUpc, "tracknowVal", trackNowVal, "PostawardVal", postAwardVal);

  console.log(
    "hasChangeStatusPermission",
    hasChangeStatusPermission,
    selectedCustomer
  );


  return (
    <Fragment>
      <style>{`
  .p-datatable.tracker-table-theme {
    border-radius: 8px !important;
    overflow: hidden !important;
    border: none !important;
    box-shadow: none !important; 
    background: ${tokens.colors.offWhite} !important;
  }

  .tracker-table-theme .p-datatable-wrapper {
    border-radius: 8px !important;
    overflow: auto !important;
    height: 550px !important;
    background: ${tokens.colors.offWhite} !important;
  }

  .tracker-table-theme .p-datatable-header {
    background: ${tokens.colors.offWhite} !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .tracker-table-theme .p-datatable-table {
    border-radius: 8px !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  .tracker-table-theme .p-datatable-thead > tr {
    background: ${primaryColor} !important;
  }

  .tracker-table-theme .p-datatable-thead > tr:first-child > th:first-child {
    border-top-left-radius: 8px !important;
  }

  .tracker-table-theme .p-datatable-thead > tr:first-child > th:last-child {
    border-top-right-radius: 8px !important;
  }

  .tracker-table-theme .p-datatable-thead > tr > th {
    background: ${primaryColor} !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    letter-spacing: 0.02em !important;
    padding: 10px 10px !important;
    border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
    border-bottom: none !important;
    text-transform: none !important;
    box-shadow: none !important;
    overflow: hidden !important;
  }

  .tracker-table-theme .p-datatable-thead > tr > th:last-child {
    border-right: none !important;
  }

  .tracker-table-theme .p-datatable-thead > tr > th.p-frozen-column {
    z-index: 7 !important;
    background: ${primaryColor} !important;
    will-change: auto !important;
  }

  .tracker-table-theme .p-sortable-column-icon {
    color: #ffffff !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr {
    height: 45px !important;
  }

  .tracker-table-theme .p-datatable-emptymessage > td {
    height: 45px !important;
    padding: 10px 8px !important;
    line-height: 1.3 !important;
    font-size: 15px !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr:nth-child(odd) > td {
    background-color: #ffffff !important;
    padding: 0px 4px !important;
    font-size: 15px !important;
    line-height: 1.3 !important;
    color: #000000 !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr:nth-child(even) > td {
    background-color: ${tokens.colors.offWhite} !important;
    padding: 0px 4px !important;
    font-size: 15px !important;
    line-height: 1.3 !important;
    color: #000000 !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr > td {
    border-right: 1px solid ${primaryColor} !important;
    border-bottom: 1px solid ${primaryColor} !important;
    border-left: none !important;
    border-top: none !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr > td:last-child {
    border-right: none !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column {
    z-index: 4 !important;
    background-color: #ffffff !important;
    color: #000000 !important;
    will-change: auto !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column {
    z-index: 4 !important;
    background-color: ${tokens.colors.offWhite} !important;
    color: #000000 !important;
    will-change: auto !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 8px !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 8px !important;
  }

  /* Remove hover effect completely while hovering rows/cells */
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight):hover,
  .tracker-table-theme .p-datatable-tbody > tr.p-selectable-row:not(.p-highlight):hover,
  .tracker-table-theme.p-datatable.p-datatable-selectable .p-datatable-tbody > tr.p-selectable-row:not(.p-highlight):not(.p-datatable-emptymessage):hover,
  .tracker-table-theme.p-datatable.p-datatable-hoverable-rows .p-datatable-tbody > tr:not(.p-highlight):not(.p-datatable-emptymessage):hover {
    background: transparent !important;
    background-color: transparent !important;
  }

  /* Maintain alternating row backgrounds when hovering row or non-clickable cells */
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight):nth-child(odd):hover > td:not(.filingNameColumn):not(.federalColumn):not(.stateColumn):not(.affectedCompaniesColumn):not(.staffAssignedColumn),
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight):nth-child(odd) > td:not(.filingNameColumn):not(.federalColumn):not(.stateColumn):not(.affectedCompaniesColumn):not(.staffAssignedColumn):hover {
    background-color: #ffffff !important;
    cursor: default !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight):nth-child(even):hover > td:not(.filingNameColumn):not(.federalColumn):not(.stateColumn):not(.affectedCompaniesColumn):not(.staffAssignedColumn),
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight):nth-child(even) > td:not(.filingNameColumn):not(.federalColumn):not(.stateColumn):not(.affectedCompaniesColumn):not(.staffAssignedColumn):hover {
    background-color: ${tokens.colors.offWhite} !important;
    cursor: default !important;
  }

  /* Ensure frozen columns always stay opaque with high z-index on row / cell hover */
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight):nth-child(odd):hover > td.p-frozen-column,
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight):nth-child(odd) > td.p-frozen-column:hover {
    z-index: 4 !important;
    background-color: #ffffff !important;
    font-weight: inherit !important;
    color: inherit !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.p-frozen-column:hover {
    background-color: transparent !important;
  }

  /* All other columns MUST NOT change font-weight on hover */
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td:not(.filingNameColumn):not(.federalColumn):not(.stateColumn):not(.affectedCompaniesColumn):not(.staffAssignedColumn):hover {
    font-weight: inherit !important;
  }

  /* COMPLETED ROW - Green background for completed filings */
  .tracker-table-theme .p-datatable-tbody > tr.completed-row > td,
  .tracker-table-theme .p-datatable-tbody > tr.completed-row:nth-child(odd) > td,
  .tracker-table-theme .p-datatable-tbody > tr.completed-row:nth-child(even) > td,
  .tracker-table-theme .p-datatable-tbody > tr.completed-row > td.p-frozen-column,
  .tracker-table-theme .p-datatable-tbody > tr.completed-row:nth-child(odd) > td.p-frozen-column,
  .tracker-table-theme .p-datatable-tbody > tr.completed-row:nth-child(even) > td.p-frozen-column {
    background-color: #e2fedf !important;
    z-index: 4 !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr.completed-row:not(.p-highlight):hover > td:not(.filingNameColumn):not(.federalColumn):not(.stateColumn):not(.affectedCompaniesColumn):not(.staffAssignedColumn),
  .tracker-table-theme .p-datatable-tbody > tr.completed-row:not(.p-highlight) > td:not(.filingNameColumn):not(.federalColumn):not(.stateColumn):not(.affectedCompaniesColumn):not(.staffAssignedColumn):hover,
  .tracker-table-theme .p-datatable-tbody > tr.completed-row:not(.p-highlight):hover > td.p-frozen-column,
  .tracker-table-theme .p-datatable-tbody > tr.completed-row:not(.p-highlight) > td.p-frozen-column:hover {
    background-color: #e2fedf !important;
    z-index: 4 !important;
  }

  /* SELECTED ROW - Matches AddFilingtable.js dynamic styling */
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight:nth-child(odd) > td,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight:nth-child(even) > td,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.p-frozen-column,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight:nth-child(odd) > td.p-frozen-column,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight:nth-child(even) > td.p-frozen-column {
    z-index: 4 !important;
    background-color: color-mix(in srgb, ${primaryColor} 14%, white) !important;
    border-right: 1px solid ${primaryColor} !important;
    border-bottom: 1px solid ${primaryColor} !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td:last-child {
    border-right: none !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr > td.filingNameColumn,
  .tracker-table-theme .p-datatable-tbody > tr > td.filingNameColumn *,
  .tracker-table-theme .p-datatable-tbody > tr > td.federalColumn,
  .tracker-table-theme .p-datatable-tbody > tr > td.federalColumn *,
  .tracker-table-theme .p-datatable-tbody > tr > td.stateColumn,
  .tracker-table-theme .p-datatable-tbody > tr > td.stateColumn *,
  .tracker-table-theme .p-datatable-tbody > tr > td.affectedCompaniesColumn,
  .tracker-table-theme .p-datatable-tbody > tr > td.affectedCompaniesColumn *,
  .tracker-table-theme .p-datatable-tbody > tr > td.staffAssignedColumn,
  .tracker-table-theme .p-datatable-tbody > tr > td.staffAssignedColumn * {
    color: ${primaryColor} !important;
  }

  /* Values in Filing Name, Federal, State, Affected Companies, and Staff Assigned columns become bold and alpha background on hover when NOT selected */
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.filingNameColumn:hover,
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.federalColumn:hover,
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.stateColumn:hover,
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.affectedCompaniesColumn:hover,
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.staffAssignedColumn:hover {
    background-color: color-mix(in srgb, ${primaryColor} 8%, white) !important;
    cursor: pointer !important;
    transition: background-color 0.2s ease;
  }

  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.filingNameColumn:hover {
    z-index: 4 !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.filingNameColumn:hover *,
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.federalColumn:hover *,
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.stateColumn:hover *,
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.affectedCompaniesColumn:hover *,
  .tracker-table-theme .p-datatable-tbody > tr:not(.p-highlight) > td.staffAssignedColumn:hover * {
    font-weight: 600 !important;
    color: ${primaryColor} !important;
  }

  /* After selection, remove hover effects on cells */
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight:hover,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight:hover > td,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td:hover,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.p-frozen-column:hover,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.filingNameColumn:hover,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.federalColumn:hover,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.stateColumn:hover,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.affectedCompaniesColumn:hover,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.staffAssignedColumn:hover {
    z-index: 4 !important;
    background-color: color-mix(in srgb, ${primaryColor} 14%, white) !important;
  }

  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td:hover *,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.filingNameColumn:hover *,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.federalColumn:hover *,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.stateColumn:hover *,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.affectedCompaniesColumn:hover *,
  .tracker-table-theme .p-datatable-tbody > tr.p-highlight > td.staffAssignedColumn:hover * {
    font-weight: inherit !important;
  }

  .p-checkbox .p-checkbox-box.p-highlight {
    background: ${primaryColor} !important;
    border-color: ${primaryColor} !important;
  }

  .p-radiobutton .p-radiobutton-box.p-highlight {
    background: ${primaryColor} !important;
    border-color: ${primaryColor} !important;
  }

  .tracker-table-theme .p-column-filter-menu-button {
    display: none !important;
  }

  .tracker-table-theme .p-column-filter-menu-button-open,
  .tracker-table-theme .p-column-filter-menu-button-active {
    display: none !important;
  }

  /* Align header and body selection checkboxes */
  .tracker-table-theme .p-datatable-thead > tr > th.p-selection-column,
  .tracker-table-theme .p-datatable-tbody > tr > td.p-selection-column {
    padding: 0 !important;
    text-align: center !important;
    vertical-align: middle !important;
    width: 3rem !important;
    min-width: 3rem !important;
  }

  .tracker-table-theme .p-selection-column .p-checkbox {
    margin: 0 auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .tracker-categories-overlay .p-overlaypanel-close {
    color: ${primaryColor} !important;
  }

  .tracker-categories-overlay .p-overlaypanel-close:hover {
    color: ${primaryColor} !important;
  }

  .tracker-categories-overlay .p-overlaypanel-close-icon,
  .tracker-categories-overlay .p-overlaypanel-close .pi,
  .tracker-categories-overlay .p-overlaypanel-close svg {
    color: #ffffff !important;
    fill: #ffffff !important;
  }

  .tracker-categories-overlay .p-overlaypanel-close {
    background: ${primaryColor} !important;
    border: 1px solid ${primaryColor} !important;
    border-radius: 999px !important;
  }

  /* PrimeReact Dialog close icon styling (Affected Companies / Staff Assigned) */
  .tracker-details-dialog .p-dialog-header-close {
    background: ${primaryColor} !important;
    border: 1px solid ${primaryColor} !important;
    border-radius: 999px !important;
    width: 32px !important;
    height: 32px !important;
  }

  .tracker-details-dialog .p-dialog-header-close:hover,
  .tracker-details-dialog .p-dialog-header-close:focus {
    background: ${primaryColor} !important;
    border-color: ${primaryColor} !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .tracker-details-dialog .p-dialog-header-close-icon,
  .tracker-details-dialog .p-dialog-header-close .pi,
  .tracker-details-dialog .p-dialog-header-close svg {
    color: #ffffff !important;
    fill: #ffffff !important;
    font-size: 16px !important;
  }

  .tracker-more-count,
  .tracker-table-theme .tableBtn .tracker-more-count {
    color: #9ca3af !important;
    font-size: 12px !important;
    margin-left: 6px !important;
    text-decoration: none !important;
  }

  /* Keep frozen column offsets aligned by class to avoid gaps when columns hide/show */
  .frozen-tracker-active.tracker-table-theme .p-frozen-column.filingNameColumn {
    left: 0 !important;
  }

  .frozen-tracker-active.tracker-table-theme .p-frozen-column.dueDateFilingColumn {
    left: 20rem !important;
  }

  .frozen-tracker-active.tracker-table-theme .p-frozen-column.status {
    left: 32rem !important;
  }

  /* Force exact edit SVG on row editor init button */
  .tracker-table-theme .p-row-editor-init {
    width: 24px !important;
    height: 24px !important;
    padding: 0 !important;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='${encodeURIComponent(primaryColor)}'><path d='M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z'/></svg>") !important;
    background-position: center center !important;
    background-size: 22px 22px !important;
    background-repeat: no-repeat !important;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
    color: ${primaryColor} !important;
  }

  .tracker-table-theme .p-row-editor-init-icon {
    display: none !important;
  }

  .tracker-table-theme .p-row-editor-init,
  .tracker-table-theme .p-row-editor-save,
  .tracker-table-theme .p-row-editor-cancel {
    color: ${primaryColor} !important;
    border-radius: 50% !important;
  }

  .tracker-table-theme .p-row-editor-init:hover {
    background-color: color-mix(in srgb, ${primaryColor} 14%, transparent) !important;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='${encodeURIComponent(primaryColor)}'><path d='M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z'/></svg>") !important;
    background-position: center center !important;
    background-size: 22px 22px !important;
    background-repeat: no-repeat !important;
    box-shadow: none !important;
  }

  .tracker-table-theme .p-row-editor-save:hover,
  .tracker-table-theme .p-row-editor-cancel:hover {
    color: ${primaryColor} !important;
    background-color: color-mix(in srgb, ${primaryColor} 14%, transparent) !important;
    box-shadow: none !important;
  }

  .tracker-table-theme .p-row-editor-init:focus,
  .tracker-table-theme .p-row-editor-init:focus-visible {
    background-color: color-mix(in srgb, ${primaryColor} 18%, transparent) !important;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='${encodeURIComponent(primaryColor)}'><path d='M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z'/></svg>") !important;
    background-position: center center !important;
    background-size: 22px 22px !important;
    background-repeat: no-repeat !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${primaryColor} 25%, transparent) !important;
    outline: none !important;
  }

  .tracker-table-theme .p-row-editor-save:focus,
  .tracker-table-theme .p-row-editor-cancel:focus,
  .tracker-table-theme .p-row-editor-save:focus-visible,
  .tracker-table-theme .p-row-editor-cancel:focus-visible {
    color: ${primaryColor} !important;
    background-color: color-mix(in srgb, ${primaryColor} 18%, transparent) !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${primaryColor} 25%, transparent) !important;
    outline: none !important;
  }

  .tracker-table-theme .p-dropdown:not(.p-disabled):hover {
    border-color: ${primaryColor} !important;
  }

  .tracker-table-theme .p-dropdown:not(.p-disabled).p-focus {
    border-color: ${primaryColor} !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${primaryColor} 25%, transparent) !important;
  }

  .tracker-table-theme .staffAssignedColumn,
  .tracker-table-theme td.staffAssignedColumn,
  .tracker-table-theme th.staffAssignedColumn {
    width: 12rem !important;
    min-width: 12rem !important;
    max-width: 12rem !important;
  }

  .tracker-table-theme .staffAssignedArray {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow: hidden !important;
  }

  .tracker-table-theme .tracker-staffassigned-editor.p-multiselect {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  .tracker-table-theme .tracker-staffassigned-editor .p-multiselect-label-container,
  .tracker-table-theme .tracker-staffassigned-editor .p-multiselect-label {
    min-width: 0 !important;
    max-width: 100% !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

      `}</style>
      <CustomDialog
        visible={showAlert}
        onHide={closeAlert}
        footer={null}
      >
        {alertMessage}
      </CustomDialog>
      <CustomDialog
        header="info"
        visible={openFilingDueDateInfo}
        onHide={handleCloseFilingDueDate}
        footer={null}
        onConfirm={() => completeOnRowEditFunc()}
      >
        {alertMessage}
      </CustomDialog>

      <Dialog
        header="Affected Companies"
        visible={showAffectedCompanies}
        onHide={() => {
          setShowAffectedCompanies(false);
          setShowStaffAssigned(false);
        }}
        style={{ width: "30vw" }}
        modal
        className="tracker-details-dialog"
      >
        <p style={{ fontWeight: "bold", margin: 0 }}>
          {affectedCompaniesDetails.recordName}
        </p>
        <ul>
          {affectedCompaniesDetails.list.map((ele, index) => (
            <li key={index}>{ele}</li>
          ))}
        </ul>
      </Dialog>
      <Dialog
        header="Staff Assigned"
        visible={showStaffAssigned}
        onHide={() => {
          setShowStaffAssigned(false);
          setShowAffectedCompanies(false);
        }}
        style={{ width: "30vw" }}
        modal
        className="tracker-details-dialog"
      >
        <p style={{ fontWeight: "bold", margin: 0 }}>
          {staffAssignedDetails.recordName}
        </p>
        {staffAssignedDetails.list.length > 0 ? (
          <ul>
            {staffAssignedDetails.list.map((ele, index) => (
              <li key={index}>{ele}</li>
            ))}
          </ul>
        ) : (
          <Typography sx={{ marginTop: "20px" }}>No Staff Assigned</Typography>
        )}
      </Dialog>

      <Dialog
        header="Confirmation"
        visible={grantTermConfrimation}
        onHide={() => grantTermCloseAlert()}
        footer={grantTermFooterContent}
        style={{ width: "30vw" }}
        modal
      >
        <p className="m-0">
          Marking Grant Term Completed is not reversible and all upcoming
          records will be removed. Are you sure you want to continue?
        </p>
      </Dialog>

      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleTabChange}>
            <Tab label="Tracker Active" value="1" disabled={isLoading} />
            <Tab label="Tracker History" value="2" disabled={isLoading} />
          </TabList>
        </Box>
        <TabPanel value="1" className="filingPeriodTable" sx={{ px: 2 }}>
          {sortRecord === "Clear" ? (
            <DataTable
              ref={dtUpcoming}
              scrollable
              resizableColumns
              className="frozen-tracker-upd tracker-table-theme"
              style={{ borderRadius: '8px', overflow: 'hidden', border: 'none', background: tokens.colors.offWhite }}
              columnResizeMode="expand"
              rowClassName={rowClass}
              showGridlines
              emptyMessage="No records found "
              selection={selectedClientFiling || []}
              // selectionMode='radiobutton'
              onSelectionChange={(e) => selectFilingRecord(e.value)}
              value={selectedCustomer ? ClientFilingTrackers : []}
              dataKey="trackerListId"
              tableStyle={{ minWidth: selectedCustomer?.customerId ? "50rem" : "100%" }}
              // paginator={!viewAll}
              // rows={viewAll ? clientFiling.length : 200}
              // rowsPerPageOptions={[150, 200, 250, 300]}
              filters={filters}
              // sortField="dueDate"
              // sortOrder={-1}
              filterMode="multiple"
              selectionAutoFocus={false}
              autoFocus={false}
              // globalFilterFields={["filingName"]}
              header={headerDue}
              loading={isLoading}
              virtualScrollerOptions={{
                onScroll: loadDataLazy,
                itemSize: 45,
                delay: 0,
                scrollHeight: "550px",
                appendOnly: true,
              }}
              scrollHeight="550px"
              onFilter={(e) => onFilterChange(e)}
              sortField={sortingData.sortBy}
              sortOrder={sortingData.sortOrder}
              onSort={(e) => handleSort(e)}
            >
              <Column
                selectionMode="multiple"
                // headerStyle={{ width: "5%", minWidth: "4rem" }}
                style={{ width: "1rem", margin: "0" }}
              >
                Select
              </Column>
              <Column
                header="Indicators"
                style={{ textAlign: "center", minWidth: "8rem", width: "8rem" }}
                body={(rowData) => (
                  <>
                    <Stack direction="row">
                      <TrackClientComment rowData={rowData} />
                      <TrackClientAttachment rowData={rowData} />
                      <TrackClientRefDocs rowData={rowData} />
                    </Stack>
                  </>
                )}
              ></Column>
              {/* <Column
                rowEditor
                header='Edit'
                style={{ width: '0rem', margin: '0' }}
              ></Column> */}
              <Column
                field="filingName"
                header="Filing Name"
                sortable
                className="filingNameColumn"
                frozen={Boolean(selectedCustomer?.customerId)}
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterPlaceholder="Search by Filing Name"
                style={{ width: "10rem" }}
                body={(rowData) => cellListDisplayName(rowData)}
              ></Column>
              {/* <Column
            field='filingDescription'
            header='Filing Description'
            sortable
            style={{ minWidth: "15rem" }}
          ></Column> */}
              {/* <Column
                header='Internal Due Date'
                filterField='internalDueDate'
                dataType='date'
                style={{ minWidth: "13rem" }}
                body={cellEditorBody}
                filter
                frozen={Boolean(selectedCustomer?.customerId)}
                showAddButton={false}
                showFilterOperator={false}
                filterElement={dateFilterTemplate}
                //className="column-small"
                field='internalDueDate'
                sortable
              editor={
                hasChangeDueDatePermission
                  ? (options) => cellEditor(options)
                  : undefined
              }
              onCellEditInit={onCellEditInit}
              onCellEditComplete={onCellEditComplete}
              ></Column> */}

              <Column
                //className="column-small"
                field="dueDateFiling"
                header="Filing Due Date"
                sortable
                style={{ minWidth: "12rem" }}
                dataType="date"
                filter
                frozen={Boolean(selectedCustomer?.customerId)}
                showAddButton={false}
                showFilterOperator={false}
                filterField="dueDateFiling"
                filterElement={dateFilterTemplate}
                body={cellFilingDateBody}
              // onCellEditInit={onCellEditInit}
              // onCellEditComplete={onCellEditComplete}
              ></Column>

              {postAwardValUpc && (
                <Column
                  //className="column-small"
                  field="filingPeriod"
                  header="Filing Period"
                  // filter
                  frozen={
                    Boolean(selectedCustomer?.customerId) &&
                    (postAwardVal && !trackNowVal ? true : false)
                  }
                  showAddButton={false}
                  showFilterOperator={false}
                  style={{ minWidth: "15rem", maxWidth: "15rem" }}
                // filterMatchModeOptions={[
                //   { value: FilterMatchMode.CONTAINS, label: "Contains" },
                //   {
                //     value: FilterMatchMode.NOT_CONTAINS,
                //     label: "Not Contains",
                //   },
                //   { value: FilterMatchMode.EQUALS, label: "Equal" },
                // ]}
                // filterPlaceholder="Search by Filing Period"

                // filterElement={dateFilterTemplate}
                // body={cellFilingDateBody}
                // onCellEditInit={onCellEditInit}
                // onCellEditComplete={onCellEditComplete}
                ></Column>
              )}

              <Column
                className="column-small"
                field="status"
                header="Status"
                frozen={
                  Boolean(selectedCustomer?.customerId) &&
                  ((trackNowVal && !postAwardVal ? true : false) ||
                    ClientFilingTrackers.length === 0)
                }
                sortable
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterMenuStyle={{ width: "14rem" }}
                filterElement={statusRowFilterTemplate}
                onFilterMatchModeChange={() =>
                  setFederalFilterSelectedValues([])
                }
                onFilterClear={() => setFederalFilterSelectedValues([])}
                filterPlaceholder="Search by Status"
                style={{ maxWidth: "13rem" }}
                body={cellStatusEditorBody}
                editor={
                  hasChangeStatusPermission &&
                    selectedCustomer &&
                    (
                      (selectedCustomer.clientType === "Child" &&
                        !selectedCustomer.bothChildAndSubChild) ||

                      (selectedCustomer.clientType === "Parent" &&
                        selectedCustomer.isOnlyParentFile) ||

                      (selectedCustomer.clientType === "SubChild")
                    )
                    ? (options) => cellStatusEditor(options)
                    : undefined
                }
              // onCellEditInit={onCellStatusEditInit}
              // // onCellEditComplete={onCellEditStatusComplete}
              ></Column>
              {trackNowVal && (
                <Column
                  className="affectedCompaniesColumn"
                  header="Affected Companies"
                  field="customerName"
                  style={{ minWidth: "11rem", maxWidth: "25rem" }}
                  body={(rowData) =>
                    CellAffectedCompaniesEditorBody(
                      rowData,
                      "affectedCompanies"
                    )
                  }
                  // sortable={
                  //   detailedViewVal ||
                  //   selectedCustomer?.parentCustomer !== null ||
                  //   selectedCustomer?.isOnlyParentFile
                  // }
                  // filter
                  // showAddButton={false}
                  // showFilterOperator={false}
                  showFilterMenu={false}
                // show
                // filterMatchModeOptions={[
                //   { value: FilterMatchMode.CONTAINS, label: "Contains" },
                //   {
                //     value: FilterMatchMode.NOT_CONTAINS,
                //     label: "Not Contains",
                //   },
                //   { value: FilterMatchMode.EQUALS, label: "Equal" },
                // ]}
                // filterField="customerName"
                // filterPlaceholder="Search by Customer Name"
                ></Column>
              )}
              <Column
                className="staffAssignedColumn"
                field="staffAssignedArray"
                header="Staff Assigned"
                sortable={
                  detailedViewVal ||
                  !isDetailedViewAvailable ||
                  selectedCustomer?.clientType === "SubChild" ||
                  selectedCustomer?.isOnlyParentFile
                }
                showFilterMenu={false}
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterField="staffassigned"
                filterPlaceholder="Search by Staff Assigned"
                style={{ width: "12rem", minWidth: "12rem", maxWidth: "12rem" }}
                headerStyle={{ width: "12rem", minWidth: "12rem", maxWidth: "12rem" }}
                bodyStyle={{ width: "12rem", minWidth: "12rem", maxWidth: "12rem", overflow: "hidden" }}
                body={cellStaffAssignedBody}
                editor={
                  canEditStaffAssigned
                    ? (options) => cellStaffAssignedEditor(options)
                    : undefined
                }
              ></Column>

              <Column
                field="filingFrequency"
                header="Filing Frequency"
                sortable
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterPlaceholder="Search by Frequency"
                style={{ minWidth: "15rem" }}
              ></Column>

              <Column
                field="stateList"
                header="State"
                sortable
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterField="stateList"
                filterPlaceholder="Search by State"
                filterMenuStyle={{ width: "15rem" }}
                filterElement={stateRowFilterTemplate}
                onFilterClear={() => setFederalFilterSelectedValues([])}
                onFilterMatchModeChange={() =>
                  setFederalFilterSelectedValues([])
                }
                style={{ minWidth: "13rem" }}
                className="column-small"
              ></Column>

              {/* { <Column
                field='formattedAffectedCompany'
                header='Affected Companies'
                // filter

                showAddButton={false}
                showFilterOperator={false}
                // filterMatchModeOptions={[
                //   { value: FilterMatchMode.CONTAINS, label: "Contains" },
                //   {
                //     value: FilterMatchMode.NOT_CONTAINS,
                //     label: "Not Contains",
                //   },
                //   { value: FilterMatchMode.EQUALS, label: "Equal" },
                // ]}
                // filterPlaceholder="Search by Affected Companies"
                style={{ minWidth: "15rem", maxWidth: "15rem" }}
                body={(rowData) => cellListDisplayAffectedComp(rowData)}
              ></Column>} */}
              {postAwardVal && !trackNowVal && (
                <Column
                  className="affectedCompaniesColumn"
                  header="Affected Companies"
                  style={{ minWidth: "11rem", maxWidth: "25rem" }}
                  body={(rowData) =>
                    CellAffectedCompaniesEditorBody(
                      rowData,
                      "affectedCompanies"
                    )
                  }
                  // sortable={
                  //   detailedViewVal ||
                  //   selectedCustomer?.parentCustomer !== null ||
                  //   selectedCustomer?.isOnlyParentFile
                  // }
                  // filter
                  // showAddButton={false}
                  // showFilterOperator={false}
                  showFilterMenu={false}
                // filterMatchModeOptions={[
                //   { value: FilterMatchMode.CONTAINS, label: "Contains" },
                //   {
                //     value: FilterMatchMode.NOT_CONTAINS,
                //     label: "Not Contains",
                //   },
                //   { value: FilterMatchMode.EQUALS, label: "Equal" },
                // ]}
                // filterField="customerName"
                // filterPlaceholder="Search by Customer Name"
                ></Column>
              )}
              {trackNowValUpc && (
                <Column
                  field="ruleInfo"
                  header="Rule Info"
                  filter
                  showAddButton={false}
                  showFilterOperator={false}
                  filterMatchModeOptions={[
                    { value: FilterMatchMode.CONTAINS, label: "Contains" },
                    {
                      value: FilterMatchMode.NOT_CONTAINS,
                      label: "Not Contains",
                    },
                    { value: FilterMatchMode.EQUALS, label: "Equal" },
                  ]}
                  filterPlaceholder="Search by Rule Info"
                  style={{ minWidth: "15rem", maxWidth: "15rem" }}
                  body={(rowData) => cellListDisplayRuleInfo(rowData)}
                ></Column>
              )}

              <Column
                field="filingJuristiction"
                header="Jurisdiction"
                sortable
                filter
                showAddButton={false}
                showFilterOperator={false}
                showFilterMatchModes={false}
                filterElement={jurisdictionRowFilterTemplate}
                onFilterMatchModeChange={() =>
                  setFederalFilterSelectedValues([])
                }
                onFilterClear={() => setFederalFilterSelectedValues([])}
                filterPlaceholder="Search by Jurisdiction"
                style={{ minWidth: "14rem" }}
              ></Column>

              {trackNowValUpc && (
                <Column
                  field="filingRequired"
                  header="Required"
                  style={{ minWidth: "13rem" }}
                  className="column-small"
                  filter
                  filterElement={requiredRowFilterTemplate}
                  onFilterClear={() => setFederalFilterSelectedValues([])}
                  showAddButton={false}
                  showFilterOperator={false}
                  showFilterMatchModes={false}
                  filterPlaceholder="Search by Required"
                >
                  Select
                </Column>
              )}

              {postAwardValUpc && (
                <Column
                  field="awardTypeName"
                  header="Award Type "
                  sortable
                  filter
                  showAddButton={false}
                  showFilterOperator={false}
                  filterMatchModeOptions={[
                    { value: FilterMatchMode.IN, label: "Contains" },
                    {
                      value: FilterMatchMode.NOT_CONTAINS,
                      label: "Not Contains",
                    },
                    { value: FilterMatchMode.EQUALS, label: "Equal" },
                  ]}
                  filterElement={postawardTypeRowFilterTemplate}
                  onFilterMatchModeChange={() => setMasterCatFilter([])}
                  onFilterClear={() => setMasterCatFilter([])}
                  filterPlaceholder="Search by Award Type"
                  style={{ minWidth: "15rem" }}
                ></Column>
              )}

              {postAwardValUpc && (
                <Column
                  field="awardingAgencyName"
                  header="Award Agency"
                  sortable
                  filter
                  showAddButton={false}
                  showFilterOperator={false}
                  filterMatchModeOptions={[
                    { value: FilterMatchMode.IN, label: "Contains" },
                    {
                      value: FilterMatchMode.NOT_CONTAINS,
                      label: "Not Contains",
                    },
                    { value: FilterMatchMode.EQUALS, label: "Equal" },
                  ]}
                  filterElement={postawardAgencyRowFilterTemplate}
                  onFilterMatchModeChange={() => setMasterCatFilter([])}
                  onFilterClear={() => setMasterCatFilter([])}
                  filterPlaceholder="Search by Award Agency"
                  style={{ minWidth: "15rem" }}
                ></Column>
              )}

              {trackNowValUpc && (
                <Column
                  field="federalCategories"
                  header="Who Must File Federal"
                  className="federalColumn"
                  // sortable
                  body={(rowData) =>
                    CellListDisplayFederal(rowData, "federalCategories")
                  }
                  filter
                  filterField="federalCategories"
                  showAddButton={false}
                  showFilterOperator={false}
                  filterMatchModeOptions={[
                    { value: FilterMatchMode.IN, label: "Contains" },
                    {
                      value: FilterMatchMode.NOT_CONTAINS,
                      label: "Not Contains",
                    },
                    { value: FilterMatchMode.EQUALS, label: "Equal" },
                  ]}
                  onFilterMatchModeChange={() =>
                    setFederalFilterSelectedValues([])
                  }
                  filterElement={(options) =>
                    upcomingCategoryFilter(options, "federalCategories")
                  }
                  onFilterClear={() => setUpcomingCatFilter([])}
                  filterPlaceholder="Search by Cateogry"
                  style={{ minWidth: "15rem", maxWidth: "15rem" }}
                  showFilterMenu={false}
                // filterMenuStyle={{ width: "14rem" }}
                //showClearButton={false}
                // filterElement={federalCategoryRowFilterTemplate}
                // onFilterClear={() => setFederalCatFilter([])}
                ></Column>
              )}

              {trackNowValUpc && (
                <Column
                  field="stateCategories"
                  header="Who Must File in State"
                  className="stateColumn"
                  // sortable
                  filter
                  filterField="stateCategories"
                  showAddButton={false}
                  showFilterOperator={false}
                  filterMatchModeOptions={[
                    { value: FilterMatchMode.IN, label: "Contains" },
                    {
                      value: FilterMatchMode.NOT_CONTAINS,
                      label: "Not Contains",
                    },
                    { value: FilterMatchMode.EQUALS, label: "Equal" },
                  ]}
                  onFilterMatchModeChange={() => setUpcomingCatFilter([])}
                  filterElement={(options) =>
                    upcomingCategoryFilter(options, "stateCategories")
                  }
                  onFilterClear={() => setUpcomingCatFilter([])}
                  body={(rowData) =>
                    CellListDisplayFederal(rowData, "stateCategories")
                  }
                  // filterElement={stateCategoryRowFilterTemplate}
                  // onFilterClear={() => setStateCatFilter([])}
                  filterPlaceholder="Search by Cateogry"
                  showFilterMenu={false}
                  // filterMenuStyle={{ width: "14rem" }}
                  //  showClearButton={false}
                  style={{ minWidth: "15rem", maxWidth: "15rem" }}
                ></Column>
              )}

              {/* <Column
            field='jsidept'
            header='JSI Dept'
            style={{ minWidth: "14rem" }}
          ></Column> */}
              {/* <Column
            field='jsiContactEmail'
            header='JSI Contact Email'
            style={{ minWidth: "14rem" }}
          ></Column> */}
              <Column
                field="whereToFile"
                header="Where to File"
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                body={(rowData) => cellListDisplayWhereToFile(rowData)}
                filterPlaceholder="Search by Where to File"
                style={{ minWidth: "13rem", maxWidth: "13rem" }}
              ></Column>
              <Column
                field="notes"
                header="Notes"
                headerStyle={{
                  width: "45rem",
                  minWidth: "45rem",
                  maxWidth: "45rem",
                }}
                style={{
                  width: "45rem",
                  minWidth: "45rem",
                  maxWidth: "45rem",
                }}
                body={cellListDisplayNotes}
              />
            </DataTable>
          ) : (
            <DataTable
              ref={dt}
              scrollable
              resizableColumns
              className="frozen-tracker-active tracker-table-theme"
              style={{ borderRadius: '8px', overflow: 'hidden', border: 'none', background: tokens.colors.offWhite }}
              columnResizeMode="expand"
              rowClassName={rowClass}
              showGridlines
              emptyMessage="No records found "
              value={selectedCustomer ? ClientFilingTrackers : []}
              selection={selectedClientFiling || []}
              // selectionMode='radiobutton'
              onSelectionChange={(e) => selectFilingRecord(e.value)}
              dataKey="trackerListId"
              tableStyle={{ minWidth: selectedCustomer?.customerId ? "50rem" : "100%" }}
              onRowSelect={onRowSelect}
              // paginator={!viewAll}
              selectionAutoFocus={false}
              autoFocus={false}
              // rows={viewAll ? clientFiling.length : 200}
              // rowsPerPageOptions={[150, 200, 250, 300]}

              filters={filters}
              // sortField="dueDate"
              // sortOrder={-1}
              filterMode="multiple"
              globalFilterFields={["filingName"]}
              onRowEditInit={onRowEditInit}
              editMode="row"
              rowEditorSaveIcon={<GoogleMaterialIcon name="check" size={20} color={primaryColor} />}
              rowEditorCancelIcon={<GoogleMaterialIcon name="close" size={20} color={primaryColor} />}
              onRowEditComplete={onRowEditComplete}
              onRowEditCancel={onRowEditCancel}
              //onRowEditSave={onRowEditComplete}
              header={renderHeader()}
              loading={isLoading}
              virtualScrollerOptions={{
                onScroll: loadDataLazy,
                itemSize: 45,
                delay: 0,
                scrollHeight: "550px",
                appendOnly: true,
              }}
              scrollHeight="550px"
              onFilter={(e) => onFilterChange(e)}
              sortField={sortingData.sortBy}
              sortOrder={sortingData.sortOrder}
              onSort={(e) => handleSort(e)}
            >
              <Column
                selectionMode="multiple"
                // headerStyle={{ width: "5%", minWidth: "4rem" }}
                style={{ width: "1rem", margin: "0" }}
              >
                Select
              </Column>
              <Column
                header="Indicators"
                style={{ textAlign: "center", minWidth: "8rem", width: "8rem" }}
                body={(rowData) => (
                  <>
                    <Stack direction="row">
                      <TrackClientComment rowData={rowData} />
                      <TrackClientAttachment rowData={rowData} />
                      <TrackClientRefDocs rowData={rowData} />
                    </Stack>
                  </>
                )}
              ></Column>
              <Column
                header="Edit"
                rowEditor
                style={{ width: "3rem", textAlign: "center" }}
                bodyStyle={{ textAlign: "center", color: primaryColor }}
              />
              <Column
                field="filingName"
                header="Filing Name"
                sortable
                className="filingNameColumn"
                filter
                frozen={Boolean(selectedCustomer?.customerId)}
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterPlaceholder="Search by Filing Name"
                style={{ width: "20rem" }}
                body={(rowData) => cellListDisplayName(rowData)}
              ></Column>
              {/* <Column
            field='filingDescription'
            header='Filing Description'
            sortable
            style={{ minWidth: "15rem" }}
          ></Column> */}

              {/* {postAwardVal &&               
              <Column
                header='Internal Due Date'
                filterField='internalDueDate'
                dataType='date'
                frozen={Boolean(selectedCustomer?.customerId)}
                className='internalDueDate'
                style={{ width: "9rem" }}
                body={cellEditorBody}
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterElement={dateFilterTemplate}
                //className="column-small"
                field='internalDueDate'
                sortable
                editor={
                  hasChangeDueDatePermission
                    ? (options) => cellEditor(options)
                    : undefined
                }

              // onCellEditInit={onCellEditInit}
              // onCellEditComplete={onCellEditComplete}
              ></Column>
            } */}

              <Column
                //className="column-small"
                field="dueDateFiling"
                header="Filing Due Date"
                className="dueDateFilingColumn"
                sortable
                style={{ minWidth: "12rem" }}
                dataType="date"
                frozen={Boolean(selectedCustomer?.customerId)}
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterField="dueDateFiling"
                filterElement={dateFilterTemplate}
                body={cellFilingDateBody}
                editor={(options) => {
                  const rowData = options.rowData;
                  const { recordType, isMasterFiling } = rowData;
                  console.log("enableEditor recordType", recordType);
                  const enableEditor =
                    (recordType === "PostAward" ||
                      (recordType === "TrackNow" && !isMasterFiling)) &&
                    hasChangeDueDatePermission;
                  console.log("enableEditor", enableEditor);
                  return cellFilingEditor(options, enableEditor);
                }}
              // onCellEditInit={onCellEditInit}
              // onCellEditComplete={onCellEditComplete}
              ></Column>

              {postAwardVal && (
                <Column
                  field="filingPeriods"
                  body={(rowData) => cellFilingPeriods(rowData)}
                  header="Filing Period"
                  frozen={
                    Boolean(selectedCustomer?.customerId) &&
                    (postAwardVal && !trackNowVal ? true : false)
                  }
                  showAddButton={false}
                  showFilterOperator={false}
                  style={{ minWidth: "15rem", maxWidth: "15rem" }}
                  dataType="date"
                  editor={(options) => {
                    const rowData = options.rowData;
                    const { recordType, isMasterFiling } = rowData;
                    console.log("enableEditor recordType", recordType);
                    const enableEditor =
                      recordType === "PostAward"
                      &&
                      hasChangeDueDatePermission;
                    return cellFilingEditorPeriod(options, enableEditor);
                  }}

                ></Column>
              )}

              <Column
                //  className='column-small'
                field="status"
                header="Status"
                sortable
                frozen={
                  Boolean(selectedCustomer?.customerId) &&
                  ((trackNowVal && !postAwardVal ? true : false) ||
                    ClientFilingTrackers.length === 0)
                }
                filter
                className={
                  trackNowVal && !postAwardVal ? "status" : "status-hide"
                }
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterMenuStyle={{ width: "9rem" }}
                filterElement={statusRowFilterTemplate}
                onFilterMatchModeChange={() =>
                  setFederalFilterSelectedValues([])
                }
                onFilterClear={() => setFederalFilterSelectedValues([])}
                filterPlaceholder="Search by Status"
                style={{ width: "9rem" }}
                body={cellStatusEditorBody}
                editor={
                  hasChangeStatusPermission &&
                    selectedCustomer &&
                    (
                      (selectedCustomer.clientType === "Child" &&
                        !selectedCustomer.bothChildAndSubChild) ||

                      (selectedCustomer.clientType === "Parent" &&
                        selectedCustomer.isOnlyParentFile) ||

                      (selectedCustomer.clientType === "SubChild") ||

                      detailedViewVal
                    )
                    ? (options) => cellStatusEditor(options)
                    : undefined
                }

              // onCellEditInit={onCellStatusEditInit}
              // // onCellEditComplete={onCellEditStatusComplete}
              ></Column>

              {postAwardVal && (
                <Column
                  className="column-small"
                  field="grantTermComplete"
                  header="Grant Term Complete"
                  sortable
                  filter
                  showAddButton={false}
                  showFilterOperator={false}
                  filterMatchModeOptions={[
                    { value: FilterMatchMode.IN, label: "Contains" },
                    {
                      value: FilterMatchMode.NOT_CONTAINS,
                      label: "Not Contains",
                    },
                    { value: FilterMatchMode.EQUALS, label: "Equal" },
                  ]}
                  filterField="GrantTermcomplete"
                  filterMenuStyle={{ width: "14rem" }}
                  filterPlaceholder="Search by GrantTermcomplete"
                  style={{ maxWidth: "13rem" }}
                  body={cellGrantTermcompleteEditorBody}
                  // editor={
                  //    hasChangeGrantTermcompletePermission
                  //     ?
                  //      (options) => cellGrantTermcompleteEditor(options)
                  //     : undefined
                  // }

                  editor={(options) => {
                    const rowData = options.rowData;
                    const { recordType, status } = rowData;

                    // Check if recordType is "postaward" and status is "completed"
                    const enableEditor =
                      recordType === "PostAward" && status === "Completed";
                    return enableEditor
                      ? cellGrantTermcompleteEditor(options)
                      : null; // Return null or undefined to disable the editor
                  }}
                ></Column>
              )}

              {trackNowVal && (
                <Column
                  className="affectedCompaniesColumn"
                  header="Affected Companies"
                  field="customerName"
                  style={{ minWidth: "11rem", maxWidth: "25rem" }}
                  body={(rowData) =>
                    CellAffectedCompaniesEditorBody(
                      rowData,
                      "affectedCompanies"
                    )
                  }
                  // sortable={
                  //   detailedViewVal ||
                  //   selectedCustomer?.parentCustomer !== null ||
                  //   selectedCustomer?.isOnlyParentFile
                  // }
                  // filter
                  // showAddButton={false}
                  // showFilterOperator={false}
                  showFilterMenu={false}
                // show
                // filterMatchModeOptions={[
                //   { value: FilterMatchMode.CONTAINS, label: "Contains" },
                //   {
                //     value: FilterMatchMode.NOT_CONTAINS,
                //     label: "Not Contains",
                //   },
                //   { value: FilterMatchMode.EQUALS, label: "Equal" },
                // ]}
                // filterField="customerName"
                // filterPlaceholder="Search by Customer Name"
                ></Column>
              )}

              <Column
                className="staffAssignedColumn"
                field="staffAssignedArray"
                header="Staff Assigned"
                filter
                sortable={
                  detailedViewVal ||
                  !isDetailedViewAvailable ||
                  selectedCustomer?.clientType === "SubChild" ||
                  selectedCustomer?.isOnlyParentFile
                }
                showFilterMenu={false}
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterField="staffassigned"
                filterPlaceholder="Search by Staff Assigned"
                style={{ width: "12rem", minWidth: "12rem", maxWidth: "12rem" }}
                headerStyle={{ width: "12rem", minWidth: "12rem", maxWidth: "12rem" }}
                bodyStyle={{ width: "12rem", minWidth: "12rem", maxWidth: "12rem", overflow: "hidden" }}
                body={(rowData, field) =>
                  CellListDisplayStaffAssigned(rowData, field)
                }
                editor={
                  canEditStaffAssigned
                    ? (options) => cellStaffAssignedEditor(options)
                    : undefined
                }
              ></Column>

              <Column
                field="filingFrequency"
                header="Filing Frequency"
                sortable
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterPlaceholder="Search by Frequency"
                style={{ minWidth: "15rem" }}
              ></Column>

              <Column
                field="stateList"
                header="State"
                sortable
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterField="stateList"
                filterPlaceholder="Search by State"
                filterMenuStyle={{ width: "15rem" }}
                filterElement={stateRowFilterTemplate}
                onFilterClear={() => setFederalFilterSelectedValues([])}
                style={{ minWidth: "13rem" }}
                className="column-small"
              ></Column>

              {postAwardVal && !trackNowVal && (
                <Column
                  className="affectedCompaniesColumn"
                  header="Affected Companies"
                  style={{ minWidth: "11rem", maxWidth: "25rem" }}
                  body={(rowData) =>
                    CellAffectedCompaniesEditorBody(
                      rowData,
                      "affectedCompanies"
                    )
                  }
                  // sortable={
                  //   detailedViewVal ||
                  //   selectedCustomer?.parentCustomer !== null ||
                  //   selectedCustomer?.isOnlyParentFile
                  // }
                  // filter
                  // showAddButton={false}
                  // showFilterOperator={false}
                  showFilterMenu={false}
                // filterMatchModeOptions={[
                //   { value: FilterMatchMode.CONTAINS, label: "Contains" },
                //   {
                //     value: FilterMatchMode.NOT_CONTAINS,
                //     label: "Not Contains",
                //   },
                //   { value: FilterMatchMode.EQUALS, label: "Equal" },
                // ]}
                // filterField="customerName"
                // filterPlaceholder="Search by Customer Name"
                ></Column>
              )}

              {trackNowVal && (
                <Column
                  field="ruleInfo"
                  header="Rule Info"
                  filter
                  showAddButton={false}
                  showFilterOperator={false}
                  filterMatchModeOptions={[
                    { value: FilterMatchMode.CONTAINS, label: "Contains" },
                    {
                      value: FilterMatchMode.NOT_CONTAINS,
                      label: "Not Contains",
                    },
                    { value: FilterMatchMode.EQUALS, label: "Equal" },
                  ]}
                  filterPlaceholder="Search by Rule Info"
                  style={{ minWidth: "15rem", maxWidth: "15rem" }}
                  body={(rowData) => cellListDisplayRuleInfo(rowData)}
                ></Column>
              )}

              <Column
                field="filingJuristiction"
                header="Jurisdiction"
                sortable
                filter
                showAddButton={false}
                showFilterOperator={false}
                showFilterMatchModes={false}
                filterElement={jurisdictionRowFilterTemplate}
                filterPlaceholder="Search by Jurisdiction"
                style={{ minWidth: "14rem" }}
              ></Column>

              {trackNowVal && (
                <Column
                  field="filingRequired"
                  header="Required"
                  style={{ minWidth: "13rem" }}
                  className="column-small"
                  filter
                  filterElement={requiredRowFilterTemplate}
                  onFilterClear={() => setFederalFilterSelectedValues([])}
                  showAddButton={false}
                  showFilterOperator={false}
                  showFilterMatchModes={false}
                  filterPlaceholder="Search by Required"
                >
                  Select
                </Column>
              )}

              {postAwardVal && (
                <Column
                  field="awardTypeName"
                  header="Award Type "
                  sortable
                  filter
                  showAddButton={false}
                  showFilterOperator={false}
                  filterMatchModeOptions={[
                    { value: FilterMatchMode.IN, label: "Contains" },
                    {
                      value: FilterMatchMode.NOT_CONTAINS,
                      label: "Not Contains",
                    },
                    { value: FilterMatchMode.EQUALS, label: "Equal" },
                  ]}
                  filterElement={postawardTypeRowFilterTemplate}
                  onFilterMatchModeChange={() => setMasterCatFilter([])}
                  onFilterClear={() => setMasterCatFilter([])}
                  filterPlaceholder="Search by Award Type"
                  style={{ minWidth: "15rem" }}
                ></Column>
              )}

              {postAwardVal && (
                <Column
                  field="awardingAgencyName"
                  header="Award Agency"
                  sortable
                  filter
                  showAddButton={false}
                  showFilterOperator={false}
                  filterMatchModeOptions={[
                    { value: FilterMatchMode.IN, label: "Contains" },
                    {
                      value: FilterMatchMode.NOT_CONTAINS,
                      label: "Not Contains",
                    },
                    { value: FilterMatchMode.EQUALS, label: "Equal" },
                  ]}
                  filterElement={postawardAgencyRowFilterTemplate}
                  onFilterMatchModeChange={() => setMasterCatFilter([])}
                  onFilterClear={() => setMasterCatFilter([])}
                  filterPlaceholder="Search by Award Agency"
                  style={{ minWidth: "15rem" }}
                ></Column>
              )}

              {trackNowVal && (
                <Column
                  field="federalCategories"
                  header="Who Must File Federal"
                  className="federalColumn"
                  // sortable
                  body={(rowData) =>
                    CellListDisplayFederal(rowData, "federalCategories")
                  }
                  filter
                  filterField="federalCategories"
                  showAddButton={false}
                  showFilterOperator={false}
                  filterMatchModeOptions={[
                    { value: FilterMatchMode.IN, label: "Contains" },
                    {
                      value: FilterMatchMode.NOT_CONTAINS,
                      label: "Not Contains",
                    },
                    { value: FilterMatchMode.EQUALS, label: "Equal" },
                  ]}
                  onFilterMatchModeChange={() =>
                    setFederalFilterSelectedValues([])
                  }
                  filterElement={(options) =>
                    federalFilterElement(options, "federalCategories")
                  }
                  onFilterClear={() => setFederalFilterSelectedValues([])}
                  filterPlaceholder="Search by Cateogry"
                  style={{ minWidth: "15rem", maxWidth: "15rem" }}
                  showFilterMenu={false}
                // filterMenuStyle={{ width: "14rem" }}
                //showClearButton={false}
                // filterElement={federalCategoryRowFilterTemplate}
                // onFilterClear={() => setFederalCatFilter([])}
                ></Column>
              )}

              {trackNowVal && (
                <Column
                  field="stateCategories"
                  header="Who Must File in State"
                  className="stateColumn"
                  // sortable
                  filter
                  filterField="stateCategories"
                  showAddButton={false}
                  showFilterOperator={false}
                  filterMatchModeOptions={[
                    { value: FilterMatchMode.IN, label: "Contains" },
                    {
                      value: FilterMatchMode.NOT_CONTAINS,
                      label: "Not Contains",
                    },
                    { value: FilterMatchMode.EQUALS, label: "Equal" },
                  ]}
                  onFilterMatchModeChange={() =>
                    setFederalFilterSelectedValues([])
                  }
                  filterElement={(options) =>
                    federalFilterElement(options, "stateCategories")
                  }
                  onFilterClear={() => setFederalFilterSelectedValues([])}
                  body={(rowData) =>
                    CellListDisplayFederal(rowData, "stateCategories")
                  }
                  // filterElement={stateCategoryRowFilterTemplate}
                  // onFilterClear={() => setStateCatFilter([])}
                  filterPlaceholder="Search by Cateogry"
                  showFilterMenu={false}
                  // filterMenuStyle={{ width: "14rem" }}
                  //  showClearButton={false}
                  style={{ minWidth: "15rem", maxWidth: "15rem" }}
                ></Column>
              )}

              {/* <Column
            field='jsidept'
            header='JSI Dept'
            style={{ minWidth: "14rem" }}
          ></Column> */}
              {/* <Column
            field='jsiContactEmail'
            header='JSI Contact Email'
            style={{ minWidth: "14rem" }}
          ></Column> */}
              <Column
                field="whereToFile"
                header="Where to File"
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                body={(rowData) => cellListDisplayWhereToFile(rowData)}
                filterPlaceholder="Search by Where to File"
                style={{ minWidth: "13rem", maxWidth: "13rem" }}
              ></Column>
              <Column
                field="notes"
                header="Notes"
                headerStyle={{
                  width: "45rem",
                  minWidth: "45rem",
                  maxWidth: "45rem",
                }}
                style={{
                  width: "45rem",
                  minWidth: "45rem",
                  maxWidth: "45rem",
                }}
                body={cellListDisplayNotes}
              />
            </DataTable>
          )}
        </TabPanel>

        <TabPanel value="2" className="filingPeriodTable" sx={{ px: 2 }}>
          <DataTable
            ref={dtHistory}
            key="Tracker History"
            className="frozen-tracker-history tracker-table-theme"
            style={{ borderRadius: '8px', overflow: 'hidden', border: 'none', background: tokens.colors.offWhite }}
            scrollable
            resizableColumns
            columnResizeMode="expand"
            rowClassName={rowClass}
            showGridlines
            emptyMessage="No records found "
            value={selectedCustomer ? ClientFilingTrackersHistory : []}
            selection={selectedClientFiling || []}
            // selectionMode='radiobutton'
            onSelectionChange={(e) => selectFilingRecord(e.value)}
            dataKey="trackerListId"
            tableStyle={{ minWidth: selectedCustomer?.customerId ? "50rem" : "100%" }}
            onRowSelect={onRowSelect}
            // paginator={!viewAll}
            selectionAutoFocus={false}
            autoFocus={false}
            // rows={viewAll ? clientFilingHistory.length : 200}
            // rowsPerPageOptions={[150, 200, 250, 300]}

            filters={filters}
            filterMode="multiple"
            // sortField="dueDate"
            // sortOrder={-1}
            globalFilterFields={["filingName"]}

            editMode="row"
            onRowEditInit={onRowEditInit}
            rowEditorSaveIcon={<GoogleMaterialIcon name="check" size={20} color={primaryColor} />}
            rowEditorCancelIcon={<GoogleMaterialIcon name="close" size={20} color={primaryColor} />}
            onRowEditComplete={onRowEditComplete}
            onRowEditCancel={onRowEditCancel}
            header={header}
            loading={isLoading}
            virtualScrollerOptions={{
              onScroll: loadDataLazy,
              itemSize: 45,
              delay: 0,
              scrollHeight: "550px",
              appendOnly: true,
            }}
            scrollHeight="550px"
            onFilter={(e) => onFilterChange(e)}
            sortField={sortingData.sortBy}
            sortOrder={sortingData.sortOrder}
            onSort={(e) => handleSort(e)}
          >
            <Column
              selectionMode="multiple"
              // headerStyle={{ width: "5%", minWidth: "4rem" }}
              style={{ width: "1rem", margin: "0" }}
            >
              Select
            </Column>
            <Column
              header="Indicators"
              style={{ textAlign: "center", minWidth: "8rem", width: "8rem" }}
              body={(rowData) => (
                <>
                  <Stack direction="row">
                    <TrackClientComment rowData={rowData} />
                    <TrackClientAttachment rowData={rowData} />
                    <TrackClientRefDocs rowData={rowData} />
                  </Stack>
                </>
              )}
            ></Column>
            <Column
              header="Edit"
              rowEditor
              style={{ width: "3rem", textAlign: "center" }}
              bodyStyle={{ textAlign: "center", color: primaryColor }}
            />
            <Column
              field="filingName"
              header="Filing Name"
              sortable
              className="filingNameColumn"
              frozen={Boolean(selectedCustomer?.customerId)}
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterMatchModeOptions={[
                { value: FilterMatchMode.CONTAINS, label: "Contains" },
                { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                { value: FilterMatchMode.EQUALS, label: "Equal" },
              ]}
              filterPlaceholder="Search by Filing Name"
              style={{ width: "10rem" }}
              body={(rowData) => cellListDisplayName(rowData)}
            ></Column>
            {/* <Column
            field='filingDescription'
            header='Filing Description'
            sortable
            style={{ minWidth: "15rem" }}
          ></Column> */}
            {/* {postAwardVal &&          
            <Column
              header='Internal Due Date'
              filterField='internalDueDate'
              dataType='date'
              style={{ width: "9rem" }}
              body={cellEditorBody}
              frozen={Boolean(selectedCustomer?.customerId)}
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterElement={dateFilterTemplate}
              //className="column-small"
              field='internalDueDate'
              sortable
              editor={
                hasChangeDueDatePermission
                  ? (options) => cellEditor(options)
                  : undefined
              }
            // onCellEditInit={onCellEditInit}
            // onCellEditComplete={onCellEditComplete}
            ></Column>
          } */}

            <Column
              //className="column-small"
              field="dueDateFiling"
              header="Filing Due Date"
              sortable
              style={{ minWidth: "12rem" }}
              dataType="date"
              filter
              frozen={Boolean(selectedCustomer?.customerId)}
              showAddButton={false}
              showFilterOperator={false}
              filterField="dueDateFiling"
              filterElement={dateFilterTemplate}
              body={cellFilingDateBody}
            // onCellEditInit={onCellEditInit}
            // onCellEditComplete={onCellEditComplete}
            ></Column>

            {postAwardVal && (
              <Column
                field="filingPeriods"
                body={(rowData) => cellFilingPeriods(rowData)}
                header="Filing Period"
                frozen={
                  Boolean(selectedCustomer?.customerId) &&
                  (postAwardVal && !trackNowVal ? true : false)
                }
                showAddButton={false}
                showFilterOperator={false}
                style={{ minWidth: "15rem", maxWidth: "15rem" }}
                dataType="date"
                editor={(options) => {
                  const rowData = options.rowData;
                  const { recordType, isMasterFiling } = rowData;
                  console.log("enableEditor recordType", recordType);
                  const enableEditor =
                    (recordType === "PostAward" ||
                      (recordType === "TrackNow" && !isMasterFiling)) &&
                    hasChangeDueDatePermission;
                  console.log("enableEditor", enableEditor);
                  return cellFilingEditorPeriod(options, enableEditor);
                }}

              ></Column>
            )}

            <Column
              className="column-small"
              field="status"
              header="Status"
              frozen={
                Boolean(selectedCustomer?.customerId) &&
                (trackNowVal && !postAwardVal ? true : false)
              }
              sortable
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterMatchModeOptions={[
                { value: FilterMatchMode.CONTAINS, label: "Contains" },
                { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                { value: FilterMatchMode.EQUALS, label: "Equal" },
              ]}
              filterMenuStyle={{ width: "14rem" }}
              filterElement={statusRowFilterTemplate}
              onFilterMatchModeChange={() => setFederalFilterSelectedValues([])}
              onFilterClear={() => setFederalFilterSelectedValues([])}
              filterPlaceholder="Search by Status"
              style={{ width: "9rem" }}
              body={cellStatusEditorBody}
              editor={
                hasChangeStatusPermission &&
                  selectedCustomer &&
                  (selectedCustomer.isOnlyChildFile ||
                    selectedCustomer.isOnlyParentFile)
                  ? (options) => cellStatusEditor(options)
                  : undefined
              }
            // onCellEditInit={onCellStatusEditInit}
            // // onCellEditComplete={onCellEditStatusComplete}
            ></Column>

            {postAwardVal && (
              <Column
                className="column-small"
                field="grantTermComplete"
                header="Grant Term Complete"
                sortable
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.IN, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterField="GrantTermcomplete"
                filterMenuStyle={{ width: "14rem" }}
                filterPlaceholder="Search by GrantTermcomplete"
                style={{ maxWidth: "13rem" }}
                body={cellGrantTermcompleteEditorBody}
                // editor={
                //    hasChangeGrantTermcompletePermission
                //     ?
                //      (options) => cellGrantTermcompleteEditor(options)
                //     : undefined
                // }

                editor={(options) => {
                  const rowData = options.rowData;
                  const { recordType, status } = rowData;

                  // Check if recordType is "postaward" and status is "completed"
                  const enableEditor =
                    recordType === "PostAward" && status === "Completed";
                  return enableEditor
                    ? cellGrantTermcompleteEditor(options)
                    : null; // Return null or undefined to disable the editor
                }}
              ></Column>
            )}

            <Column
              className="staffAssignedColumn"
              field="staffAssignedArray"
              header="Staff Assigned"
              sortable={
                detailedViewVal ||
                !isDetailedViewAvailable ||
                selectedCustomer?.clientType === "SubChild" ||
                selectedCustomer?.isOnlyParentFile
              }
              showFilterMenu={false}
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterMatchModeOptions={[
                { value: FilterMatchMode.CONTAINS, label: "Contains" },
                { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                { value: FilterMatchMode.EQUALS, label: "Equal" },
              ]}
              filterField="staffassigned"
              filterPlaceholder="Search by Staff Assigned"
              style={{ width: "12rem", minWidth: "12rem", maxWidth: "12rem" }}
              headerStyle={{ width: "12rem", minWidth: "12rem", maxWidth: "12rem" }}
              bodyStyle={{ width: "12rem", minWidth: "12rem", maxWidth: "12rem", overflow: "hidden" }}
              // body={cellStaffAssignedBody}
              body={(rowData, field) =>
                CellListDisplayStaffAssigned(rowData, field)
              }
              editor={
                canEditStaffAssigned
                  ? (options) => cellStaffAssignedEditor(options)
                  : undefined
              }
            ></Column>

            <Column
              field="filingFrequency"
              header="Filing Frequency"
              sortable
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterMatchModeOptions={[
                { value: FilterMatchMode.CONTAINS, label: "Contains" },
                { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                { value: FilterMatchMode.EQUALS, label: "Equal" },
              ]}
              filterPlaceholder="Search by Frequency"
              style={{ minWidth: "15rem" }}
            ></Column>

            <Column
              field="stateList"
              header="State"
              sortable
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterMatchModeOptions={[
                { value: FilterMatchMode.CONTAINS, label: "Contains" },
                { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                { value: FilterMatchMode.EQUALS, label: "Equal" },
              ]}
              filterField="stateList"
              filterPlaceholder="Search by State"
              filterMenuStyle={{ width: "15rem" }}
              filterElement={stateRowFilterTemplate}
              onFilterClear={() => setFederalFilterSelectedValues([])}
              onFilterMatchModeChange={() => setFederalFilterSelectedValues([])}
              style={{ minWidth: "13rem" }}
              className="column-small"
            ></Column>

            {/* <Column
              field='fldAffectedCompany'
              header='Affected Companies'
              // filter

              showAddButton={false}
              showFilterOperator={false}
              // filterMatchModeOptions={[
              //   { value: FilterMatchMode.CONTAINS, label: "Contains" },
              //   {
              //     value: FilterMatchMode.NOT_CONTAINS,
              //     label: "Not Contains",
              //   },
              //   { value: FilterMatchMode.EQUALS, label: "Equal" },
              // ]}
              // filterPlaceholder="Search by Affected Companies"
              style={{ minWidth: "15rem", maxWidth: "15rem" }}
              body={(rowData, field) =>
                cellListDisplayAffectedComp(rowData, field)
              }

              editor={
                hasChangeStatusPermission
                  ? (options) => cellAffectedCompaniesEditor(options)
                  : undefined
              }
            ></Column> */}

            {trackNowVal && (
              <Column
                field="ruleInfo"
                header="Rule Info"
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.CONTAINS, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterPlaceholder="Search by Rule Info"
                style={{ minWidth: "15rem", maxWidth: "15rem" }}
                body={(rowData) => cellListDisplayRuleInfo(rowData)}
              ></Column>
            )}

            <Column
              field="filingJuristiction"
              header="Jurisdiction"
              sortable
              filter
              showAddButton={false}
              showFilterOperator={false}
              showFilterMatchModes={false}
              filterElement={jurisdictionRowFilterTemplate}
              onFilterMatchModeChange={() => setFederalFilterSelectedValues([])}
              onFilterClear={() => setFederalFilterSelectedValues([])}
              filterPlaceholder="Search by Jurisdiction"
              style={{ minWidth: "14rem" }}
            ></Column>

            {trackNowVal && (
              <Column
                field="filingRequired"
                header="Required"
                style={{ minWidth: "13rem" }}
                className="column-small"
                filter
                filterElement={requiredRowFilterTemplate}
                onFilterClear={() => setFederalFilterSelectedValues([])}
                showAddButton={false}
                showFilterOperator={false}
                showFilterMatchModes={false}
                filterPlaceholder="Search by Required"
              >
                Select
              </Column>
            )}

            {postAwardVal && (
              <Column
                field="awardTypeName"
                header="Award Type "
                sortable
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.IN, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterElement={postawardTypeRowFilterTemplate}
                onFilterMatchModeChange={() => setMasterCatFilter([])}
                onFilterClear={() => setMasterCatFilter([])}
                filterPlaceholder="Search by Award Type"
                style={{ minWidth: "15rem" }}
              ></Column>
            )}

            {postAwardVal && (
              <Column
                field="awardingAgencyName"
                header="Award Agency"
                sortable
                filter
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.IN, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                filterElement={postawardAgencyRowFilterTemplate}
                onFilterMatchModeChange={() => setMasterCatFilter([])}
                onFilterClear={() => setMasterCatFilter([])}
                filterPlaceholder="Search by Award Agency"
                style={{ minWidth: "15rem" }}
              ></Column>
            )}

            {trackNowVal && (
              <Column
                field="federalCategories"
                header="Who Must File Federal"
                className="federalColumn"
                // sortable
                body={(rowData) =>
                  CellListDisplayFederal(rowData, "federalCategories")
                }
                filter
                filterField="federalCategories"
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.IN, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                onFilterMatchModeChange={() =>
                  setFederalFilterSelectedValues([])
                }
                filterElement={(options) =>
                  federalFilterElement(options, "federalCategories")
                }
                onFilterClear={() => setFederalFilterSelectedValues([])}
                filterPlaceholder="Search by Cateogry"
                style={{ minWidth: "15rem", maxWidth: "15rem" }}
                showFilterMenu={false}
              // filterMenuStyle={{ width: "14rem" }}
              //showClearButton={false}
              // filterElement={federalCategoryRowFilterTemplate}
              // onFilterClear={() => setFederalCatFilter([])}
              ></Column>
            )}

            {trackNowVal && (
              <Column
                field="stateCategories"
                header="Who Must File in State"
                className="stateColumn"
                // sortable
                filter
                filterField="stateCategories"
                showAddButton={false}
                showFilterOperator={false}
                filterMatchModeOptions={[
                  { value: FilterMatchMode.IN, label: "Contains" },
                  {
                    value: FilterMatchMode.NOT_CONTAINS,
                    label: "Not Contains",
                  },
                  { value: FilterMatchMode.EQUALS, label: "Equal" },
                ]}
                onFilterMatchModeChange={() =>
                  setFederalFilterSelectedValues([])
                }
                filterElement={(options) =>
                  federalFilterElement(options, "stateCategories")
                }
                onFilterClear={() => setFederalFilterSelectedValues([])}
                body={(rowData) =>
                  CellListDisplayFederal(rowData, "stateCategories")
                }
                // filterElement={stateCategoryRowFilterTemplate}
                // onFilterClear={() => setStateCatFilter([])}
                filterPlaceholder="Search by Cateogry"
                showFilterMenu={false}
                // filterMenuStyle={{ width: "14rem" }}
                //  showClearButton={false}
                style={{ minWidth: "15rem", maxWidth: "15rem" }}
              ></Column>
            )}
            {/* <Column
            field='jsidept'
            header='JSI Dept'
            style={{ minWidth: "14rem" }}
          ></Column> */}
            {/* <Column
            field='jsiContactEmail'
            header='JSI Contact Email'
            style={{ minWidth: "14rem" }}
          ></Column> */}
            <Column
              field="whereToFile"
              header="Where to File"
              filter
              showAddButton={false}
              showFilterOperator={false}
              filterMatchModeOptions={[
                { value: FilterMatchMode.CONTAINS, label: "Contains" },
                { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                { value: FilterMatchMode.EQUALS, label: "Equal" },
              ]}
              body={(rowData) => cellListDisplayWhereToFile(rowData)}
              filterPlaceholder="Search by Where to File"
              style={{ minWidth: "13rem", maxWidth: "13rem" }}
            ></Column>
            <Column
              field="notes"
              header="Notes"
              headerStyle={{
                width: "45rem",
                minWidth: "45rem",
                maxWidth: "45rem",
              }}
              style={{
                width: "45rem",
                minWidth: "45rem",
                maxWidth: "45rem",
              }}
              body={cellListDisplayNotes}
            />
          </DataTable>
        </TabPanel>
      </TabContext>
      <ClientTableFilter
        anchorEl={filterAnchorEl}
        onClose={handleFilterClose}
        hideTrackerStaffAssignedFilter={
          !selectedCustomer?.isOnlyChildFile &&
          !selectedCustomer?.isOnlyParentFile && !detailedViewVal
        }
        onApply={(filterConfig) => {
          console.log('Filter applied:', filterConfig);
          handleFilterClose();

          let filterChange = [];
          const { field, matchMode, value } = filterConfig;
          const nextActiveFilters = [
            ...activeFilters.filter((item) => item.field !== field),
            {
              field,
              label: getFilterChipLabel(field),
              displayValue: getFilterChipValue(value),
              matchMode,
              value,
            },
          ];
          setActiveFilters(nextActiveFilters);

          if (field === 'stateList') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = { name: 'SearchByStateInfo', val: getStateCode(ele) };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'StateInfoSearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            }
          } else if (field === 'filingJuristiction') {
            filterChange.push({ name: 'SearchByJuristiction', val: value });
          } else if (field === 'filingRequired') {
            filterChange.push({ name: 'SearchByRequired', val: value });
          } else if (field === 'awardTypeName') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = { name: 'SearchByAwardType', val: ele };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'AwardTypeSearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            }
          } else if (field === 'awardingAgencyName') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = { name: 'SearchByAwardAgency', val: ele };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'AwardAgencySearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            }
          } else if (field === 'federalCategories') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = { name: 'SearchByWhoMustFileFederal', val: ele };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'WhoMustFileFederalSearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            }
          } else if (field === 'stateCategories') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = { name: 'SearchByWhoMustFileInState', val: ele };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'WhoMustFileInStateSearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            }
          } else if (field === 'status') {
            if (Array.isArray(value)) {
              value.forEach((ele, i) => {
                let changeItem = { name: 'SearchByStatus', val: ele };
                if (i + 1 === value.length) {
                  changeItem.searchType = 'StatusSearchType';
                  changeItem.searchTypeVal = getSearchType(matchMode);
                }
                filterChange.push(changeItem);
              });
            }
          } else if (field === 'dueDateFiling') {
            filterChange.push({
              name: 'SearchByFilingDueDate',
              val: value,
              searchType: 'FilingDueDateSearchType',
              searchTypeVal: getSearchType(matchMode),
            });
          } else {
            const fieldName = field.charAt(0).toUpperCase() + field.slice(1);
            filterChange.push({
              name: `SearchBy${fieldName}`,
              val: value,
              searchType: `${fieldName}SearchType`,
              searchTypeVal: getSearchType(matchMode),
            });
          }

          const allFilterChanges = buildTrackerApiFilters(nextActiveFilters);
          console.log('Filter parameters:', allFilterChanges);
          handleSetFilterVariable(allFilterChanges);
        }}
        onClear={() => {
          clearTrackerFilters();
        }}
        clients={clientFiling}
        categoriesLookup={[...new Set([...federalCategoriesLookup, ...categoryList])]}
        programList={[]}
        stateList={stateList}
        tracknowlicenseTypes={[]}
        postawardlicenseTypes={[]}
        roleType={""}
        trackerMode={true}
        requiredOnlyIs={true}
        statusLookup={['Pending', 'In Progress', 'Approved', 'Completed']}
        jurisdictionLookup={['Federal', 'State', 'Both']}
        awardAgenciesList={awardAgenciesList}
        awardTypeList={awardTypeList}
      />
    </Fragment>
  );
});

export default ClientFilingTrackerTable;